// //////////////// isolate ////////////////
// // ============================================================
// // src/pages/VidyaOne.js
// // Vidya One Homepage — shows all hospitals as cards
// // PearlSmile appears as first card by default (static)
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";

// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// // ✅ PearlSmile default static card — always shows first
// const PEARLSMILE_CARD = {
//   _id: "pearlsmile-static",
//   name: "PearlSmile Dental Hospital",
//   type: "dental",
//   city: "Pune, Maharashtra",
//   slug: "pearlsmile",
//   statPatients: "18K+",
//   statDoctors: "20+",
//   statRating: "4.9★",
//   logoUrl: "",
// };

// const CATEGORIES = [
//   { id: "all", label: "All", icon: "🏥" },
//   { id: "dental", label: "Dental", icon: "🦷" },
//   { id: "ortho", label: "Ortho", icon: "🦴" },
//   { id: "ayurved", label: "Ayurved", icon: "🌿" },
//   { id: "cardiology", label: "Cardiology", icon: "❤️" },
//   { id: "eye", label: "Eye", icon: "👁️" },
//   { id: "pediatric", label: "Pediatric", icon: "👶" },
//   { id: "general", label: "General", icon: "➕" },
// ];

// const CAT_GRADIENTS = {
//   dental: "linear-gradient(135deg,#0d7377,#14a0a5)",
//   ortho: "linear-gradient(135deg,#1a3a6b,#2563eb)",
//   ayurved: "linear-gradient(135deg,#166534,#16a34a)",
//   cardiology: "linear-gradient(135deg,#881337,#dc2626)",
//   eye: "linear-gradient(135deg,#4338ca,#7c3aed)",
//   pediatric: "linear-gradient(135deg,#c2410c,#f97316)",
//   general: "linear-gradient(135deg,#0f766e,#0d9488)",
// };

// const CAT_ICONS = {
//   dental: "🦷",
//   ortho: "🦴",
//   ayurved: "🌿",
//   cardiology: "❤️",
//   eye: "👁️",
//   pediatric: "👶",
//   general: "➕",
// };

// // ── Register Modal ────────────────────────────────────────────
// const TYPES = [
//   "Dental",
//   "Ortho",
//   "Ayurved",
//   "Cardiology",
//   "Eye",
//   "Pediatric",
//   "General",
// ];
// const PLANS = [
//   { id: "starter", label: "Starter — ₹999/mo" },
//   { id: "pro", label: "Pro — ₹1,999/mo" },
//   { id: "enterprise", label: "Enterprise — ₹3,499/mo" },
// ];

// function RegisterModal({ onClose }) {
//   const [step, setStep] = useState(1);
//   const [saving, setSaving] = useState(false);
//   const [msg, setMsg] = useState("");
//   const [form, setForm] = useState({
//     name: "",
//     type: "",
//     phone: "",
//     whatsapp: "",
//     email: "",
//     address: "",
//     city: "",
//     established: "",
//     plan: "pro",
//     adminId: "",
//     password: "",
//   });
//   const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

//   const inp = {
//     width: "100%",
//     padding: "10px 14px",
//     borderRadius: 8,
//     border: "1.5px solid #e2e8f0",
//     fontSize: 14,
//     fontFamily: "DM Sans,sans-serif",
//     outline: "none",
//     background: "#f8fafc",
//     boxSizing: "border-box",
//     marginTop: 4,
//     marginBottom: 12,
//   };
//   const lbl = {
//     fontSize: 12,
//     fontWeight: 600,
//     color: "#475569",
//     display: "block",
//   };

//   const next = () => {
//     if (!form.name || !form.type || !form.phone || !form.city) {
//       setMsg("Please fill all required fields.");
//       return;
//     }
//     setMsg("");
//     setStep(2);
//   };

//   const submit = async () => {
//     if (!form.adminId || !form.password) {
//       setMsg("Admin ID and password are required.");
//       return;
//     }
//     setSaving(true);
//     setMsg("");
//     try {
//       const slug = form.name
//         .toLowerCase()
//         .replace(/[^a-z0-9]+/g, "-")
//         .replace(/^-|-$/g, "");
//       const res = await fetch(`${API_URL}/hospitals/register`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ ...form, slug }),
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message || "Registration failed");
//       setStep(3);
//     } catch (err) {
//       setMsg(err.message);
//     }
//     setSaving(false);
//   };

//   return (
//     <div
//       style={{
//         position: "fixed",
//         inset: 0,
//         background: "rgba(0,0,0,0.6)",
//         backdropFilter: "blur(4px)",
//         zIndex: 2000,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: 20,
//       }}
//       onClick={(e) => {
//         if (e.target === e.currentTarget) onClose();
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 24,
//           width: "100%",
//           maxWidth: 520,
//           maxHeight: "90vh",
//           overflowY: "auto",
//           boxShadow: "0 24px 80px rgba(0,0,0,0.4)",
//         }}
//       >
//         {/* Header */}
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             padding: "22px 28px",
//             borderRadius: "24px 24px 0 0",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div>
//             <div style={{ fontSize: 17, fontWeight: 700, color: "#fff" }}>
//               {step === 3
//                 ? "🎉 Registration Successful!"
//                 : "🏥 Register Your Hospital"}
//             </div>
//             <div
//               style={{
//                 fontSize: 12,
//                 color: "rgba(255,255,255,0.55)",
//                 marginTop: 3,
//               }}
//             >
//               {step === 1 && "Step 1 of 2 — Hospital Details"}
//               {step === 2 && "Step 2 of 2 — Admin Credentials"}
//               {step === 3 && "Your hospital is now live on VidyaOne!"}
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.12)",
//               border: "none",
//               color: "#fff",
//               width: 32,
//               height: 32,
//               borderRadius: "50%",
//               fontSize: 16,
//               cursor: "pointer",
//             }}
//           >
//             ✕
//           </button>
//         </div>

//         <div style={{ padding: 28 }}>
//           {msg && (
//             <div
//               style={{
//                 background: "#fef2f2",
//                 border: "1px solid #fecaca",
//                 borderRadius: 8,
//                 padding: "10px 14px",
//                 marginBottom: 16,
//                 fontSize: 13,
//                 color: "#dc2626",
//               }}
//             >
//               {msg}
//             </div>
//           )}

//           {/* Step 1 */}
//           {step === 1 && (
//             <>
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "1fr 1fr",
//                   gap: "0 14px",
//                 }}
//               >
//                 <div>
//                   <label style={lbl}>Hospital Name *</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. Sai Dental Hospital"
//                     value={form.name}
//                     onChange={(e) => set("name", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Hospital Type *</label>
//                   <select
//                     style={inp}
//                     value={form.type}
//                     onChange={(e) => set("type", e.target.value)}
//                   >
//                     <option value="">Select type</option>
//                     {TYPES.map((t) => (
//                       <option key={t} value={t.toLowerCase()}>
//                         {t}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 <div>
//                   <label style={lbl}>Phone *</label>
//                   <input
//                     style={inp}
//                     placeholder="+91 98765 43210"
//                     value={form.phone}
//                     onChange={(e) => set("phone", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>WhatsApp (no +)</label>
//                   <input
//                     style={inp}
//                     placeholder="919876543210"
//                     value={form.whatsapp}
//                     onChange={(e) => set("whatsapp", e.target.value)}
//                   />
//                 </div>
//                 <div style={{ gridColumn: "1/-1" }}>
//                   <label style={lbl}>Email</label>
//                   <input
//                     style={inp}
//                     type="email"
//                     placeholder="info@hospital.com"
//                     value={form.email}
//                     onChange={(e) => set("email", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Address</label>
//                   <input
//                     style={inp}
//                     placeholder="Street, Area"
//                     value={form.address}
//                     onChange={(e) => set("address", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>City *</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. Mumbai, MH"
//                     value={form.city}
//                     onChange={(e) => set("city", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Established Year</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. 2010"
//                     value={form.established}
//                     onChange={(e) => set("established", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Plan</label>
//                   <select
//                     style={inp}
//                     value={form.plan}
//                     onChange={(e) => set("plan", e.target.value)}
//                   >
//                     {PLANS.map((p) => (
//                       <option key={p.id} value={p.id}>
//                         {p.label}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//               <button
//                 onClick={next}
//                 style={{
//                   width: "100%",
//                   padding: 13,
//                   background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 10,
//                   fontSize: 15,
//                   fontWeight: 700,
//                   cursor: "pointer",
//                 }}
//               >
//                 Next: Create Admin Account →
//               </button>
//             </>
//           )}

//           {/* Step 2 */}
//           {step === 2 && (
//             <>
//               <div
//                 style={{
//                   background: "#f0fdf4",
//                   border: "1px solid #bbf7d0",
//                   borderRadius: 10,
//                   padding: "12px 16px",
//                   marginBottom: 20,
//                   fontSize: 13,
//                   color: "#166534",
//                 }}
//               >
//                 ✅ <strong>{form.name}</strong> · {form.city}
//               </div>
//               <label style={lbl}>Admin ID *</label>
//               <input
//                 style={inp}
//                 placeholder="e.g. saidental_admin"
//                 value={form.adminId}
//                 onChange={(e) => set("adminId", e.target.value)}
//               />
//               <label style={lbl}>Password *</label>
//               <input
//                 style={inp}
//                 type="password"
//                 placeholder="Create a strong password"
//                 value={form.password}
//                 onChange={(e) => set("password", e.target.value)}
//               />
//               <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 16 }}>
//                 💡 Save these credentials — you'll use them to login to your
//                 admin panel.
//               </div>
//               <div style={{ display: "flex", gap: 10 }}>
//                 <button
//                   onClick={() => setStep(1)}
//                   style={{
//                     flex: 1,
//                     padding: 13,
//                     background: "#f1f5f9",
//                     color: "#475569",
//                     border: "none",
//                     borderRadius: 10,
//                     fontSize: 14,
//                     fontWeight: 600,
//                     cursor: "pointer",
//                   }}
//                 >
//                   ← Back
//                 </button>
//                 <button
//                   onClick={submit}
//                   disabled={saving}
//                   style={{
//                     flex: 2,
//                     padding: 13,
//                     background: saving
//                       ? "#94a3b8"
//                       : "linear-gradient(135deg,#0d7377,#14a0a5)",
//                     color: "#fff",
//                     border: "none",
//                     borderRadius: 10,
//                     fontSize: 15,
//                     fontWeight: 700,
//                     cursor: saving ? "not-allowed" : "pointer",
//                   }}
//                 >
//                   {saving ? "Registering..." : "🚀 Complete Registration"}
//                 </button>
//               </div>
//             </>
//           )}

//           {/* Step 3 — Success */}
//           {step === 3 && (
//             <div style={{ textAlign: "center", padding: "20px 0" }}>
//               <div style={{ fontSize: 64, marginBottom: 16 }}>🎉</div>
//               <h3
//                 style={{
//                   fontSize: 22,
//                   fontWeight: 700,
//                   color: "#0a1628",
//                   marginBottom: 8,
//                 }}
//               >
//                 {form.name}
//               </h3>
//               <p
//                 style={{
//                   fontSize: 14,
//                   color: "#64748b",
//                   marginBottom: 24,
//                   lineHeight: 1.6,
//                 }}
//               >
//                 Your hospital is now live on VidyaOne! Use your credentials to
//                 login.
//               </p>
//               <div
//                 style={{
//                   background: "#f0fdf4",
//                   border: "1px solid #bbf7d0",
//                   borderRadius: 12,
//                   padding: "16px 20px",
//                   marginBottom: 24,
//                   textAlign: "left",
//                 }}
//               >
//                 <div
//                   style={{
//                     fontSize: 12,
//                     fontWeight: 700,
//                     color: "#16a34a",
//                     marginBottom: 8,
//                   }}
//                 >
//                   YOUR LOGIN CREDENTIALS
//                 </div>
//                 <div style={{ fontSize: 14, color: "#166534" }}>
//                   Admin ID: <strong>{form.adminId}</strong>
//                 </div>
//                 <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>
//                   (Save your password securely)
//                 </div>
//               </div>
//               <button
//                 onClick={onClose}
//                 style={{
//                   width: "100%",
//                   padding: 13,
//                   background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 10,
//                   fontSize: 15,
//                   fontWeight: 700,
//                   cursor: "pointer",
//                 }}
//               >
//                 Done ✓
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Main VidyaOne Page ────────────────────────────────────────
// export default function VidyaOne() {
//   const navigate = useNavigate();
//   const [hospitals, setHospitals] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState("");
//   const [activeCat, setActiveCat] = useState("all");
//   const [regOpen, setRegOpen] = useState(false);

//   const fetchHospitals = useCallback(async () => {
//     setLoading(true);
//     try {
//       const r = await fetch(`${API_URL}/hospitals`);
//       if (r.ok) {
//         const data = await r.json();
//         setHospitals(Array.isArray(data) ? data : []);
//       }
//     } catch (_) {}
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     fetchHospitals();
//   }, [fetchHospitals]);

//   // ✅ Always include PearlSmile as first card
//   // Filter out duplicate if it already exists in DB
//   const allHospitals = [
//     PEARLSMILE_CARD,
//     ...hospitals.filter((h) => h.slug !== "pearlsmile"),
//   ];

//   const filtered = allHospitals.filter((h) => {
//     const matchCat =
//       activeCat === "all" || (h.type || "").toLowerCase() === activeCat;
//     const q = search.toLowerCase();
//     const matchSearch =
//       !q ||
//       (h.name || "").toLowerCase().includes(q) ||
//       (h.city || "").toLowerCase().includes(q) ||
//       (h.type || "").toLowerCase().includes(q);
//     return matchCat && matchSearch;
//   });

//   const css = `
//     * { box-sizing: border-box; margin: 0; padding: 0; }
//     body { font-family: "DM Sans", sans-serif; }
//     .vo-nav {
//       position: fixed; top:0; left:0; right:0; z-index:1000;
//       background: rgba(10,22,40,0.97); backdrop-filter: blur(12px);
//       border-bottom: 1px solid rgba(255,255,255,0.06);
//       display: flex; align-items: center; justify-content: space-between;
//       padding: 0 40px; height: 68px;
//     }
//     .vo-logo { display:flex; align-items:center; gap:10px; cursor:pointer; }
//     .vo-logo-icon {
//       width:38px; height:38px;
//       background: linear-gradient(135deg,#0d7377,#14a0a5);
//       border-radius:10px; display:flex; align-items:center;
//       justify-content:center; font-size:20px;
//     }
//     .vo-logo-text { font-family:"Cormorant Garamond",serif; font-size:22px; font-weight:700; color:#fff; }
//     .vo-logo-sub  { font-size:9px; color:#c9a845; letter-spacing:2px; text-transform:uppercase; }
//     .vo-nav-btn {
//       background: linear-gradient(135deg,#0d7377,#14a0a5);
//       color:#fff; border:none; padding:10px 22px;
//       border-radius:8px; font-weight:700; font-size:13px;
//       font-family:"DM Sans",sans-serif; cursor:pointer;
//       transition: opacity 0.2s;
//     }
//     .vo-nav-btn:hover { opacity:0.9; }
//     .vo-hero {
//       min-height:100vh;
//       background: linear-gradient(135deg,#0a1628 0%,#0d2444 50%,#0a1f3a 100%);
//       display:flex; align-items:center; padding-top:68px; position:relative; overflow:hidden;
//     }
//     .vo-hero::before {
//       content:""; position:absolute; top:-200px; right:-200px;
//       width:600px; height:600px;
//       background: radial-gradient(circle,rgba(13,115,119,0.15) 0%,transparent 70%);
//       border-radius:50%;
//     }
//     .vo-hero-inner {
//       max-width:1200px; margin:0 auto; padding:80px 24px;
//       display:grid; grid-template-columns:1fr 1fr;
//       gap:60px; align-items:center; position:relative; z-index:1;
//     }
//     .vo-badge {
//       display:inline-flex; align-items:center; gap:8px;
//       background:rgba(201,168,76,0.15); border:1px solid rgba(201,168,76,0.3);
//       color:#c9a845; font-size:11px; font-weight:700;
//       letter-spacing:1px; text-transform:uppercase;
//       padding:7px 16px; border-radius:100px; margin-bottom:24px;
//     }
//     .vo-hero h1 {
//       font-family:"Cormorant Garamond",serif;
//       font-size:clamp(40px,5vw,64px); font-weight:700;
//       color:#fff; line-height:1.1; margin-bottom:20px;
//     }
//     .vo-hero h1 em { font-style:italic; color:#14a0a5; }
//     .vo-hero-desc { font-size:16px; color:rgba(255,255,255,0.7); line-height:1.7; margin-bottom:36px; max-width:480px; }
//     .vo-actions { display:flex; gap:14px; flex-wrap:wrap; }
//     .vo-btn-primary {
//       background:linear-gradient(135deg,#0d7377,#14a0a5);
//       color:#fff; border:none; padding:14px 28px;
//       border-radius:10px; font-size:15px; font-weight:700;
//       font-family:"DM Sans",sans-serif; cursor:pointer;
//       transition:opacity 0.2s,transform 0.2s;
//     }
//     .vo-btn-primary:hover { opacity:0.92; transform:translateY(-1px); }
//     .vo-btn-outline {
//       background:transparent; color:#fff;
//       border:1.5px solid rgba(255,255,255,0.3);
//       padding:14px 28px; border-radius:10px;
//       font-size:15px; font-weight:600;
//       font-family:"DM Sans",sans-serif; cursor:pointer;
//       transition:border-color 0.2s;
//     }
//     .vo-btn-outline:hover { border-color:rgba(255,255,255,0.6); }
//     .vo-stats { display:flex; gap:32px; margin-top:40px; }
//     .vo-stat-num { font-family:"Cormorant Garamond",serif; font-size:28px; font-weight:700; color:#14a0a5; }
//     .vo-stat-lbl { font-size:12px; color:rgba(255,255,255,0.5); margin-top:2px; }
//     .vo-float-cards { display:flex; flex-direction:column; gap:14px; }
//     .vo-float-card {
//       background:rgba(255,255,255,0.06); border:1px solid rgba(255,255,255,0.1);
//       backdrop-filter:blur(12px); border-radius:16px; padding:18px 22px;
//       display:flex; align-items:center; gap:14px; transition:transform 0.3s;
//     }
//     .vo-float-card:hover { transform:translateX(6px); }
//     .vo-float-icon { width:46px; height:46px; border-radius:12px; display:flex; align-items:center; justify-content:center; font-size:22px; flex-shrink:0; }
//     .vo-float-title { font-size:14px; font-weight:700; color:#fff; margin-bottom:3px; }
//     .vo-float-desc  { font-size:12px; color:rgba(255,255,255,0.55); }
//     .vo-hospitals { padding:100px 0; background:#f8fafc; }
//     .vo-container { max-width:1200px; margin:0 auto; padding:0 24px; }
//     .vo-section-tag {
//       display:inline-flex; align-items:center; gap:6px;
//       background:rgba(13,115,119,0.1); border:1px solid rgba(13,115,119,0.25);
//       color:#0d7377; font-size:11px; font-weight:700;
//       letter-spacing:1.2px; text-transform:uppercase;
//       padding:6px 14px; border-radius:100px; margin-bottom:16px;
//     }
//     .vo-section-title {
//       font-family:"Cormorant Garamond",serif;
//       font-size:clamp(32px,4vw,52px); font-weight:700;
//       color:#0a1628; line-height:1.15; margin-bottom:16px;
//     }
//     .vo-section-title em { font-style:italic; color:#0d7377; }
//     .vo-controls { display:flex; gap:16px; margin-bottom:32px; flex-wrap:wrap; align-items:center; }
//     .vo-search {
//       flex:1; min-width:260px; padding:12px 18px;
//       border-radius:10px; border:1.5px solid #e2e8f0;
//       font-size:14px; font-family:"DM Sans",sans-serif;
//       outline:none; background:#fff; transition:border-color 0.2s;
//     }
//     .vo-search:focus { border-color:#0d7377; }
//     .vo-cats { display:flex; gap:8px; flex-wrap:wrap; }
//     .vo-cat {
//       padding:8px 14px; border-radius:100px;
//       border:1.5px solid #e2e8f0; background:#fff;
//       font-size:13px; font-weight:600; color:#475569;
//       cursor:pointer; transition:all 0.2s; white-space:nowrap;
//       font-family:"DM Sans",sans-serif;
//     }
//     .vo-cat:hover { border-color:#0d7377; color:#0d7377; }
//     .vo-cat.active { background:#0d7377; border-color:#0d7377; color:#fff; }
//     .vo-grid {
//       display:grid; grid-template-columns:repeat(auto-fill,minmax(300px,1fr));
//       gap:28px;
//     }
//     .vo-card {
//       background:#fff; border-radius:20px; overflow:hidden;
//       box-shadow:0 4px 32px rgba(0,0,0,0.08);
//       transition:transform 0.28s,box-shadow 0.28s;
//       cursor:pointer; border:1px solid #f1f5f9;
//     }
//     .vo-card:hover { transform:translateY(-6px); box-shadow:0 12px 48px rgba(0,0,0,0.14); }
//     .vo-card-top {
//       height:140px; display:flex; align-items:center;
//       justify-content:center; position:relative; font-size:52px;
//     }
//     .vo-card-badge {
//       position:absolute; top:14px; right:14px;
//       background:rgba(255,255,255,0.2); backdrop-filter:blur(8px);
//       border:1px solid rgba(255,255,255,0.3); border-radius:20px;
//       padding:4px 12px; font-size:11px; font-weight:700; color:#fff;
//     }
//     .vo-card-body { padding:20px 22px 22px; }
//     .vo-card-name { font-family:"Cormorant Garamond",serif; font-size:20px; font-weight:700; color:#0a1628; margin-bottom:4px; }
//     .vo-card-type { font-size:12px; font-weight:700; color:#0d7377; text-transform:uppercase; letter-spacing:0.5px; margin-bottom:8px; }
//     .vo-card-city { font-size:13px; color:#94a3b8; margin-bottom:14px; }
//     .vo-card-stats { display:flex; gap:16px; padding:12px 0; border-top:1px solid #f1f5f9; border-bottom:1px solid #f1f5f9; margin-bottom:14px; }
//     .vo-card-stat { text-align:center; flex:1; }
//     .vo-card-stat-num { font-size:15px; font-weight:700; color:#0a1628; }
//     .vo-card-stat-lbl { font-size:10px; color:#94a3b8; margin-top:2px; }
//     .vo-card-btn {
//       width:100%; padding:11px;
//       background:linear-gradient(135deg,#0d7377,#14a0a5);
//       color:#fff; border:none; border-radius:10px;
//       font-size:13px; font-weight:700; cursor:pointer;
//       font-family:"DM Sans",sans-serif; transition:opacity 0.2s;
//     }
//     .vo-card-btn:hover { opacity:0.9; }
//     .vo-empty { grid-column:1/-1; text-align:center; padding:60px 0; color:#94a3b8; font-size:15px; }
//     @keyframes vopulse { 0%,100%{opacity:1}50%{opacity:0.45} }
//     .vo-skel { background:#e2e8f0; border-radius:8px; animation:vopulse 1.5s ease-in-out infinite; }
//     .vo-cta { padding:100px 0; background:linear-gradient(135deg,#0a1628,#0d2444); text-align:center; }
//     .vo-cta-title { font-family:"Cormorant Garamond",serif; font-size:clamp(32px,4vw,52px); font-weight:700; color:#fff; margin-bottom:16px; }
//     .vo-cta-title em { font-style:italic; color:#14a0a5; }
//     .vo-cta-desc { font-size:16px; color:rgba(255,255,255,0.65); max-width:520px; margin:0 auto 40px; line-height:1.7; }
//     .vo-plans { display:flex; gap:20px; justify-content:center; flex-wrap:wrap; margin-bottom:36px; }
//     .vo-plan {
//       background:rgba(255,255,255,0.08); border:1px solid rgba(255,255,255,0.15);
//       border-radius:16px; padding:22px 26px; min-width:180px; transition:background 0.2s;
//     }
//     .vo-plan:hover { background:rgba(255,255,255,0.12); }
//     .vo-plan.featured { background:linear-gradient(135deg,#0d7377,#14a0a5); border-color:transparent; }
//     .vo-plan-name { font-size:12px; font-weight:700; color:rgba(255,255,255,0.65); text-transform:uppercase; letter-spacing:1px; margin-bottom:8px; }
//     .vo-plan-price { font-family:"Cormorant Garamond",serif; font-size:30px; font-weight:700; color:#fff; line-height:1; margin-bottom:4px; }
//     .vo-plan-period { font-size:12px; color:rgba(255,255,255,0.5); margin-bottom:10px; }
//     .vo-plan-features { font-size:12px; color:rgba(255,255,255,0.6); line-height:1.6; }
//     .vo-how { padding:100px 0; background:#fff; }
//     .vo-how-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:28px; margin-top:56px; }
//     .vo-how-card {
//       text-align:center; padding:28px 20px;
//       border-radius:20px; background:#f8fafc; border:1px solid #f1f5f9;
//       transition:transform 0.25s,box-shadow 0.25s;
//     }
//     .vo-how-card:hover { transform:translateY(-4px); box-shadow:0 4px 24px rgba(0,0,0,0.08); }
//     .vo-how-step {
//       width:46px; height:46px; border-radius:50%;
//       background:linear-gradient(135deg,#0d7377,#14a0a5);
//       color:#fff; font-size:18px; font-weight:800;
//       display:flex; align-items:center; justify-content:center;
//       margin:0 auto 14px;
//     }
//     .vo-how-icon { font-size:30px; margin-bottom:12px; }
//     .vo-how-title { font-size:15px; font-weight:700; color:#0a1628; margin-bottom:8px; }
//     .vo-how-desc  { font-size:13px; color:#475569; line-height:1.6; }
//     .vo-footer { background:#0a1628; padding:56px 0 24px; border-top:1px solid rgba(255,255,255,0.06); }
//     .vo-footer-inner { max-width:1200px; margin:0 auto; padding:0 24px 40px; display:grid; grid-template-columns:2fr 1fr 1fr; gap:48px; }
//     .vo-footer-desc { font-size:14px; color:rgba(255,255,255,0.5); line-height:1.7; margin-top:10px; max-width:280px; }
//     .vo-footer-col h4 { font-size:12px; font-weight:700; color:rgba(255,255,255,0.85); text-transform:uppercase; letter-spacing:1px; margin-bottom:14px; }
//     .vo-footer-col ul { list-style:none; }
//     .vo-footer-col ul li { margin-bottom:8px; }
//     .vo-footer-col ul li a { font-size:13px; color:rgba(255,255,255,0.5); cursor:pointer; transition:color 0.2s; }
//     .vo-footer-col ul li a:hover { color:rgba(255,255,255,0.85); }
//     .vo-footer-bottom { max-width:1200px; margin:0 auto; padding:20px 24px 0; border-top:1px solid rgba(255,255,255,0.07); display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:12px; font-size:13px; color:rgba(255,255,255,0.35); }
//     @media(max-width:860px) {
//       .vo-hero-inner { grid-template-columns:1fr; }
//       .vo-float-cards { display:none; }
//       .vo-how-grid { grid-template-columns:repeat(2,1fr); }
//       .vo-footer-inner { grid-template-columns:1fr; gap:28px; }
//       .vo-nav { padding:0 20px; }
//     }
//     @media(max-width:600px) {
//       .vo-grid { grid-template-columns:1fr; }
//       .vo-how-grid { grid-template-columns:1fr; }
//       .vo-stats { gap:20px; }
//       .vo-plans { flex-direction:column; align-items:center; }
//     }
//   `;

//   const scrollTo = (id) =>
//     document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

//   return (
//     <div style={{ fontFamily: "DM Sans,sans-serif" }}>
//       <style>{css}</style>

//       {/* ── Navbar ── */}
//       <div className="vo-nav">
//         <div className="vo-logo">
//           <div className="vo-logo-icon">🏥</div>
//           <div>
//             <div className="vo-logo-text">VidyaOne</div>
//             <div className="vo-logo-sub">Healthcare Platform</div>
//           </div>
//         </div>
//         <div style={{ display: "flex", gap: 20, alignItems: "center" }}>
//           <a
//             onClick={() => scrollTo("hospitals")}
//             style={{
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 14,
//               fontWeight: 500,
//               cursor: "pointer",
//             }}
//           >
//             Hospitals
//           </a>
//           <a
//             onClick={() => scrollTo("how")}
//             style={{
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 14,
//               fontWeight: 500,
//               cursor: "pointer",
//             }}
//           >
//             How It Works
//           </a>
//           <button className="vo-nav-btn" onClick={() => setRegOpen(true)}>
//             Register Hospital
//           </button>
//         </div>
//       </div>

//       {/* ── Hero ── */}
//       <section className="vo-hero" id="home">
//         <div className="vo-hero-inner">
//           <div>
//             <div className="vo-badge">
//               🌟 India's Healthcare Management Platform
//             </div>
//             <h1>
//               Find & Book
//               <br />
//               <em>Top Hospitals</em>
//               <br />
//               Near You
//             </h1>
//             <p className="vo-hero-desc">
//               From Dental to Ortho, Ayurved to Cardiology — discover verified
//               hospitals, book appointments instantly, and manage your health all
//               in one place.
//             </p>
//             <div className="vo-actions">
//               <button
//                 className="vo-btn-primary"
//                 onClick={() => scrollTo("hospitals")}
//               >
//                 Find Hospitals →
//               </button>
//               <button
//                 className="vo-btn-outline"
//                 onClick={() => setRegOpen(true)}
//               >
//                 Register Your Hospital
//               </button>
//             </div>
//             <div className="vo-stats">
//               {[
//                 ["200+", "Hospitals"],
//                 ["50K+", "Patients"],
//                 ["7", "Specialities"],
//               ].map(([n, l]) => (
//                 <div key={l}>
//                   <div className="vo-stat-num">{n}</div>
//                   <div className="vo-stat-lbl">{l}</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//           <div className="vo-float-cards">
//             {[
//               {
//                 icon: "🦷",
//                 bg: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                 title: "Dental Care",
//                 desc: "Root canal, implants, whitening",
//               },
//               {
//                 icon: "🦴",
//                 bg: "linear-gradient(135deg,#1a3a6b,#2563eb)",
//                 title: "Ortho Care",
//                 desc: "Joint replacement, physiotherapy",
//               },
//               {
//                 icon: "🌿",
//                 bg: "linear-gradient(135deg,#166534,#16a34a)",
//                 title: "Ayurved",
//                 desc: "Panchakarma, herbal treatments",
//               },
//               {
//                 icon: "❤️",
//                 bg: "linear-gradient(135deg,#881337,#dc2626)",
//                 title: "Cardiology",
//                 desc: "Heart care, ECG, consultations",
//               },
//             ].map((c) => (
//               <div key={c.title} className="vo-float-card">
//                 <div className="vo-float-icon" style={{ background: c.bg }}>
//                   {c.icon}
//                 </div>
//                 <div>
//                   <div className="vo-float-title">{c.title}</div>
//                   <div className="vo-float-desc">{c.desc}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ── Hospital Grid ── */}
//       <section className="vo-hospitals" id="hospitals">
//         <div className="vo-container">
//           <div style={{ textAlign: "center", marginBottom: 48 }}>
//             <div className="vo-section-tag">🏥 Browse Hospitals</div>
//             <h2 className="vo-section-title">
//               Find the Right
//               <br />
//               <em>Hospital for You</em>
//             </h2>
//             <p
//               style={{
//                 fontSize: 16,
//                 color: "#475569",
//                 maxWidth: 540,
//                 margin: "0 auto",
//                 lineHeight: 1.7,
//               }}
//             >
//               Browse verified hospitals by speciality or city.
//             </p>
//           </div>

//           <div className="vo-controls">
//             <input
//               className="vo-search"
//               placeholder="🔍 Search by hospital name or city..."
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//             />
//             <div className="vo-cats">
//               {CATEGORIES.map((c) => (
//                 <button
//                   key={c.id}
//                   className={`vo-cat${activeCat === c.id ? " active" : ""}`}
//                   onClick={() => setActiveCat(c.id)}
//                 >
//                   {c.icon} {c.label}
//                 </button>
//               ))}
//             </div>
//           </div>

//           <div style={{ fontSize: 13, color: "#94a3b8", marginBottom: 24 }}>
//             {loading
//               ? "Loading hospitals..."
//               : `${filtered.length} hospital${filtered.length !== 1 ? "s" : ""} found`}
//           </div>

//           <div className="vo-grid">
//             {loading ? (
//               [1, 2, 3, 4, 5, 6].map((i) => (
//                 <div
//                   key={i}
//                   style={{
//                     background: "#fff",
//                     borderRadius: 20,
//                     overflow: "hidden",
//                     boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
//                   }}
//                 >
//                   <div className="vo-skel" style={{ height: 140 }} />
//                   <div style={{ padding: "20px 22px" }}>
//                     <div
//                       className="vo-skel"
//                       style={{ height: 20, width: "70%", marginBottom: 8 }}
//                     />
//                     <div
//                       className="vo-skel"
//                       style={{ height: 13, width: "40%", marginBottom: 14 }}
//                     />
//                     <div
//                       className="vo-skel"
//                       style={{ height: 38, borderRadius: 10 }}
//                     />
//                   </div>
//                 </div>
//               ))
//             ) : filtered.length === 0 ? (
//               <div className="vo-empty">No hospitals match your search.</div>
//             ) : (
//               filtered.map((h) => {
//                 const type = (h.type || "general").toLowerCase();
//                 const grad = CAT_GRADIENTS[type] || CAT_GRADIENTS.general;
//                 const cat = CATEGORIES.find((c) => c.id === type);
//                 return (
//                   <div
//                     key={h._id}
//                     className="vo-card"
//                     onClick={() => navigate(`/hospital/${h.slug}`)}
//                   >
//                     <div className="vo-card-top" style={{ background: grad }}>
//                       <div className="vo-card-badge">
//                         {cat?.label || "Hospital"}
//                       </div>
//                       {h.logoUrl ? (
//                         <img
//                           src={h.logoUrl}
//                           alt={h.name}
//                           style={{
//                             width: 70,
//                             height: 70,
//                             borderRadius: "50%",
//                             objectFit: "cover",
//                             border: "3px solid rgba(255,255,255,0.3)",
//                           }}
//                         />
//                       ) : (
//                         <span>{CAT_ICONS[type] || "🏥"}</span>
//                       )}
//                     </div>
//                     <div className="vo-card-body">
//                       <div className="vo-card-name">{h.name}</div>
//                       <div className="vo-card-type">
//                         {cat?.icon} {cat?.label || "Hospital"}
//                       </div>
//                       <div className="vo-card-city">
//                         📍 {h.city || "Location not specified"}
//                       </div>
//                       <div className="vo-card-stats">
//                         {[
//                           ["Patients", h.statPatients],
//                           ["Doctors", h.statDoctors],
//                           ["Rating", h.statRating],
//                         ].map(([l, v]) => (
//                           <div key={l} className="vo-card-stat">
//                             <div className="vo-card-stat-num">{v || "—"}</div>
//                             <div className="vo-card-stat-lbl">{l}</div>
//                           </div>
//                         ))}
//                       </div>
//                       <button className="vo-card-btn">
//                         Book Appointment →
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>
//       </section>

//       {/* ── How It Works ── */}
//       <section className="vo-how" id="how">
//         <div className="vo-container">
//           <div style={{ textAlign: "center" }}>
//             <div className="vo-section-tag">Simple Process</div>
//             <h2 className="vo-section-title">
//               How <em>VidyaOne</em> Works
//             </h2>
//             <p
//               style={{
//                 fontSize: 16,
//                 color: "#475569",
//                 maxWidth: 520,
//                 margin: "0 auto",
//                 lineHeight: 1.7,
//               }}
//             >
//               Get your hospital live in under 10 minutes. No technical knowledge
//               required.
//             </p>
//           </div>
//           <div className="vo-how-grid">
//             {[
//               {
//                 step: "1",
//                 icon: "🏥",
//                 title: "Register Hospital",
//                 desc: "Fill your hospital details, choose a plan and pay securely.",
//               },
//               {
//                 step: "2",
//                 icon: "⚙️",
//                 title: "Setup Your Panel",
//                 desc: "Add your doctors, services and pricing inside your admin dashboard.",
//               },
//               {
//                 step: "3",
//                 icon: "📅",
//                 title: "Patients Book",
//                 desc: "Patients find your hospital on VidyaOne and book appointments online.",
//               },
//               {
//                 step: "4",
//                 icon: "📊",
//                 title: "Manage Everything",
//                 desc: "Track appointments, patients, billing and doctor availability in one panel.",
//               },
//             ].map((s) => (
//               <div key={s.step} className="vo-how-card">
//                 <div className="vo-how-step">{s.step}</div>
//                 <div className="vo-how-icon">{s.icon}</div>
//                 <div className="vo-how-title">{s.title}</div>
//                 <div className="vo-how-desc">{s.desc}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ── CTA ── */}
//       <section className="vo-cta" id="pricing">
//         <div className="vo-container">
//           <div
//             className="vo-section-tag"
//             style={{
//               background: "rgba(201,168,76,0.15)",
//               borderColor: "rgba(201,168,76,0.3)",
//               color: "#c9a845",
//             }}
//           >
//             💰 Simple Pricing
//           </div>
//           <h2 className="vo-cta-title">
//             Register Your Hospital
//             <br />
//             <em>Start Today</em>
//           </h2>
//           <p className="vo-cta-desc">
//             Choose a plan that fits your hospital. All plans include full admin
//             panel, patient management & WhatsApp integration.
//           </p>
//           <div className="vo-plans">
//             {[
//               {
//                 name: "Starter",
//                 price: "₹999",
//                 period: "/month",
//                 features: "3 Doctors · Appointments · Patients",
//               },
//               {
//                 name: "Pro",
//                 price: "₹1,999",
//                 period: "/month",
//                 features: "10 Doctors · Billing · WhatsApp",
//                 featured: true,
//               },
//               {
//                 name: "Enterprise",
//                 price: "₹3,499",
//                 period: "/month",
//                 features: "Unlimited · Priority Support · Custom Domain",
//               },
//             ].map((p) => (
//               <div
//                 key={p.name}
//                 className={`vo-plan${p.featured ? " featured" : ""}`}
//               >
//                 <div className="vo-plan-name">{p.name}</div>
//                 <div className="vo-plan-price">{p.price}</div>
//                 <div className="vo-plan-period">{p.period}</div>
//                 <div className="vo-plan-features">{p.features}</div>
//               </div>
//             ))}
//           </div>
//           <button
//             className="vo-btn-primary"
//             style={{ fontSize: 16, padding: "15px 36px" }}
//             onClick={() => setRegOpen(true)}
//           >
//             Register Your Hospital Now →
//           </button>
//           <div
//             style={{
//               fontSize: 12,
//               color: "rgba(255,255,255,0.4)",
//               marginTop: 14,
//             }}
//           >
//             14-day free trial · No credit card required to start
//           </div>
//         </div>
//       </section>

//       {/* ── Footer ── */}
//       <footer className="vo-footer">
//         <div className="vo-footer-inner">
//           <div>
//             <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//               <div
//                 style={{
//                   width: 36,
//                   height: 36,
//                   background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   borderRadius: 10,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   fontSize: 18,
//                 }}
//               >
//                 🏥
//               </div>
//               <div>
//                 <div
//                   style={{
//                     fontFamily: "Cormorant Garamond,serif",
//                     fontSize: 20,
//                     fontWeight: 700,
//                     color: "#fff",
//                   }}
//                 >
//                   VidyaOne
//                 </div>
//                 <div
//                   style={{
//                     fontSize: 9,
//                     color: "#c9a845",
//                     letterSpacing: 2,
//                     textTransform: "uppercase",
//                   }}
//                 >
//                   Healthcare Platform
//                 </div>
//               </div>
//             </div>
//             <p className="vo-footer-desc">
//               India's premier hospital management platform. Connecting patients
//               with the best hospitals.
//             </p>
//           </div>
//           <div className="vo-footer-col">
//             <h4>For Hospitals</h4>
//             <ul>
//               {[
//                 "Register Hospital",
//                 "Pricing Plans",
//                 "How It Works",
//                 "Admin Login",
//               ].map((s) => (
//                 <li key={s}>
//                   <a>{s}</a>
//                 </li>
//               ))}
//             </ul>
//           </div>
//           <div className="vo-footer-col">
//             <h4>Specialities</h4>
//             <ul>
//               {[
//                 "🦷 Dental",
//                 "🦴 Ortho",
//                 "🌿 Ayurved",
//                 "❤️ Cardiology",
//                 "👁️ Eye Care",
//                 "👶 Pediatric",
//               ].map((s) => (
//                 <li key={s}>
//                   <a>{s}</a>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>
//         <div className="vo-footer-bottom">
//           <p>© 2026 Vidyastack Services Pvt Ltd. All rights reserved.</p>
//           <div style={{ display: "flex", gap: 24 }}>
//             <a>Privacy Policy</a>
//             <a>Terms of Service</a>
//           </div>
//         </div>
//       </footer>

//       {/* Register Modal */}
//       {regOpen && (
//         <RegisterModal
//           onClose={() => {
//             setRegOpen(false);
//             fetchHospitals();
//           }}
//         />
//       )}
//     </div>
//   );
// }

// // ============================================================
// // src/pages/VidyaOne.js
// // ✅ Super Admin button added in navbar
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";

// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// const PEARLSMILE_CARD = {
//   _id: "pearlsmile-static",
//   name: "PearlSmile Dental Hospital",
//   type: "dental",
//   city: "Pune, Maharashtra",
//   slug: "pearlsmile",
//   statPatients: "18K+",
//   statDoctors: "20+",
//   statRating: "4.9★",
//   logoUrl: "",
// };

// const CATEGORIES = [
//   { id: "all", label: "All", icon: "🏥" },
//   { id: "dental", label: "Dental", icon: "🦷" },
//   { id: "ortho", label: "Ortho", icon: "🦴" },
//   { id: "ayurved", label: "Ayurved", icon: "🌿" },
//   { id: "cardiology", label: "Cardiology", icon: "❤️" },
//   { id: "eye", label: "Eye", icon: "👁️" },
//   { id: "pediatric", label: "Pediatric", icon: "👶" },
//   { id: "general", label: "General", icon: "➕" },
// ];

// const CAT_GRADIENTS = {
//   dental: "linear-gradient(135deg,#0d7377,#14a0a5)",
//   ortho: "linear-gradient(135deg,#1a3a6b,#2563eb)",
//   ayurved: "linear-gradient(135deg,#166534,#16a34a)",
//   cardiology: "linear-gradient(135deg,#881337,#dc2626)",
//   eye: "linear-gradient(135deg,#4338ca,#7c3aed)",
//   pediatric: "linear-gradient(135deg,#c2410c,#f97316)",
//   general: "linear-gradient(135deg,#0f766e,#0d9488)",
// };

// const CAT_ICONS = {
//   dental: "🦷",
//   ortho: "🦴",
//   ayurved: "🌿",
//   cardiology: "❤️",
//   eye: "👁️",
//   pediatric: "👶",
//   general: "➕",
// };

// const TYPES = [
//   "Dental",
//   "Ortho",
//   "Ayurved",
//   "Cardiology",
//   "Eye",
//   "Pediatric",
//   "General",
// ];
// const PLANS = [
//   { id: "starter", label: "Starter — ₹999/mo" },
//   { id: "pro", label: "Pro — ₹1,999/mo" },
//   { id: "enterprise", label: "Enterprise — ₹3,499/mo" },
// ];

// function RegisterModal({ onClose }) {
//   const [step, setStep] = useState(1);
//   const [saving, setSaving] = useState(false);
//   const [msg, setMsg] = useState("");
//   const [form, setForm] = useState({
//     name: "",
//     type: "",
//     phone: "",
//     whatsapp: "",
//     email: "",
//     address: "",
//     city: "",
//     established: "",
//     plan: "pro",
//     adminId: "",
//     password: "",
//   });
//   const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

//   const inp = {
//     width: "100%",
//     padding: "10px 14px",
//     borderRadius: 8,
//     border: "1.5px solid #e2e8f0",
//     fontSize: 14,
//     fontFamily: "DM Sans,sans-serif",
//     outline: "none",
//     background: "#f8fafc",
//     boxSizing: "border-box",
//     marginTop: 4,
//     marginBottom: 12,
//   };
//   const lbl = {
//     fontSize: 12,
//     fontWeight: 600,
//     color: "#475569",
//     display: "block",
//   };

//   const next = () => {
//     if (!form.name || !form.type || !form.phone || !form.city) {
//       setMsg("Please fill all required fields.");
//       return;
//     }
//     setMsg("");
//     setStep(2);
//   };

//   const submit = async () => {
//     if (!form.adminId || !form.password) {
//       setMsg("Admin ID and password are required.");
//       return;
//     }
//     setSaving(true);
//     setMsg("");
//     try {
//       const slug = form.name
//         .toLowerCase()
//         .replace(/[^a-z0-9]+/g, "-")
//         .replace(/^-|-$/g, "");
//       const res = await fetch(`${API_URL}/hospitals/register`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ ...form, slug }),
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message || "Registration failed");
//       setStep(3);
//     } catch (err) {
//       setMsg(err.message);
//     }
//     setSaving(false);
//   };

//   return (
//     <div
//       style={{
//         position: "fixed",
//         inset: 0,
//         background: "rgba(0,0,0,0.6)",
//         backdropFilter: "blur(4px)",
//         zIndex: 2000,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: 20,
//       }}
//       onClick={(e) => {
//         if (e.target === e.currentTarget) onClose();
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 24,
//           width: "100%",
//           maxWidth: 520,
//           maxHeight: "90vh",
//           overflowY: "auto",
//           boxShadow: "0 24px 80px rgba(0,0,0,0.4)",
//         }}
//       >
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             padding: "22px 28px",
//             borderRadius: "24px 24px 0 0",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div>
//             <div style={{ fontSize: 17, fontWeight: 700, color: "#fff" }}>
//               {step === 3
//                 ? "🎉 Registration Successful!"
//                 : "🏥 Register Your Hospital"}
//             </div>
//             <div
//               style={{
//                 fontSize: 12,
//                 color: "rgba(255,255,255,0.55)",
//                 marginTop: 3,
//               }}
//             >
//               {step === 1 && "Step 1 of 2 — Hospital Details"}
//               {step === 2 && "Step 2 of 2 — Admin Credentials"}
//               {step === 3 && "Your hospital is now live on VidyaOne!"}
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.12)",
//               border: "none",
//               color: "#fff",
//               width: 32,
//               height: 32,
//               borderRadius: "50%",
//               fontSize: 16,
//               cursor: "pointer",
//             }}
//           >
//             ✕
//           </button>
//         </div>
//         <div style={{ padding: 28 }}>
//           {msg && (
//             <div
//               style={{
//                 background: "#fef2f2",
//                 border: "1px solid #fecaca",
//                 borderRadius: 8,
//                 padding: "10px 14px",
//                 marginBottom: 16,
//                 fontSize: 13,
//                 color: "#dc2626",
//               }}
//             >
//               {msg}
//             </div>
//           )}

//           {step === 1 && (
//             <>
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "1fr 1fr",
//                   gap: "0 14px",
//                 }}
//               >
//                 <div>
//                   <label style={lbl}>Hospital Name *</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. Sai Dental Hospital"
//                     value={form.name}
//                     onChange={(e) => set("name", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Hospital Type *</label>
//                   <select
//                     style={inp}
//                     value={form.type}
//                     onChange={(e) => set("type", e.target.value)}
//                   >
//                     <option value="">Select type</option>
//                     {TYPES.map((t) => (
//                       <option key={t} value={t.toLowerCase()}>
//                         {t}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 <div>
//                   <label style={lbl}>Phone *</label>
//                   <input
//                     style={inp}
//                     placeholder="+91 98765 43210"
//                     value={form.phone}
//                     onChange={(e) => set("phone", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>WhatsApp (no +)</label>
//                   <input
//                     style={inp}
//                     placeholder="919876543210"
//                     value={form.whatsapp}
//                     onChange={(e) => set("whatsapp", e.target.value)}
//                   />
//                 </div>
//                 <div style={{ gridColumn: "1/-1" }}>
//                   <label style={lbl}>Email</label>
//                   <input
//                     style={inp}
//                     type="email"
//                     placeholder="info@hospital.com"
//                     value={form.email}
//                     onChange={(e) => set("email", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Address</label>
//                   <input
//                     style={inp}
//                     placeholder="Street, Area"
//                     value={form.address}
//                     onChange={(e) => set("address", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>City *</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. Mumbai, MH"
//                     value={form.city}
//                     onChange={(e) => set("city", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Established Year</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. 2010"
//                     value={form.established}
//                     onChange={(e) => set("established", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Plan</label>
//                   <select
//                     style={inp}
//                     value={form.plan}
//                     onChange={(e) => set("plan", e.target.value)}
//                   >
//                     {PLANS.map((p) => (
//                       <option key={p.id} value={p.id}>
//                         {p.label}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//               <button
//                 onClick={next}
//                 style={{
//                   width: "100%",
//                   padding: 13,
//                   background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 10,
//                   fontSize: 15,
//                   fontWeight: 700,
//                   cursor: "pointer",
//                 }}
//               >
//                 Next: Create Admin Account →
//               </button>
//             </>
//           )}

//           {step === 2 && (
//             <>
//               <div
//                 style={{
//                   background: "#f0fdf4",
//                   border: "1px solid #bbf7d0",
//                   borderRadius: 10,
//                   padding: "12px 16px",
//                   marginBottom: 20,
//                   fontSize: 13,
//                   color: "#166534",
//                 }}
//               >
//                 ✅ <strong>{form.name}</strong> · {form.city}
//               </div>
//               <label style={lbl}>Admin ID *</label>
//               <input
//                 style={inp}
//                 placeholder="e.g. saidental_admin"
//                 value={form.adminId}
//                 onChange={(e) => set("adminId", e.target.value)}
//               />
//               <label style={lbl}>Password *</label>
//               <input
//                 style={inp}
//                 type="password"
//                 placeholder="Create a strong password"
//                 value={form.password}
//                 onChange={(e) => set("password", e.target.value)}
//               />
//               <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 16 }}>
//                 💡 Save these credentials — you'll use them to login to your
//                 admin panel.
//               </div>
//               <div style={{ display: "flex", gap: 10 }}>
//                 <button
//                   onClick={() => setStep(1)}
//                   style={{
//                     flex: 1,
//                     padding: 13,
//                     background: "#f1f5f9",
//                     color: "#475569",
//                     border: "none",
//                     borderRadius: 10,
//                     fontSize: 14,
//                     fontWeight: 600,
//                     cursor: "pointer",
//                   }}
//                 >
//                   ← Back
//                 </button>
//                 <button
//                   onClick={submit}
//                   disabled={saving}
//                   style={{
//                     flex: 2,
//                     padding: 13,
//                     background: saving
//                       ? "#94a3b8"
//                       : "linear-gradient(135deg,#0d7377,#14a0a5)",
//                     color: "#fff",
//                     border: "none",
//                     borderRadius: 10,
//                     fontSize: 15,
//                     fontWeight: 700,
//                     cursor: saving ? "not-allowed" : "pointer",
//                   }}
//                 >
//                   {saving ? "Registering..." : "🚀 Complete Registration"}
//                 </button>
//               </div>
//             </>
//           )}

//           {step === 3 && (
//             <div style={{ textAlign: "center", padding: "20px 0" }}>
//               <div style={{ fontSize: 64, marginBottom: 16 }}>🎉</div>
//               <h3
//                 style={{
//                   fontSize: 22,
//                   fontWeight: 700,
//                   color: "#0a1628",
//                   marginBottom: 8,
//                 }}
//               >
//                 {form.name}
//               </h3>
//               <p
//                 style={{
//                   fontSize: 14,
//                   color: "#64748b",
//                   marginBottom: 24,
//                   lineHeight: 1.6,
//                 }}
//               >
//                 Your hospital is now live on VidyaOne! Use your credentials to
//                 login.
//               </p>
//               <div
//                 style={{
//                   background: "#f0fdf4",
//                   border: "1px solid #bbf7d0",
//                   borderRadius: 12,
//                   padding: "16px 20px",
//                   marginBottom: 24,
//                   textAlign: "left",
//                 }}
//               >
//                 <div
//                   style={{
//                     fontSize: 12,
//                     fontWeight: 700,
//                     color: "#16a34a",
//                     marginBottom: 8,
//                   }}
//                 >
//                   YOUR LOGIN CREDENTIALS
//                 </div>
//                 <div style={{ fontSize: 14, color: "#166534" }}>
//                   Admin ID: <strong>{form.adminId}</strong>
//                 </div>
//                 <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>
//                   (Save your password securely)
//                 </div>
//               </div>
//               <button
//                 onClick={onClose}
//                 style={{
//                   width: "100%",
//                   padding: 13,
//                   background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 10,
//                   fontSize: 15,
//                   fontWeight: 700,
//                   cursor: "pointer",
//                 }}
//               >
//                 Done ✓
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default function VidyaOne() {
//   const navigate = useNavigate();
//   const [hospitals, setHospitals] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState("");
//   const [activeCat, setActiveCat] = useState("all");
//   const [regOpen, setRegOpen] = useState(false);

//   const fetchHospitals = useCallback(async () => {
//     setLoading(true);
//     try {
//       const r = await fetch(`${API_URL}/hospitals`);
//       if (r.ok) {
//         const data = await r.json();
//         setHospitals(Array.isArray(data) ? data : []);
//       }
//     } catch (_) {}
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     fetchHospitals();
//   }, [fetchHospitals]);

//   const allHospitals = [
//     PEARLSMILE_CARD,
//     ...hospitals.filter((h) => h.slug !== "pearlsmile"),
//   ];

//   const filtered = allHospitals.filter((h) => {
//     const matchCat =
//       activeCat === "all" || (h.type || "").toLowerCase() === activeCat;
//     const q = search.toLowerCase();
//     const matchSearch =
//       !q ||
//       (h.name || "").toLowerCase().includes(q) ||
//       (h.city || "").toLowerCase().includes(q) ||
//       (h.type || "").toLowerCase().includes(q);
//     return matchCat && matchSearch;
//   });

//   const css = `
//     * { box-sizing: border-box; margin: 0; padding: 0; }
//     body { font-family: "DM Sans", sans-serif; }
//     .vo-nav {
//       position: fixed; top:0; left:0; right:0; z-index:1000;
//       background: rgba(10,22,40,0.97); backdrop-filter: blur(12px);
//       border-bottom: 1px solid rgba(255,255,255,0.06);
//       display: flex; align-items: center; justify-content: space-between;
//       padding: 0 40px; height: 68px;
//     }
//     .vo-logo { display:flex; align-items:center; gap:10px; cursor:pointer; }
//     .vo-logo-icon { width:38px; height:38px; background: linear-gradient(135deg,#0d7377,#14a0a5); border-radius:10px; display:flex; align-items:center; justify-content:center; font-size:20px; }
//     .vo-logo-text { font-family:"Cormorant Garamond",serif; font-size:22px; font-weight:700; color:#fff; }
//     .vo-logo-sub  { font-size:9px; color:#c9a845; letter-spacing:2px; text-transform:uppercase; }
//     .vo-nav-btn { background: linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; padding:10px 22px; border-radius:8px; font-weight:700; font-size:13px; font-family:"DM Sans",sans-serif; cursor:pointer; transition: opacity 0.2s; }
//     .vo-nav-btn:hover { opacity:0.9; }
//     .vo-nav-sa { background:rgba(255,255,255,0.06); color:rgba(255,255,255,0.55); border:1px solid rgba(255,255,255,0.12); padding:8px 14px; border-radius:8px; font-weight:600; font-size:12px; font-family:"DM Sans",sans-serif; cursor:pointer; transition:all 0.2s; }
//     .vo-nav-sa:hover { background:rgba(255,255,255,0.12); color:#fff; }
//     .vo-hero { min-height:100vh; background: linear-gradient(135deg,#0a1628 0%,#0d2444 50%,#0a1f3a 100%); display:flex; align-items:center; padding-top:68px; position:relative; overflow:hidden; }
//     .vo-hero::before { content:""; position:absolute; top:-200px; right:-200px; width:600px; height:600px; background: radial-gradient(circle,rgba(13,115,119,0.15) 0%,transparent 70%); border-radius:50%; }
//     .vo-hero-inner { max-width:1200px; margin:0 auto; padding:80px 24px; display:grid; grid-template-columns:1fr 1fr; gap:60px; align-items:center; position:relative; z-index:1; }
//     .vo-badge { display:inline-flex; align-items:center; gap:8px; background:rgba(201,168,76,0.15); border:1px solid rgba(201,168,76,0.3); color:#c9a845; font-size:11px; font-weight:700; letter-spacing:1px; text-transform:uppercase; padding:7px 16px; border-radius:100px; margin-bottom:24px; }
//     .vo-hero h1 { font-family:"Cormorant Garamond",serif; font-size:clamp(40px,5vw,64px); font-weight:700; color:#fff; line-height:1.1; margin-bottom:20px; }
//     .vo-hero h1 em { font-style:italic; color:#14a0a5; }
//     .vo-hero-desc { font-size:16px; color:rgba(255,255,255,0.7); line-height:1.7; margin-bottom:36px; max-width:480px; }
//     .vo-actions { display:flex; gap:14px; flex-wrap:wrap; }
//     .vo-btn-primary { background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; padding:14px 28px; border-radius:10px; font-size:15px; font-weight:700; font-family:"DM Sans",sans-serif; cursor:pointer; transition:opacity 0.2s,transform 0.2s; }
//     .vo-btn-primary:hover { opacity:0.92; transform:translateY(-1px); }
//     .vo-btn-outline { background:transparent; color:#fff; border:1.5px solid rgba(255,255,255,0.3); padding:14px 28px; border-radius:10px; font-size:15px; font-weight:600; font-family:"DM Sans",sans-serif; cursor:pointer; transition:border-color 0.2s; }
//     .vo-btn-outline:hover { border-color:rgba(255,255,255,0.6); }
//     .vo-stats { display:flex; gap:32px; margin-top:40px; }
//     .vo-stat-num { font-family:"Cormorant Garamond",serif; font-size:28px; font-weight:700; color:#14a0a5; }
//     .vo-stat-lbl { font-size:12px; color:rgba(255,255,255,0.5); margin-top:2px; }
//     .vo-float-cards { display:flex; flex-direction:column; gap:14px; }
//     .vo-float-card { background:rgba(255,255,255,0.06); border:1px solid rgba(255,255,255,0.1); backdrop-filter:blur(12px); border-radius:16px; padding:18px 22px; display:flex; align-items:center; gap:14px; transition:transform 0.3s; }
//     .vo-float-card:hover { transform:translateX(6px); }
//     .vo-float-icon { width:46px; height:46px; border-radius:12px; display:flex; align-items:center; justify-content:center; font-size:22px; flex-shrink:0; }
//     .vo-float-title { font-size:14px; font-weight:700; color:#fff; margin-bottom:3px; }
//     .vo-float-desc  { font-size:12px; color:rgba(255,255,255,0.55); }
//     .vo-hospitals { padding:100px 0; background:#f8fafc; }
//     .vo-container { max-width:1200px; margin:0 auto; padding:0 24px; }
//     .vo-section-tag { display:inline-flex; align-items:center; gap:6px; background:rgba(13,115,119,0.1); border:1px solid rgba(13,115,119,0.25); color:#0d7377; font-size:11px; font-weight:700; letter-spacing:1.2px; text-transform:uppercase; padding:6px 14px; border-radius:100px; margin-bottom:16px; }
//     .vo-section-title { font-family:"Cormorant Garamond",serif; font-size:clamp(32px,4vw,52px); font-weight:700; color:#0a1628; line-height:1.15; margin-bottom:16px; }
//     .vo-section-title em { font-style:italic; color:#0d7377; }
//     .vo-controls { display:flex; gap:16px; margin-bottom:32px; flex-wrap:wrap; align-items:center; }
//     .vo-search { flex:1; min-width:260px; padding:12px 18px; border-radius:10px; border:1.5px solid #e2e8f0; font-size:14px; font-family:"DM Sans",sans-serif; outline:none; background:#fff; transition:border-color 0.2s; }
//     .vo-search:focus { border-color:#0d7377; }
//     .vo-cats { display:flex; gap:8px; flex-wrap:wrap; }
//     .vo-cat { padding:8px 14px; border-radius:100px; border:1.5px solid #e2e8f0; background:#fff; font-size:13px; font-weight:600; color:#475569; cursor:pointer; transition:all 0.2s; white-space:nowrap; font-family:"DM Sans",sans-serif; }
//     .vo-cat:hover { border-color:#0d7377; color:#0d7377; }
//     .vo-cat.active { background:#0d7377; border-color:#0d7377; color:#fff; }
//     .vo-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(300px,1fr)); gap:28px; }
//     .vo-card { background:#fff; border-radius:20px; overflow:hidden; box-shadow:0 4px 32px rgba(0,0,0,0.08); transition:transform 0.28s,box-shadow 0.28s; cursor:pointer; border:1px solid #f1f5f9; }
//     .vo-card:hover { transform:translateY(-6px); box-shadow:0 12px 48px rgba(0,0,0,0.14); }
//     .vo-card-top { height:140px; display:flex; align-items:center; justify-content:center; position:relative; font-size:52px; }
//     .vo-card-badge { position:absolute; top:14px; right:14px; background:rgba(255,255,255,0.2); backdrop-filter:blur(8px); border:1px solid rgba(255,255,255,0.3); border-radius:20px; padding:4px 12px; font-size:11px; font-weight:700; color:#fff; }
//     .vo-card-body { padding:20px 22px 22px; }
//     .vo-card-name { font-family:"Cormorant Garamond",serif; font-size:20px; font-weight:700; color:#0a1628; margin-bottom:4px; }
//     .vo-card-type { font-size:12px; font-weight:700; color:#0d7377; text-transform:uppercase; letter-spacing:0.5px; margin-bottom:8px; }
//     .vo-card-city { font-size:13px; color:#94a3b8; margin-bottom:14px; }
//     .vo-card-stats { display:flex; gap:16px; padding:12px 0; border-top:1px solid #f1f5f9; border-bottom:1px solid #f1f5f9; margin-bottom:14px; }
//     .vo-card-stat { text-align:center; flex:1; }
//     .vo-card-stat-num { font-size:15px; font-weight:700; color:#0a1628; }
//     .vo-card-stat-lbl { font-size:10px; color:#94a3b8; margin-top:2px; }
//     .vo-card-btn { width:100%; padding:11px; background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; border-radius:10px; font-size:13px; font-weight:700; cursor:pointer; font-family:"DM Sans",sans-serif; transition:opacity 0.2s; }
//     .vo-card-btn:hover { opacity:0.9; }
//     .vo-empty { grid-column:1/-1; text-align:center; padding:60px 0; color:#94a3b8; font-size:15px; }
//     @keyframes vopulse { 0%,100%{opacity:1}50%{opacity:0.45} }
//     .vo-skel { background:#e2e8f0; border-radius:8px; animation:vopulse 1.5s ease-in-out infinite; }
//     .vo-cta { padding:100px 0; background:linear-gradient(135deg,#0a1628,#0d2444); text-align:center; }
//     .vo-cta-title { font-family:"Cormorant Garamond",serif; font-size:clamp(32px,4vw,52px); font-weight:700; color:#fff; margin-bottom:16px; }
//     .vo-cta-title em { font-style:italic; color:#14a0a5; }
//     .vo-cta-desc { font-size:16px; color:rgba(255,255,255,0.65); max-width:520px; margin:0 auto 40px; line-height:1.7; }
//     .vo-plans { display:flex; gap:20px; justify-content:center; flex-wrap:wrap; margin-bottom:36px; }
//     .vo-plan { background:rgba(255,255,255,0.08); border:1px solid rgba(255,255,255,0.15); border-radius:16px; padding:22px 26px; min-width:180px; transition:background 0.2s; }
//     .vo-plan:hover { background:rgba(255,255,255,0.12); }
//     .vo-plan.featured { background:linear-gradient(135deg,#0d7377,#14a0a5); border-color:transparent; }
//     .vo-plan-name { font-size:12px; font-weight:700; color:rgba(255,255,255,0.65); text-transform:uppercase; letter-spacing:1px; margin-bottom:8px; }
//     .vo-plan-price { font-family:"Cormorant Garamond",serif; font-size:30px; font-weight:700; color:#fff; line-height:1; margin-bottom:4px; }
//     .vo-plan-period { font-size:12px; color:rgba(255,255,255,0.5); margin-bottom:10px; }
//     .vo-plan-features { font-size:12px; color:rgba(255,255,255,0.6); line-height:1.6; }
//     .vo-how { padding:100px 0; background:#fff; }
//     .vo-how-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:28px; margin-top:56px; }
//     .vo-how-card { text-align:center; padding:28px 20px; border-radius:20px; background:#f8fafc; border:1px solid #f1f5f9; transition:transform 0.25s,box-shadow 0.25s; }
//     .vo-how-card:hover { transform:translateY(-4px); box-shadow:0 4px 24px rgba(0,0,0,0.08); }
//     .vo-how-step { width:46px; height:46px; border-radius:50%; background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; font-size:18px; font-weight:800; display:flex; align-items:center; justify-content:center; margin:0 auto 14px; }
//     .vo-how-icon { font-size:30px; margin-bottom:12px; }
//     .vo-how-title { font-size:15px; font-weight:700; color:#0a1628; margin-bottom:8px; }
//     .vo-how-desc  { font-size:13px; color:#475569; line-height:1.6; }
//     .vo-footer { background:#0a1628; padding:56px 0 24px; border-top:1px solid rgba(255,255,255,0.06); }
//     .vo-footer-inner { max-width:1200px; margin:0 auto; padding:0 24px 40px; display:grid; grid-template-columns:2fr 1fr 1fr; gap:48px; }
//     .vo-footer-desc { font-size:14px; color:rgba(255,255,255,0.5); line-height:1.7; margin-top:10px; max-width:280px; }
//     .vo-footer-col h4 { font-size:12px; font-weight:700; color:rgba(255,255,255,0.85); text-transform:uppercase; letter-spacing:1px; margin-bottom:14px; }
//     .vo-footer-col ul { list-style:none; }
//     .vo-footer-col ul li { margin-bottom:8px; }
//     .vo-footer-col ul li a { font-size:13px; color:rgba(255,255,255,0.5); cursor:pointer; transition:color 0.2s; }
//     .vo-footer-col ul li a:hover { color:rgba(255,255,255,0.85); }
//     .vo-footer-bottom { max-width:1200px; margin:0 auto; padding:20px 24px 0; border-top:1px solid rgba(255,255,255,0.07); display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:12px; font-size:13px; color:rgba(255,255,255,0.35); }
//     @media(max-width:860px) {
//       .vo-hero-inner { grid-template-columns:1fr; }
//       .vo-float-cards { display:none; }
//       .vo-how-grid { grid-template-columns:repeat(2,1fr); }
//       .vo-footer-inner { grid-template-columns:1fr; gap:28px; }
//       .vo-nav { padding:0 20px; }
//       .vo-nav-sa { display:none; }
//     }
//     @media(max-width:600px) {
//       .vo-grid { grid-template-columns:1fr; }
//       .vo-how-grid { grid-template-columns:1fr; }
//       .vo-stats { gap:20px; }
//       .vo-plans { flex-direction:column; align-items:center; }
//     }
//   `;

//   const scrollTo = (id) =>
//     document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

//   return (
//     <div style={{ fontFamily: "DM Sans,sans-serif" }}>
//       <style>{css}</style>

//       {/* ── Navbar ── */}
//       <div className="vo-nav">
//         <div className="vo-logo">
//           <div className="vo-logo-icon">🏥</div>
//           <div>
//             <div className="vo-logo-text">VidyaOne</div>
//             <div className="vo-logo-sub">Healthcare Platform</div>
//           </div>
//         </div>
//         <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
//           <a
//             onClick={() => scrollTo("hospitals")}
//             style={{
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 14,
//               fontWeight: 500,
//               cursor: "pointer",
//             }}
//           >
//             Hospitals
//           </a>
//           <a
//             onClick={() => scrollTo("how")}
//             style={{
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 14,
//               fontWeight: 500,
//               cursor: "pointer",
//             }}
//           >
//             How It Works
//           </a>
//           <button className="vo-nav-btn" onClick={() => setRegOpen(true)}>
//             Register Hospital
//           </button>
//           {/* ✅ Super Admin — subtle, only you know it's there */}
//           <button className="vo-nav-sa" onClick={() => navigate("/superadmin")}>
//             🛡️ Admin
//           </button>
//         </div>
//       </div>

//       {/* ── Hero ── */}
//       <section className="vo-hero" id="home">
//         <div className="vo-hero-inner">
//           <div>
//             <div className="vo-badge">
//               🌟 India's Healthcare Management Platform
//             </div>
//             <h1>
//               Find & Book
//               <br />
//               <em>Top Hospitals</em>
//               <br />
//               Near You
//             </h1>
//             <p className="vo-hero-desc">
//               From Dental to Ortho, Ayurved to Cardiology — discover verified
//               hospitals, book appointments instantly, and manage your health all
//               in one place.
//             </p>
//             <div className="vo-actions">
//               <button
//                 className="vo-btn-primary"
//                 onClick={() => scrollTo("hospitals")}
//               >
//                 Find Hospitals →
//               </button>
//               <button
//                 className="vo-btn-outline"
//                 onClick={() => setRegOpen(true)}
//               >
//                 Register Your Hospital
//               </button>
//             </div>
//             <div className="vo-stats">
//               {[
//                 ["200+", "Hospitals"],
//                 ["50K+", "Patients"],
//                 ["7", "Specialities"],
//               ].map(([n, l]) => (
//                 <div key={l}>
//                   <div className="vo-stat-num">{n}</div>
//                   <div className="vo-stat-lbl">{l}</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//           <div className="vo-float-cards">
//             {[
//               {
//                 icon: "🦷",
//                 bg: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                 title: "Dental Care",
//                 desc: "Root canal, implants, whitening",
//               },
//               {
//                 icon: "🦴",
//                 bg: "linear-gradient(135deg,#1a3a6b,#2563eb)",
//                 title: "Ortho Care",
//                 desc: "Joint replacement, physiotherapy",
//               },
//               {
//                 icon: "🌿",
//                 bg: "linear-gradient(135deg,#166534,#16a34a)",
//                 title: "Ayurved",
//                 desc: "Panchakarma, herbal treatments",
//               },
//               {
//                 icon: "❤️",
//                 bg: "linear-gradient(135deg,#881337,#dc2626)",
//                 title: "Cardiology",
//                 desc: "Heart care, ECG, consultations",
//               },
//             ].map((c) => (
//               <div key={c.title} className="vo-float-card">
//                 <div className="vo-float-icon" style={{ background: c.bg }}>
//                   {c.icon}
//                 </div>
//                 <div>
//                   <div className="vo-float-title">{c.title}</div>
//                   <div className="vo-float-desc">{c.desc}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ── Hospital Grid ── */}
//       <section className="vo-hospitals" id="hospitals">
//         <div className="vo-container">
//           <div style={{ textAlign: "center", marginBottom: 48 }}>
//             <div className="vo-section-tag">🏥 Browse Hospitals</div>
//             <h2 className="vo-section-title">
//               Find the Right
//               <br />
//               <em>Hospital for You</em>
//             </h2>
//             <p
//               style={{
//                 fontSize: 16,
//                 color: "#475569",
//                 maxWidth: 540,
//                 margin: "0 auto",
//                 lineHeight: 1.7,
//               }}
//             >
//               Browse verified hospitals by speciality or city.
//             </p>
//           </div>
//           <div className="vo-controls">
//             <input
//               className="vo-search"
//               placeholder="🔍 Search by hospital name or city..."
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//             />
//             <div className="vo-cats">
//               {CATEGORIES.map((c) => (
//                 <button
//                   key={c.id}
//                   className={`vo-cat${activeCat === c.id ? " active" : ""}`}
//                   onClick={() => setActiveCat(c.id)}
//                 >
//                   {c.icon} {c.label}
//                 </button>
//               ))}
//             </div>
//           </div>
//           <div style={{ fontSize: 13, color: "#94a3b8", marginBottom: 24 }}>
//             {loading
//               ? "Loading hospitals..."
//               : `${filtered.length} hospital${filtered.length !== 1 ? "s" : ""} found`}
//           </div>
//           <div className="vo-grid">
//             {loading ? (
//               [1, 2, 3, 4, 5, 6].map((i) => (
//                 <div
//                   key={i}
//                   style={{
//                     background: "#fff",
//                     borderRadius: 20,
//                     overflow: "hidden",
//                     boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
//                   }}
//                 >
//                   <div className="vo-skel" style={{ height: 140 }} />
//                   <div style={{ padding: "20px 22px" }}>
//                     <div
//                       className="vo-skel"
//                       style={{ height: 20, width: "70%", marginBottom: 8 }}
//                     />
//                     <div
//                       className="vo-skel"
//                       style={{ height: 13, width: "40%", marginBottom: 14 }}
//                     />
//                     <div
//                       className="vo-skel"
//                       style={{ height: 38, borderRadius: 10 }}
//                     />
//                   </div>
//                 </div>
//               ))
//             ) : filtered.length === 0 ? (
//               <div className="vo-empty">No hospitals match your search.</div>
//             ) : (
//               filtered.map((h) => {
//                 const type = (h.type || "general").toLowerCase();
//                 const grad = CAT_GRADIENTS[type] || CAT_GRADIENTS.general;
//                 const cat = CATEGORIES.find((c) => c.id === type);
//                 return (
//                   <div
//                     key={h._id}
//                     className="vo-card"
//                     onClick={() => navigate(`/hospital/${h.slug}`)}
//                   >
//                     <div className="vo-card-top" style={{ background: grad }}>
//                       <div className="vo-card-badge">
//                         {cat?.label || "Hospital"}
//                       </div>
//                       {h.logoUrl ? (
//                         <img
//                           src={h.logoUrl}
//                           alt={h.name}
//                           style={{
//                             width: 70,
//                             height: 70,
//                             borderRadius: "50%",
//                             objectFit: "cover",
//                             border: "3px solid rgba(255,255,255,0.3)",
//                           }}
//                         />
//                       ) : (
//                         <span>{CAT_ICONS[type] || "🏥"}</span>
//                       )}
//                     </div>
//                     <div className="vo-card-body">
//                       <div className="vo-card-name">{h.name}</div>
//                       <div className="vo-card-type">
//                         {cat?.icon} {cat?.label || "Hospital"}
//                       </div>
//                       <div className="vo-card-city">
//                         📍 {h.city || "Location not specified"}
//                       </div>
//                       <div className="vo-card-stats">
//                         {[
//                           ["Patients", h.statPatients],
//                           ["Doctors", h.statDoctors],
//                           ["Rating", h.statRating],
//                         ].map(([l, v]) => (
//                           <div key={l} className="vo-card-stat">
//                             <div className="vo-card-stat-num">{v || "—"}</div>
//                             <div className="vo-card-stat-lbl">{l}</div>
//                           </div>
//                         ))}
//                       </div>
//                       <button className="vo-card-btn">
//                         Book Appointment →
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>
//       </section>

//       {/* ── How It Works ── */}
//       <section className="vo-how" id="how">
//         <div className="vo-container">
//           <div style={{ textAlign: "center" }}>
//             <div className="vo-section-tag">Simple Process</div>
//             <h2 className="vo-section-title">
//               How <em>VidyaOne</em> Works
//             </h2>
//             <p
//               style={{
//                 fontSize: 16,
//                 color: "#475569",
//                 maxWidth: 520,
//                 margin: "0 auto",
//                 lineHeight: 1.7,
//               }}
//             >
//               Get your hospital live in under 10 minutes. No technical knowledge
//               required.
//             </p>
//           </div>
//           <div className="vo-how-grid">
//             {[
//               {
//                 step: "1",
//                 icon: "🏥",
//                 title: "Register Hospital",
//                 desc: "Fill your hospital details, choose a plan and pay securely.",
//               },
//               {
//                 step: "2",
//                 icon: "⚙️",
//                 title: "Setup Your Panel",
//                 desc: "Add your doctors, services and pricing inside your admin dashboard.",
//               },
//               {
//                 step: "3",
//                 icon: "📅",
//                 title: "Patients Book",
//                 desc: "Patients find your hospital on VidyaOne and book appointments online.",
//               },
//               {
//                 step: "4",
//                 icon: "📊",
//                 title: "Manage Everything",
//                 desc: "Track appointments, patients, billing and doctor availability in one panel.",
//               },
//             ].map((s) => (
//               <div key={s.step} className="vo-how-card">
//                 <div className="vo-how-step">{s.step}</div>
//                 <div className="vo-how-icon">{s.icon}</div>
//                 <div className="vo-how-title">{s.title}</div>
//                 <div className="vo-how-desc">{s.desc}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ── CTA ── */}
//       <section className="vo-cta" id="pricing">
//         <div className="vo-container">
//           <div
//             className="vo-section-tag"
//             style={{
//               background: "rgba(201,168,76,0.15)",
//               borderColor: "rgba(201,168,76,0.3)",
//               color: "#c9a845",
//             }}
//           >
//             💰 Simple Pricing
//           </div>
//           <h2 className="vo-cta-title">
//             Register Your Hospital
//             <br />
//             <em>Start Today</em>
//           </h2>
//           <p className="vo-cta-desc">
//             Choose a plan that fits your hospital. All plans include full admin
//             panel, patient management & WhatsApp integration.
//           </p>
//           <div className="vo-plans">
//             {[
//               {
//                 name: "Starter",
//                 price: "₹999",
//                 period: "/month",
//                 features: "3 Doctors · Appointments · Patients",
//               },
//               {
//                 name: "Pro",
//                 price: "₹1,999",
//                 period: "/month",
//                 features: "10 Doctors · Billing · WhatsApp",
//                 featured: true,
//               },
//               {
//                 name: "Enterprise",
//                 price: "₹3,499",
//                 period: "/month",
//                 features: "Unlimited · Priority Support · Custom Domain",
//               },
//             ].map((p) => (
//               <div
//                 key={p.name}
//                 className={`vo-plan${p.featured ? " featured" : ""}`}
//               >
//                 <div className="vo-plan-name">{p.name}</div>
//                 <div className="vo-plan-price">{p.price}</div>
//                 <div className="vo-plan-period">{p.period}</div>
//                 <div className="vo-plan-features">{p.features}</div>
//               </div>
//             ))}
//           </div>
//           <button
//             className="vo-btn-primary"
//             style={{ fontSize: 16, padding: "15px 36px" }}
//             onClick={() => setRegOpen(true)}
//           >
//             Register Your Hospital Now →
//           </button>
//           <div
//             style={{
//               fontSize: 12,
//               color: "rgba(255,255,255,0.4)",
//               marginTop: 14,
//             }}
//           >
//             14-day free trial · No credit card required to start
//           </div>
//         </div>
//       </section>

//       {/* ── Footer ── */}
//       <footer className="vo-footer">
//         <div className="vo-footer-inner">
//           <div>
//             <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//               <div
//                 style={{
//                   width: 36,
//                   height: 36,
//                   background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   borderRadius: 10,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   fontSize: 18,
//                 }}
//               >
//                 🏥
//               </div>
//               <div>
//                 <div
//                   style={{
//                     fontFamily: "Cormorant Garamond,serif",
//                     fontSize: 20,
//                     fontWeight: 700,
//                     color: "#fff",
//                   }}
//                 >
//                   VidyaOne
//                 </div>
//                 <div
//                   style={{
//                     fontSize: 9,
//                     color: "#c9a845",
//                     letterSpacing: 2,
//                     textTransform: "uppercase",
//                   }}
//                 >
//                   Healthcare Platform
//                 </div>
//               </div>
//             </div>
//             <p className="vo-footer-desc">
//               India's premier hospital management platform. Connecting patients
//               with the best hospitals.
//             </p>
//           </div>
//           <div className="vo-footer-col">
//             <h4>For Hospitals</h4>
//             <ul>
//               {[
//                 "Register Hospital",
//                 "Pricing Plans",
//                 "How It Works",
//                 "Admin Login",
//               ].map((s) => (
//                 <li key={s}>
//                   <a>{s}</a>
//                 </li>
//               ))}
//             </ul>
//           </div>
//           <div className="vo-footer-col">
//             <h4>Specialities</h4>
//             <ul>
//               {[
//                 "🦷 Dental",
//                 "🦴 Ortho",
//                 "🌿 Ayurved",
//                 "❤️ Cardiology",
//                 "👁️ Eye Care",
//                 "👶 Pediatric",
//               ].map((s) => (
//                 <li key={s}>
//                   <a>{s}</a>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>
//         <div className="vo-footer-bottom">
//           <p>© 2026 VidyaOne Healthcare Platform. All rights reserved.</p>
//           <div style={{ display: "flex", gap: 24 }}>
//             <a>Privacy Policy</a>
//             <a>Terms of Service</a>
//           </div>
//         </div>
//       </footer>

//       {regOpen && (
//         <RegisterModal
//           onClose={() => {
//             setRegOpen(false);
//             fetchHospitals();
//           }}
//         />
//       )}
//     </div>
//   );
// }

//////// secrate key
// // ============================================================
// // src/pages/VidyaOne.js
// // ✅ Super Admin button added in navbar
// // ✅ Registration secret key gate added
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";

// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// const PEARLSMILE_CARD = {
//   _id: "pearlsmile-static",
//   name: "PearlSmile Dental Hospital",
//   type: "dental",
//   city: "Pune, Maharashtra",
//   slug: "pearlsmile",
//   statPatients: "18K+",
//   statDoctors: "20+",
//   statRating: "4.9★",
//   logoUrl: "",
// };

// const CATEGORIES = [
//   { id: "all", label: "All", icon: "🏥" },
//   { id: "dental", label: "Dental", icon: "🦷" },
//   { id: "ortho", label: "Ortho", icon: "🦴" },
//   { id: "ayurved", label: "Ayurved", icon: "🌿" },
//   { id: "cardiology", label: "Cardiology", icon: "❤️" },
//   { id: "eye", label: "Eye", icon: "👁️" },
//   { id: "pediatric", label: "Pediatric", icon: "👶" },
//   { id: "general", label: "General", icon: "➕" },
// ];

// const CAT_GRADIENTS = {
//   dental: "linear-gradient(135deg,#0d7377,#14a0a5)",
//   ortho: "linear-gradient(135deg,#1a3a6b,#2563eb)",
//   ayurved: "linear-gradient(135deg,#166534,#16a34a)",
//   cardiology: "linear-gradient(135deg,#881337,#dc2626)",
//   eye: "linear-gradient(135deg,#4338ca,#7c3aed)",
//   pediatric: "linear-gradient(135deg,#c2410c,#f97316)",
//   general: "linear-gradient(135deg,#0f766e,#0d9488)",
// };

// const CAT_ICONS = {
//   dental: "🦷",
//   ortho: "🦴",
//   ayurved: "🌿",
//   cardiology: "❤️",
//   eye: "👁️",
//   pediatric: "👶",
//   general: "➕",
// };

// const TYPES = [
//   "Dental",
//   "Ortho",
//   "Ayurved",
//   "Cardiology",
//   "Eye",
//   "Pediatric",
//   "General",
// ];
// const PLANS = [
//   { id: "starter", label: "Starter — ₹999/mo" },
//   { id: "pro", label: "Pro — ₹1,999/mo" },
//   { id: "enterprise", label: "Enterprise — ₹3,499/mo" },
// ];

// // ── Register Modal ────────────────────────────────────────────
// function RegisterModal({ onClose }) {
//   const [step, setStep] = useState(1);
//   const [saving, setSaving] = useState(false);
//   const [msg, setMsg] = useState("");
//   const [form, setForm] = useState({
//     name: "",
//     type: "",
//     phone: "",
//     whatsapp: "",
//     email: "",
//     address: "",
//     city: "",
//     established: "",
//     plan: "pro",
//     adminId: "",
//     password: "",
//     registrationKey: "", // ✅ Secret key field
//   });
//   const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

//   const inp = {
//     width: "100%",
//     padding: "10px 14px",
//     borderRadius: 8,
//     border: "1.5px solid #e2e8f0",
//     fontSize: 14,
//     fontFamily: "DM Sans,sans-serif",
//     outline: "none",
//     background: "#f8fafc",
//     boxSizing: "border-box",
//     marginTop: 4,
//     marginBottom: 12,
//   };
//   const lbl = {
//     fontSize: 12,
//     fontWeight: 600,
//     color: "#475569",
//     display: "block",
//   };

//   const next = () => {
//     if (!form.name || !form.type || !form.phone || !form.city) {
//       setMsg("Please fill all required fields.");
//       return;
//     }
//     setMsg("");
//     setStep(2);
//   };

//   const submit = async () => {
//     if (!form.adminId || !form.password) {
//       setMsg("Admin ID and password are required.");
//       return;
//     }
//     // ✅ Frontend key validation
//     if (!form.registrationKey.trim()) {
//       setMsg(
//         "Registration access key is required. Contact VidyaOne on WhatsApp to get your key.",
//       );
//       return;
//     }
//     setSaving(true);
//     setMsg("");
//     try {
//       const slug = form.name
//         .toLowerCase()
//         .replace(/[^a-z0-9]+/g, "-")
//         .replace(/^-|-$/g, "");
//       const res = await fetch(`${API_URL}/hospitals/register`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ ...form, slug }),
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message || "Registration failed");
//       setStep(3);
//     } catch (err) {
//       setMsg(err.message);
//     }
//     setSaving(false);
//   };

//   return (
//     <div
//       style={{
//         position: "fixed",
//         inset: 0,
//         background: "rgba(0,0,0,0.6)",
//         backdropFilter: "blur(4px)",
//         zIndex: 2000,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: 20,
//       }}
//       onClick={(e) => {
//         if (e.target === e.currentTarget) onClose();
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 24,
//           width: "100%",
//           maxWidth: 520,
//           maxHeight: "90vh",
//           overflowY: "auto",
//           boxShadow: "0 24px 80px rgba(0,0,0,0.4)",
//         }}
//       >
//         {/* Header */}
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             padding: "22px 28px",
//             borderRadius: "24px 24px 0 0",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div>
//             <div style={{ fontSize: 17, fontWeight: 700, color: "#fff" }}>
//               {step === 3
//                 ? "🎉 Registration Successful!"
//                 : "🏥 Register Your Hospital"}
//             </div>
//             <div
//               style={{
//                 fontSize: 12,
//                 color: "rgba(255,255,255,0.55)",
//                 marginTop: 3,
//               }}
//             >
//               {step === 1 && "Step 1 of 2 — Hospital Details"}
//               {step === 2 && "Step 2 of 2 — Admin Credentials & Access Key"}
//               {step === 3 && "Your hospital is now live on VidyaOne!"}
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.12)",
//               border: "none",
//               color: "#fff",
//               width: 32,
//               height: 32,
//               borderRadius: "50%",
//               fontSize: 16,
//               cursor: "pointer",
//             }}
//           >
//             ✕
//           </button>
//         </div>

//         <div style={{ padding: 28 }}>
//           {/* Error message */}
//           {msg && (
//             <div
//               style={{
//                 background: "#fef2f2",
//                 border: "1px solid #fecaca",
//                 borderRadius: 8,
//                 padding: "10px 14px",
//                 marginBottom: 16,
//                 fontSize: 13,
//                 color: "#dc2626",
//               }}
//             >
//               {msg}
//             </div>
//           )}

//           {/* ── STEP 1: Hospital Details ── */}
//           {step === 1 && (
//             <>
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "1fr 1fr",
//                   gap: "0 14px",
//                 }}
//               >
//                 <div>
//                   <label style={lbl}>Hospital Name *</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. Sai Dental Hospital"
//                     value={form.name}
//                     onChange={(e) => set("name", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Hospital Type *</label>
//                   <select
//                     style={inp}
//                     value={form.type}
//                     onChange={(e) => set("type", e.target.value)}
//                   >
//                     <option value="">Select type</option>
//                     {TYPES.map((t) => (
//                       <option key={t} value={t.toLowerCase()}>
//                         {t}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 <div>
//                   <label style={lbl}>Phone *</label>
//                   <input
//                     style={inp}
//                     placeholder="+91 98765 43210"
//                     value={form.phone}
//                     onChange={(e) => set("phone", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>WhatsApp (no +)</label>
//                   <input
//                     style={inp}
//                     placeholder="919876543210"
//                     value={form.whatsapp}
//                     onChange={(e) => set("whatsapp", e.target.value)}
//                   />
//                 </div>
//                 <div style={{ gridColumn: "1/-1" }}>
//                   <label style={lbl}>Email</label>
//                   <input
//                     style={inp}
//                     type="email"
//                     placeholder="info@hospital.com"
//                     value={form.email}
//                     onChange={(e) => set("email", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Address</label>
//                   <input
//                     style={inp}
//                     placeholder="Street, Area"
//                     value={form.address}
//                     onChange={(e) => set("address", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>City *</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. Mumbai, MH"
//                     value={form.city}
//                     onChange={(e) => set("city", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Established Year</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. 2010"
//                     value={form.established}
//                     onChange={(e) => set("established", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Plan</label>
//                   <select
//                     style={inp}
//                     value={form.plan}
//                     onChange={(e) => set("plan", e.target.value)}
//                   >
//                     {PLANS.map((p) => (
//                       <option key={p.id} value={p.id}>
//                         {p.label}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//               <button
//                 onClick={next}
//                 style={{
//                   width: "100%",
//                   padding: 13,
//                   background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 10,
//                   fontSize: 15,
//                   fontWeight: 700,
//                   cursor: "pointer",
//                 }}
//               >
//                 Next: Create Admin Account →
//               </button>
//             </>
//           )}

//           {/* ── STEP 2: Admin Credentials + Secret Key ── */}
//           {step === 2 && (
//             <>
//               <div
//                 style={{
//                   background: "#f0fdf4",
//                   border: "1px solid #bbf7d0",
//                   borderRadius: 10,
//                   padding: "12px 16px",
//                   marginBottom: 20,
//                   fontSize: 13,
//                   color: "#166534",
//                 }}
//               >
//                 ✅ <strong>{form.name}</strong> · {form.city}
//               </div>

//               <label style={lbl}>Admin ID *</label>
//               <input
//                 style={inp}
//                 placeholder="e.g. saidental_admin"
//                 value={form.adminId}
//                 onChange={(e) => set("adminId", e.target.value)}
//               />

//               <label style={lbl}>Password *</label>
//               <input
//                 style={inp}
//                 type="password"
//                 placeholder="Create a strong password"
//                 value={form.password}
//                 onChange={(e) => set("password", e.target.value)}
//               />

//               <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 18 }}>
//                 💡 Save these credentials — you'll use them to login to your
//                 admin panel.
//               </div>

//               {/* ✅ Secret Key Field */}
//               <div
//                 style={{
//                   background: "#fffbeb",
//                   border: "1px solid #fde68a",
//                   borderRadius: 10,
//                   padding: "14px 16px",
//                   marginBottom: 16,
//                 }}
//               >
//                 <div
//                   style={{
//                     fontSize: 13,
//                     fontWeight: 700,
//                     color: "#92400e",
//                     marginBottom: 8,
//                   }}
//                 >
//                   🔐 Registration Access Key Required
//                 </div>
//                 <div
//                   style={{
//                     fontSize: 12,
//                     color: "#92400e",
//                     marginBottom: 10,
//                     lineHeight: 1.5,
//                   }}
//                 >
//                   This is a private key provided by VidyaOne. Without it,
//                   registration is not allowed. Contact us on WhatsApp to get
//                   your key before registering.
//                 </div>
//                 <a
//                   href="https://wa.me/918793608083?text=Hi%20VidyaOne%2C%20I%20want%20to%20register%20my%20hospital.%20Please%20share%20the%20registration%20key."
//                   target="_blank"
//                   rel="noreferrer"
//                   style={{
//                     display: "inline-flex",
//                     alignItems: "center",
//                     gap: 8,
//                     margin: "6px 0 12px",
//                     background: "#25d366",
//                     color: "#fff",
//                     borderRadius: 8,
//                     padding: "9px 16px",
//                     fontSize: 13,
//                     fontWeight: 700,
//                     textDecoration: "none",
//                   }}
//                 >
//                   <svg width="15" height="15" viewBox="0 0 24 24" fill="white">
//                     <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                     <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                   </svg>
//                   Contact VidyaOne Owner — +91 87936 08083
//                 </a>
//                 <label style={{ ...lbl, color: "#92400e" }}>Access Key *</label>
//                 <input
//                   style={{
//                     ...inp,
//                     marginBottom: 0,
//                     background: "#fff",
//                     border: "1.5px solid #fcd34d",
//                   }}
//                   type="password"
//                   placeholder="Enter your VidyaOne registration key"
//                   value={form.registrationKey}
//                   onChange={(e) => set("registrationKey", e.target.value)}
//                 />
//               </div>

//               <div style={{ display: "flex", gap: 10 }}>
//                 <button
//                   onClick={() => setStep(1)}
//                   style={{
//                     flex: 1,
//                     padding: 13,
//                     background: "#f1f5f9",
//                     color: "#475569",
//                     border: "none",
//                     borderRadius: 10,
//                     fontSize: 14,
//                     fontWeight: 600,
//                     cursor: "pointer",
//                   }}
//                 >
//                   ← Back
//                 </button>
//                 <button
//                   onClick={submit}
//                   disabled={saving}
//                   style={{
//                     flex: 2,
//                     padding: 13,
//                     background: saving
//                       ? "#94a3b8"
//                       : "linear-gradient(135deg,#0d7377,#14a0a5)",
//                     color: "#fff",
//                     border: "none",
//                     borderRadius: 10,
//                     fontSize: 15,
//                     fontWeight: 700,
//                     cursor: saving ? "not-allowed" : "pointer",
//                   }}
//                 >
//                   {saving ? "Registering..." : "🚀 Complete Registration"}
//                 </button>
//               </div>
//             </>
//           )}

//           {/* ── STEP 3: Success ── */}
//           {step === 3 && (
//             <div style={{ textAlign: "center", padding: "20px 0" }}>
//               <div style={{ fontSize: 64, marginBottom: 16 }}>🎉</div>
//               <h3
//                 style={{
//                   fontSize: 22,
//                   fontWeight: 700,
//                   color: "#0a1628",
//                   marginBottom: 8,
//                 }}
//               >
//                 {form.name}
//               </h3>
//               <p
//                 style={{
//                   fontSize: 14,
//                   color: "#64748b",
//                   marginBottom: 24,
//                   lineHeight: 1.6,
//                 }}
//               >
//                 Your hospital is now live on VidyaOne! Use your credentials to
//                 login.
//               </p>
//               <div
//                 style={{
//                   background: "#f0fdf4",
//                   border: "1px solid #bbf7d0",
//                   borderRadius: 12,
//                   padding: "16px 20px",
//                   marginBottom: 24,
//                   textAlign: "left",
//                 }}
//               >
//                 <div
//                   style={{
//                     fontSize: 12,
//                     fontWeight: 700,
//                     color: "#16a34a",
//                     marginBottom: 8,
//                   }}
//                 >
//                   YOUR LOGIN CREDENTIALS
//                 </div>
//                 <div style={{ fontSize: 14, color: "#166534" }}>
//                   Admin ID: <strong>{form.adminId}</strong>
//                 </div>
//                 <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>
//                   (Save your password securely)
//                 </div>
//               </div>
//               <button
//                 onClick={onClose}
//                 style={{
//                   width: "100%",
//                   padding: 13,
//                   background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 10,
//                   fontSize: 15,
//                   fontWeight: 700,
//                   cursor: "pointer",
//                 }}
//               >
//                 Done ✓
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Main VidyaOne Page ────────────────────────────────────────
// export default function VidyaOne() {
//   const navigate = useNavigate();
//   const [hospitals, setHospitals] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState("");
//   const [activeCat, setActiveCat] = useState("all");
//   const [regOpen, setRegOpen] = useState(false);

//   const fetchHospitals = useCallback(async () => {
//     setLoading(true);
//     try {
//       const r = await fetch(`${API_URL}/hospitals`);
//       if (r.ok) {
//         const data = await r.json();
//         setHospitals(Array.isArray(data) ? data : []);
//       }
//     } catch (_) {}
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     fetchHospitals();
//   }, [fetchHospitals]);

//   const allHospitals = [
//     PEARLSMILE_CARD,
//     ...hospitals.filter((h) => h.slug !== "pearlsmile"),
//   ];

//   const filtered = allHospitals.filter((h) => {
//     const matchCat =
//       activeCat === "all" || (h.type || "").toLowerCase() === activeCat;
//     const q = search.toLowerCase();
//     const matchSearch =
//       !q ||
//       (h.name || "").toLowerCase().includes(q) ||
//       (h.city || "").toLowerCase().includes(q) ||
//       (h.type || "").toLowerCase().includes(q);
//     return matchCat && matchSearch;
//   });

//   const css = `
//     * { box-sizing: border-box; margin: 0; padding: 0; }
//     body { font-family: "DM Sans", sans-serif; }
//     .vo-nav { position:fixed; top:0; left:0; right:0; z-index:1000; background:rgba(10,22,40,0.97); backdrop-filter:blur(12px); border-bottom:1px solid rgba(255,255,255,0.06); display:flex; align-items:center; justify-content:space-between; padding:0 40px; height:68px; }
//     .vo-logo { display:flex; align-items:center; gap:10px; cursor:pointer; }
//     .vo-logo-icon { width:38px; height:38px; background:linear-gradient(135deg,#0d7377,#14a0a5); border-radius:10px; display:flex; align-items:center; justify-content:center; font-size:20px; }
//     .vo-logo-text { font-family:"Cormorant Garamond",serif; font-size:22px; font-weight:700; color:#fff; }
//     .vo-logo-sub  { font-size:9px; color:#c9a845; letter-spacing:2px; text-transform:uppercase; }
//     .vo-nav-btn { background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; padding:10px 22px; border-radius:8px; font-weight:700; font-size:13px; font-family:"DM Sans",sans-serif; cursor:pointer; transition:opacity 0.2s; }
//     .vo-nav-btn:hover { opacity:0.9; }
//     .vo-nav-sa { background:rgba(255,255,255,0.06); color:rgba(255,255,255,0.55); border:1px solid rgba(255,255,255,0.12); padding:8px 14px; border-radius:8px; font-weight:600; font-size:12px; font-family:"DM Sans",sans-serif; cursor:pointer; transition:all 0.2s; }
//     .vo-nav-sa:hover { background:rgba(255,255,255,0.12); color:#fff; }
//     .vo-hero { min-height:100vh; background:linear-gradient(135deg,#0a1628 0%,#0d2444 50%,#0a1f3a 100%); display:flex; align-items:center; padding-top:68px; position:relative; overflow:hidden; }
//     .vo-hero::before { content:""; position:absolute; top:-200px; right:-200px; width:600px; height:600px; background:radial-gradient(circle,rgba(13,115,119,0.15) 0%,transparent 70%); border-radius:50%; }
//     .vo-hero-inner { max-width:1200px; margin:0 auto; padding:80px 24px; display:grid; grid-template-columns:1fr 1fr; gap:60px; align-items:center; position:relative; z-index:1; }
//     .vo-badge { display:inline-flex; align-items:center; gap:8px; background:rgba(201,168,76,0.15); border:1px solid rgba(201,168,76,0.3); color:#c9a845; font-size:11px; font-weight:700; letter-spacing:1px; text-transform:uppercase; padding:7px 16px; border-radius:100px; margin-bottom:24px; }
//     .vo-hero h1 { font-family:"Cormorant Garamond",serif; font-size:clamp(40px,5vw,64px); font-weight:700; color:#fff; line-height:1.1; margin-bottom:20px; }
//     .vo-hero h1 em { font-style:italic; color:#14a0a5; }
//     .vo-hero-desc { font-size:16px; color:rgba(255,255,255,0.7); line-height:1.7; margin-bottom:36px; max-width:480px; }
//     .vo-actions { display:flex; gap:14px; flex-wrap:wrap; }
//     .vo-btn-primary { background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; padding:14px 28px; border-radius:10px; font-size:15px; font-weight:700; font-family:"DM Sans",sans-serif; cursor:pointer; transition:opacity 0.2s,transform 0.2s; }
//     .vo-btn-primary:hover { opacity:0.92; transform:translateY(-1px); }
//     .vo-btn-outline { background:transparent; color:#fff; border:1.5px solid rgba(255,255,255,0.3); padding:14px 28px; border-radius:10px; font-size:15px; font-weight:600; font-family:"DM Sans",sans-serif; cursor:pointer; transition:border-color 0.2s; }
//     .vo-btn-outline:hover { border-color:rgba(255,255,255,0.6); }
//     .vo-stats { display:flex; gap:32px; margin-top:40px; }
//     .vo-stat-num { font-family:"Cormorant Garamond",serif; font-size:28px; font-weight:700; color:#14a0a5; }
//     .vo-stat-lbl { font-size:12px; color:rgba(255,255,255,0.5); margin-top:2px; }
//     .vo-float-cards { display:flex; flex-direction:column; gap:14px; }
//     .vo-float-card { background:rgba(255,255,255,0.06); border:1px solid rgba(255,255,255,0.1); backdrop-filter:blur(12px); border-radius:16px; padding:18px 22px; display:flex; align-items:center; gap:14px; transition:transform 0.3s; }
//     .vo-float-card:hover { transform:translateX(6px); }
//     .vo-float-icon { width:46px; height:46px; border-radius:12px; display:flex; align-items:center; justify-content:center; font-size:22px; flex-shrink:0; }
//     .vo-float-title { font-size:14px; font-weight:700; color:#fff; margin-bottom:3px; }
//     .vo-float-desc  { font-size:12px; color:rgba(255,255,255,0.55); }
//     .vo-hospitals { padding:100px 0; background:#f8fafc; }
//     .vo-container { max-width:1200px; margin:0 auto; padding:0 24px; }
//     .vo-section-tag { display:inline-flex; align-items:center; gap:6px; background:rgba(13,115,119,0.1); border:1px solid rgba(13,115,119,0.25); color:#0d7377; font-size:11px; font-weight:700; letter-spacing:1.2px; text-transform:uppercase; padding:6px 14px; border-radius:100px; margin-bottom:16px; }
//     .vo-section-title { font-family:"Cormorant Garamond",serif; font-size:clamp(32px,4vw,52px); font-weight:700; color:#0a1628; line-height:1.15; margin-bottom:16px; }
//     .vo-section-title em { font-style:italic; color:#0d7377; }
//     .vo-controls { display:flex; gap:16px; margin-bottom:32px; flex-wrap:wrap; align-items:center; }
//     .vo-search { flex:1; min-width:260px; padding:12px 18px; border-radius:10px; border:1.5px solid #e2e8f0; font-size:14px; font-family:"DM Sans",sans-serif; outline:none; background:#fff; transition:border-color 0.2s; }
//     .vo-search:focus { border-color:#0d7377; }
//     .vo-cats { display:flex; gap:8px; flex-wrap:wrap; }
//     .vo-cat { padding:8px 14px; border-radius:100px; border:1.5px solid #e2e8f0; background:#fff; font-size:13px; font-weight:600; color:#475569; cursor:pointer; transition:all 0.2s; white-space:nowrap; font-family:"DM Sans",sans-serif; }
//     .vo-cat:hover { border-color:#0d7377; color:#0d7377; }
//     .vo-cat.active { background:#0d7377; border-color:#0d7377; color:#fff; }
//     .vo-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(300px,1fr)); gap:28px; }
//     .vo-card { background:#fff; border-radius:20px; overflow:hidden; box-shadow:0 4px 32px rgba(0,0,0,0.08); transition:transform 0.28s,box-shadow 0.28s; cursor:pointer; border:1px solid #f1f5f9; }
//     .vo-card:hover { transform:translateY(-6px); box-shadow:0 12px 48px rgba(0,0,0,0.14); }
//     .vo-card-top { height:140px; display:flex; align-items:center; justify-content:center; position:relative; font-size:52px; }
//     .vo-card-badge { position:absolute; top:14px; right:14px; background:rgba(255,255,255,0.2); backdrop-filter:blur(8px); border:1px solid rgba(255,255,255,0.3); border-radius:20px; padding:4px 12px; font-size:11px; font-weight:700; color:#fff; }
//     .vo-card-body { padding:20px 22px 22px; }
//     .vo-card-name { font-family:"Cormorant Garamond",serif; font-size:20px; font-weight:700; color:#0a1628; margin-bottom:4px; }
//     .vo-card-type { font-size:12px; font-weight:700; color:#0d7377; text-transform:uppercase; letter-spacing:0.5px; margin-bottom:8px; }
//     .vo-card-city { font-size:13px; color:#94a3b8; margin-bottom:14px; }
//     .vo-card-stats { display:flex; gap:16px; padding:12px 0; border-top:1px solid #f1f5f9; border-bottom:1px solid #f1f5f9; margin-bottom:14px; }
//     .vo-card-stat { text-align:center; flex:1; }
//     .vo-card-stat-num { font-size:15px; font-weight:700; color:#0a1628; }
//     .vo-card-stat-lbl { font-size:10px; color:#94a3b8; margin-top:2px; }
//     .vo-card-btn { width:100%; padding:11px; background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; border-radius:10px; font-size:13px; font-weight:700; cursor:pointer; font-family:"DM Sans",sans-serif; transition:opacity 0.2s; }
//     .vo-card-btn:hover { opacity:0.9; }
//     .vo-empty { grid-column:1/-1; text-align:center; padding:60px 0; color:#94a3b8; font-size:15px; }
//     @keyframes vopulse { 0%,100%{opacity:1}50%{opacity:0.45} }
//     .vo-skel { background:#e2e8f0; border-radius:8px; animation:vopulse 1.5s ease-in-out infinite; }
//     .vo-cta { padding:100px 0; background:linear-gradient(135deg,#0a1628,#0d2444); text-align:center; }
//     .vo-cta-title { font-family:"Cormorant Garamond",serif; font-size:clamp(32px,4vw,52px); font-weight:700; color:#fff; margin-bottom:16px; }
//     .vo-cta-title em { font-style:italic; color:#14a0a5; }
//     .vo-cta-desc { font-size:16px; color:rgba(255,255,255,0.65); max-width:520px; margin:0 auto 40px; line-height:1.7; }
//     .vo-plans { display:flex; gap:20px; justify-content:center; flex-wrap:wrap; margin-bottom:36px; }
//     .vo-plan { background:rgba(255,255,255,0.08); border:1px solid rgba(255,255,255,0.15); border-radius:16px; padding:22px 26px; min-width:180px; transition:background 0.2s; }
//     .vo-plan:hover { background:rgba(255,255,255,0.12); }
//     .vo-plan.featured { background:linear-gradient(135deg,#0d7377,#14a0a5); border-color:transparent; }
//     .vo-plan-name { font-size:12px; font-weight:700; color:rgba(255,255,255,0.65); text-transform:uppercase; letter-spacing:1px; margin-bottom:8px; }
//     .vo-plan-price { font-family:"Cormorant Garamond",serif; font-size:30px; font-weight:700; color:#fff; line-height:1; margin-bottom:4px; }
//     .vo-plan-period { font-size:12px; color:rgba(255,255,255,0.5); margin-bottom:10px; }
//     .vo-plan-features { font-size:12px; color:rgba(255,255,255,0.6); line-height:1.6; }
//     .vo-how { padding:100px 0; background:#fff; }
//     .vo-how-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:28px; margin-top:56px; }
//     .vo-how-card { text-align:center; padding:28px 20px; border-radius:20px; background:#f8fafc; border:1px solid #f1f5f9; transition:transform 0.25s,box-shadow 0.25s; }
//     .vo-how-card:hover { transform:translateY(-4px); box-shadow:0 4px 24px rgba(0,0,0,0.08); }
//     .vo-how-step { width:46px; height:46px; border-radius:50%; background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; font-size:18px; font-weight:800; display:flex; align-items:center; justify-content:center; margin:0 auto 14px; }
//     .vo-how-icon { font-size:30px; margin-bottom:12px; }
//     .vo-how-title { font-size:15px; font-weight:700; color:#0a1628; margin-bottom:8px; }
//     .vo-how-desc  { font-size:13px; color:#475569; line-height:1.6; }
//     .vo-footer { background:#0a1628; padding:56px 0 24px; border-top:1px solid rgba(255,255,255,0.06); }
//     .vo-footer-inner { max-width:1200px; margin:0 auto; padding:0 24px 40px; display:grid; grid-template-columns:2fr 1fr 1fr; gap:48px; }
//     .vo-footer-desc { font-size:14px; color:rgba(255,255,255,0.5); line-height:1.7; margin-top:10px; max-width:280px; }
//     .vo-footer-col h4 { font-size:12px; font-weight:700; color:rgba(255,255,255,0.85); text-transform:uppercase; letter-spacing:1px; margin-bottom:14px; }
//     .vo-footer-col ul { list-style:none; }
//     .vo-footer-col ul li { margin-bottom:8px; }
//     .vo-footer-col ul li a { font-size:13px; color:rgba(255,255,255,0.5); cursor:pointer; transition:color 0.2s; }
//     .vo-footer-col ul li a:hover { color:rgba(255,255,255,0.85); }
//     .vo-footer-bottom { max-width:1200px; margin:0 auto; padding:20px 24px 0; border-top:1px solid rgba(255,255,255,0.07); display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:12px; font-size:13px; color:rgba(255,255,255,0.35); }
//     @media(max-width:860px) { .vo-hero-inner{grid-template-columns:1fr;} .vo-float-cards{display:none;} .vo-how-grid{grid-template-columns:repeat(2,1fr);} .vo-footer-inner{grid-template-columns:1fr;gap:28px;} .vo-nav{padding:0 20px;} .vo-nav-sa{display:none;} }
//     @media(max-width:600px) { .vo-grid{grid-template-columns:1fr;} .vo-how-grid{grid-template-columns:1fr;} .vo-stats{gap:20px;} .vo-plans{flex-direction:column;align-items:center;} }
//   `;

//   const scrollTo = (id) =>
//     document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

//   return (
//     <div style={{ fontFamily: "DM Sans,sans-serif" }}>
//       <style>{css}</style>

//       {/* ── Navbar ── */}
//       <div className="vo-nav">
//         <div className="vo-logo">
//           <div className="vo-logo-icon">🏥</div>
//           <div>
//             <div className="vo-logo-text">VidyaOne</div>
//             <div className="vo-logo-sub">Healthcare Platform</div>
//           </div>
//         </div>
//         <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
//           <a
//             onClick={() => scrollTo("hospitals")}
//             style={{
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 14,
//               fontWeight: 500,
//               cursor: "pointer",
//             }}
//           >
//             Hospitals
//           </a>
//           <a
//             onClick={() => scrollTo("how")}
//             style={{
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 14,
//               fontWeight: 500,
//               cursor: "pointer",
//             }}
//           >
//             How It Works
//           </a>
//           <button className="vo-nav-btn" onClick={() => setRegOpen(true)}>
//             Register Hospital
//           </button>
//           <button className="vo-nav-sa" onClick={() => navigate("/superadmin")}>
//             🛡️ Admin
//           </button>
//         </div>
//       </div>

//       {/* ── Hero ── */}
//       <section className="vo-hero" id="home">
//         <div className="vo-hero-inner">
//           <div>
//             <div className="vo-badge">
//               🌟 India's Healthcare Management Platform
//             </div>
//             <h1>
//               Find & Book
//               <br />
//               <em>Top Hospitals</em>
//               <br />
//               Near You
//             </h1>
//             <p className="vo-hero-desc">
//               From Dental to Ortho, Ayurved to Cardiology — discover verified
//               hospitals, book appointments instantly, and manage your health all
//               in one place.
//             </p>
//             <div className="vo-actions">
//               <button
//                 className="vo-btn-primary"
//                 onClick={() => scrollTo("hospitals")}
//               >
//                 Find Hospitals →
//               </button>
//               <button
//                 className="vo-btn-outline"
//                 onClick={() => setRegOpen(true)}
//               >
//                 Register Your Hospital
//               </button>
//             </div>
//             <div className="vo-stats">
//               {[
//                 ["200+", "Hospitals"],
//                 ["50K+", "Patients"],
//                 ["7", "Specialities"],
//               ].map(([n, l]) => (
//                 <div key={l}>
//                   <div className="vo-stat-num">{n}</div>
//                   <div className="vo-stat-lbl">{l}</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//           <div className="vo-float-cards">
//             {[
//               {
//                 icon: "🦷",
//                 bg: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                 title: "Dental Care",
//                 desc: "Root canal, implants, whitening",
//               },
//               {
//                 icon: "🦴",
//                 bg: "linear-gradient(135deg,#1a3a6b,#2563eb)",
//                 title: "Ortho Care",
//                 desc: "Joint replacement, physiotherapy",
//               },
//               {
//                 icon: "🌿",
//                 bg: "linear-gradient(135deg,#166534,#16a34a)",
//                 title: "Ayurved",
//                 desc: "Panchakarma, herbal treatments",
//               },
//               {
//                 icon: "❤️",
//                 bg: "linear-gradient(135deg,#881337,#dc2626)",
//                 title: "Cardiology",
//                 desc: "Heart care, ECG, consultations",
//               },
//             ].map((c) => (
//               <div key={c.title} className="vo-float-card">
//                 <div className="vo-float-icon" style={{ background: c.bg }}>
//                   {c.icon}
//                 </div>
//                 <div>
//                   <div className="vo-float-title">{c.title}</div>
//                   <div className="vo-float-desc">{c.desc}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ── Hospital Grid ── */}
//       <section className="vo-hospitals" id="hospitals">
//         <div className="vo-container">
//           <div style={{ textAlign: "center", marginBottom: 48 }}>
//             <div className="vo-section-tag">🏥 Browse Hospitals</div>
//             <h2 className="vo-section-title">
//               Find the Right
//               <br />
//               <em>Hospital for You</em>
//             </h2>
//             <p
//               style={{
//                 fontSize: 16,
//                 color: "#475569",
//                 maxWidth: 540,
//                 margin: "0 auto",
//                 lineHeight: 1.7,
//               }}
//             >
//               Browse verified hospitals by speciality or city.
//             </p>
//           </div>
//           <div className="vo-controls">
//             <input
//               className="vo-search"
//               placeholder="🔍 Search by hospital name or city..."
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//             />
//             <div className="vo-cats">
//               {CATEGORIES.map((c) => (
//                 <button
//                   key={c.id}
//                   className={`vo-cat${activeCat === c.id ? " active" : ""}`}
//                   onClick={() => setActiveCat(c.id)}
//                 >
//                   {c.icon} {c.label}
//                 </button>
//               ))}
//             </div>
//           </div>
//           <div style={{ fontSize: 13, color: "#94a3b8", marginBottom: 24 }}>
//             {loading
//               ? "Loading hospitals..."
//               : `${filtered.length} hospital${filtered.length !== 1 ? "s" : ""} found`}
//           </div>
//           <div className="vo-grid">
//             {loading ? (
//               [1, 2, 3, 4, 5, 6].map((i) => (
//                 <div
//                   key={i}
//                   style={{
//                     background: "#fff",
//                     borderRadius: 20,
//                     overflow: "hidden",
//                     boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
//                   }}
//                 >
//                   <div className="vo-skel" style={{ height: 140 }} />
//                   <div style={{ padding: "20px 22px" }}>
//                     <div
//                       className="vo-skel"
//                       style={{ height: 20, width: "70%", marginBottom: 8 }}
//                     />
//                     <div
//                       className="vo-skel"
//                       style={{ height: 13, width: "40%", marginBottom: 14 }}
//                     />
//                     <div
//                       className="vo-skel"
//                       style={{ height: 38, borderRadius: 10 }}
//                     />
//                   </div>
//                 </div>
//               ))
//             ) : filtered.length === 0 ? (
//               <div className="vo-empty">No hospitals match your search.</div>
//             ) : (
//               filtered.map((h) => {
//                 const type = (h.type || "general").toLowerCase();
//                 const grad = CAT_GRADIENTS[type] || CAT_GRADIENTS.general;
//                 const cat = CATEGORIES.find((c) => c.id === type);
//                 return (
//                   <div
//                     key={h._id}
//                     className="vo-card"
//                     onClick={() => navigate(`/hospital/${h.slug}`)}
//                   >
//                     <div className="vo-card-top" style={{ background: grad }}>
//                       <div className="vo-card-badge">
//                         {cat?.label || "Hospital"}
//                       </div>
//                       {h.logoUrl ? (
//                         <img
//                           src={h.logoUrl}
//                           alt={h.name}
//                           style={{
//                             width: 70,
//                             height: 70,
//                             borderRadius: "50%",
//                             objectFit: "cover",
//                             border: "3px solid rgba(255,255,255,0.3)",
//                           }}
//                         />
//                       ) : (
//                         <span>{CAT_ICONS[type] || "🏥"}</span>
//                       )}
//                     </div>
//                     <div className="vo-card-body">
//                       <div className="vo-card-name">{h.name}</div>
//                       <div className="vo-card-type">
//                         {cat?.icon} {cat?.label || "Hospital"}
//                       </div>
//                       <div className="vo-card-city">
//                         📍 {h.city || "Location not specified"}
//                       </div>
//                       <div className="vo-card-stats">
//                         {[
//                           ["Patients", h.statPatients],
//                           ["Doctors", h.statDoctors],
//                           ["Rating", h.statRating],
//                         ].map(([l, v]) => (
//                           <div key={l} className="vo-card-stat">
//                             <div className="vo-card-stat-num">{v || "—"}</div>
//                             <div className="vo-card-stat-lbl">{l}</div>
//                           </div>
//                         ))}
//                       </div>
//                       <button className="vo-card-btn">
//                         Book Appointment →
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>
//       </section>

//       {/* ── How It Works ── */}
//       <section className="vo-how" id="how">
//         <div className="vo-container">
//           <div style={{ textAlign: "center" }}>
//             <div className="vo-section-tag">Simple Process</div>
//             <h2 className="vo-section-title">
//               How <em>VidyaOne</em> Works
//             </h2>
//             <p
//               style={{
//                 fontSize: 16,
//                 color: "#475569",
//                 maxWidth: 520,
//                 margin: "0 auto",
//                 lineHeight: 1.7,
//               }}
//             >
//               Get your hospital live in under 10 minutes. No technical knowledge
//               required.
//             </p>
//           </div>
//           <div className="vo-how-grid">
//             {[
//               {
//                 step: "1",
//                 icon: "🏥",
//                 title: "Register Hospital",
//                 desc: "Fill your hospital details, choose a plan and pay securely.",
//               },
//               {
//                 step: "2",
//                 icon: "⚙️",
//                 title: "Setup Your Panel",
//                 desc: "Add your doctors, services and pricing inside your admin dashboard.",
//               },
//               {
//                 step: "3",
//                 icon: "📅",
//                 title: "Patients Book",
//                 desc: "Patients find your hospital on VidyaOne and book appointments online.",
//               },
//               {
//                 step: "4",
//                 icon: "📊",
//                 title: "Manage Everything",
//                 desc: "Track appointments, patients, billing and doctor availability in one panel.",
//               },
//             ].map((s) => (
//               <div key={s.step} className="vo-how-card">
//                 <div className="vo-how-step">{s.step}</div>
//                 <div className="vo-how-icon">{s.icon}</div>
//                 <div className="vo-how-title">{s.title}</div>
//                 <div className="vo-how-desc">{s.desc}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ── CTA / Pricing ── */}
//       <section className="vo-cta" id="pricing">
//         <div className="vo-container">
//           <div
//             className="vo-section-tag"
//             style={{
//               background: "rgba(201,168,76,0.15)",
//               borderColor: "rgba(201,168,76,0.3)",
//               color: "#c9a845",
//             }}
//           >
//             💰 Simple Pricing
//           </div>
//           <h2 className="vo-cta-title">
//             Register Your Hospital
//             <br />
//             <em>Start Today</em>
//           </h2>
//           <p className="vo-cta-desc">
//             Choose a plan that fits your hospital. All plans include full admin
//             panel, patient management & WhatsApp integration.
//           </p>
//           <div className="vo-plans">
//             {[
//               {
//                 name: "Starter",
//                 price: "₹999",
//                 period: "/month",
//                 features: "3 Doctors · Appointments · Patients",
//               },
//               {
//                 name: "Pro",
//                 price: "₹1,999",
//                 period: "/month",
//                 features: "10 Doctors · Billing · WhatsApp",
//                 featured: true,
//               },
//               {
//                 name: "Enterprise",
//                 price: "₹3,499",
//                 period: "/month",
//                 features: "Unlimited · Priority Support · Custom Domain",
//               },
//             ].map((p) => (
//               <div
//                 key={p.name}
//                 className={`vo-plan${p.featured ? " featured" : ""}`}
//               >
//                 <div className="vo-plan-name">{p.name}</div>
//                 <div className="vo-plan-price">{p.price}</div>
//                 <div className="vo-plan-period">{p.period}</div>
//                 <div className="vo-plan-features">{p.features}</div>
//               </div>
//             ))}
//           </div>
//           <button
//             className="vo-btn-primary"
//             style={{ fontSize: 16, padding: "15px 36px" }}
//             onClick={() => setRegOpen(true)}
//           >
//             Register Your Hospital Now →
//           </button>
//           <div
//             style={{
//               fontSize: 12,
//               color: "rgba(255,255,255,0.4)",
//               marginTop: 14,
//             }}
//           >
//             14-day free trial · No credit card required to start
//           </div>
//         </div>
//       </section>

//       {/* ── Footer ── */}
//       <footer className="vo-footer">
//         <div className="vo-footer-inner">
//           <div>
//             <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//               <div
//                 style={{
//                   width: 36,
//                   height: 36,
//                   background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   borderRadius: 10,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   fontSize: 18,
//                 }}
//               >
//                 🏥
//               </div>
//               <div>
//                 <div
//                   style={{
//                     fontFamily: "Cormorant Garamond,serif",
//                     fontSize: 20,
//                     fontWeight: 700,
//                     color: "#fff",
//                   }}
//                 >
//                   VidyaOne
//                 </div>
//                 <div
//                   style={{
//                     fontSize: 9,
//                     color: "#c9a845",
//                     letterSpacing: 2,
//                     textTransform: "uppercase",
//                   }}
//                 >
//                   Healthcare Platform
//                 </div>
//               </div>
//             </div>
//             <p className="vo-footer-desc">
//               India's premier hospital management platform. Connecting patients
//               with the best hospitals.
//             </p>
//           </div>
//           <div className="vo-footer-col">
//             <h4>For Hospitals</h4>
//             <ul>
//               {[
//                 "Register Hospital",
//                 "Pricing Plans",
//                 "How It Works",
//                 "Admin Login",
//               ].map((s) => (
//                 <li key={s}>
//                   <a>{s}</a>
//                 </li>
//               ))}
//             </ul>
//           </div>
//           <div className="vo-footer-col">
//             <h4>Specialities</h4>
//             <ul>
//               {[
//                 "🦷 Dental",
//                 "🦴 Ortho",
//                 "🌿 Ayurved",
//                 "❤️ Cardiology",
//                 "👁️ Eye Care",
//                 "👶 Pediatric",
//               ].map((s) => (
//                 <li key={s}>
//                   <a>{s}</a>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>
//         <div className="vo-footer-bottom">
//           <p>© 2026 VidyaOne Healthcare Platform. All rights reserved.</p>
//           <div style={{ display: "flex", gap: 24 }}>
//             <a>Privacy Policy</a>
//             <a>Terms of Service</a>
//           </div>
//         </div>
//       </footer>

//       {regOpen && (
//         <RegisterModal
//           onClose={() => {
//             setRegOpen(false);
//             fetchHospitals();
//           }}
//         />
//       )}
//     </div>
//   );
// }

////////////// responsive navbar ///////
// // ============================================================
// // src/pages/VidyaOne.js
// // ✅ Super Admin button added in navbar
// // ✅ Registration secret key gate added
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";

// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// const PEARLSMILE_CARD = {
//   _id: "pearlsmile-static",
//   name: "PearlSmile Dental Hospital",
//   type: "dental",
//   city: "Pune, Maharashtra",
//   slug: "pearlsmile",
//   statPatients: "18K+",
//   statDoctors: "20+",
//   statRating: "4.9★",
//   logoUrl: "",
// };

// const CATEGORIES = [
//   { id: "all", label: "All", icon: "🏥" },
//   { id: "dental", label: "Dental", icon: "🦷" },
//   { id: "ortho", label: "Ortho", icon: "🦴" },
//   { id: "ayurved", label: "Ayurved", icon: "🌿" },
//   { id: "cardiology", label: "Cardiology", icon: "❤️" },
//   { id: "eye", label: "Eye", icon: "👁️" },
//   { id: "pediatric", label: "Pediatric", icon: "👶" },
//   { id: "general", label: "General", icon: "➕" },
// ];

// const CAT_GRADIENTS = {
//   dental: "linear-gradient(135deg,#0d7377,#14a0a5)",
//   ortho: "linear-gradient(135deg,#1a3a6b,#2563eb)",
//   ayurved: "linear-gradient(135deg,#166534,#16a34a)",
//   cardiology: "linear-gradient(135deg,#881337,#dc2626)",
//   eye: "linear-gradient(135deg,#4338ca,#7c3aed)",
//   pediatric: "linear-gradient(135deg,#c2410c,#f97316)",
//   general: "linear-gradient(135deg,#0f766e,#0d9488)",
// };

// const CAT_ICONS = {
//   dental: "🦷",
//   ortho: "🦴",
//   ayurved: "🌿",
//   cardiology: "❤️",
//   eye: "👁️",
//   pediatric: "👶",
//   general: "➕",
// };

// const TYPES = [
//   "Dental",
//   "Ortho",
//   "Ayurved",
//   "Cardiology",
//   "Eye",
//   "Pediatric",
//   "General",
// ];
// const PLANS = [
//   { id: "starter", label: "Starter — ₹999/mo" },
//   { id: "pro", label: "Pro — ₹1,999/mo" },
//   { id: "enterprise", label: "Enterprise — ₹3,499/mo" },
// ];

// // ── Register Modal ────────────────────────────────────────────
// function RegisterModal({ onClose }) {
//   const [step, setStep] = useState(1);
//   const [saving, setSaving] = useState(false);
//   const [msg, setMsg] = useState("");
//   const [form, setForm] = useState({
//     name: "",
//     type: "",
//     phone: "",
//     whatsapp: "",
//     email: "",
//     address: "",
//     city: "",
//     established: "",
//     plan: "pro",
//     adminId: "",
//     password: "",
//     registrationKey: "", // ✅ Secret key field
//   });
//   const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

//   const inp = {
//     width: "100%",
//     padding: "10px 14px",
//     borderRadius: 8,
//     border: "1.5px solid #e2e8f0",
//     fontSize: 14,
//     fontFamily: "DM Sans,sans-serif",
//     outline: "none",
//     background: "#f8fafc",
//     boxSizing: "border-box",
//     marginTop: 4,
//     marginBottom: 12,
//   };
//   const lbl = {
//     fontSize: 12,
//     fontWeight: 600,
//     color: "#475569",
//     display: "block",
//   };

//   const next = () => {
//     if (!form.name || !form.type || !form.phone || !form.city) {
//       setMsg("Please fill all required fields.");
//       return;
//     }
//     setMsg("");
//     setStep(2);
//   };

//   const submit = async () => {
//     if (!form.adminId || !form.password) {
//       setMsg("Admin ID and password are required.");
//       return;
//     }
//     // ✅ Frontend key validation
//     if (!form.registrationKey.trim()) {
//       setMsg(
//         "Registration access key is required. Contact VidyaOne on WhatsApp to get your key.",
//       );
//       return;
//     }
//     setSaving(true);
//     setMsg("");
//     try {
//       const slug = form.name
//         .toLowerCase()
//         .replace(/[^a-z0-9]+/g, "-")
//         .replace(/^-|-$/g, "");
//       const res = await fetch(`${API_URL}/hospitals/register`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ ...form, slug }),
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message || "Registration failed");
//       setStep(3);
//     } catch (err) {
//       setMsg(err.message);
//     }
//     setSaving(false);
//   };

//   return (
//     <div
//       style={{
//         position: "fixed",
//         inset: 0,
//         background: "rgba(0,0,0,0.6)",
//         backdropFilter: "blur(4px)",
//         zIndex: 2000,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: 20,
//       }}
//       onClick={(e) => {
//         if (e.target === e.currentTarget) onClose();
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 24,
//           width: "100%",
//           maxWidth: 520,
//           maxHeight: "90vh",
//           overflowY: "auto",
//           boxShadow: "0 24px 80px rgba(0,0,0,0.4)",
//         }}
//       >
//         {/* Header */}
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             padding: "22px 28px",
//             borderRadius: "24px 24px 0 0",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div>
//             <div style={{ fontSize: 17, fontWeight: 700, color: "#fff" }}>
//               {step === 3
//                 ? "🎉 Registration Successful!"
//                 : "🏥 Register Your Hospital"}
//             </div>
//             <div
//               style={{
//                 fontSize: 12,
//                 color: "rgba(255,255,255,0.55)",
//                 marginTop: 3,
//               }}
//             >
//               {step === 1 && "Step 1 of 2 — Hospital Details"}
//               {step === 2 && "Step 2 of 2 — Admin Credentials & Access Key"}
//               {step === 3 && "Your hospital is now live on VidyaOne!"}
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.12)",
//               border: "none",
//               color: "#fff",
//               width: 32,
//               height: 32,
//               borderRadius: "50%",
//               fontSize: 16,
//               cursor: "pointer",
//             }}
//           >
//             ✕
//           </button>
//         </div>

//         <form
//           autoComplete="off"
//           onSubmit={(e) => e.preventDefault()}
//           style={{ padding: 28 }}
//         >
//           {/* Error message */}
//           {msg && (
//             <div
//               style={{
//                 background: "#fef2f2",
//                 border: "1px solid #fecaca",
//                 borderRadius: 8,
//                 padding: "10px 14px",
//                 marginBottom: 16,
//                 fontSize: 13,
//                 color: "#dc2626",
//               }}
//             >
//               {msg}
//             </div>
//           )}

//           {/* ── STEP 1: Hospital Details ── */}
//           {step === 1 && (
//             <>
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "1fr 1fr",
//                   gap: "0 14px",
//                 }}
//               >
//                 <div>
//                   <label style={lbl}>Hospital Name *</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. Sai Dental Hospital"
//                     autoComplete="off"
//                     value={form.name}
//                     onChange={(e) => set("name", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Hospital Type *</label>
//                   <select
//                     style={inp}
//                     value={form.type}
//                     onChange={(e) => set("type", e.target.value)}
//                   >
//                     <option value="">Select type</option>
//                     {TYPES.map((t) => (
//                       <option key={t} value={t.toLowerCase()}>
//                         {t}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 <div>
//                   <label style={lbl}>Phone *</label>
//                   <input
//                     style={inp}
//                     placeholder="+91 98765 43210"
//                     autoComplete="off"
//                     value={form.phone}
//                     onChange={(e) => set("phone", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>WhatsApp (no +)</label>
//                   <input
//                     style={inp}
//                     placeholder="919876543210"
//                     autoComplete="off"
//                     value={form.whatsapp}
//                     onChange={(e) => set("whatsapp", e.target.value)}
//                   />
//                 </div>
//                 <div style={{ gridColumn: "1/-1" }}>
//                   <label style={lbl}>Email</label>
//                   <input
//                     style={inp}
//                     type="email"
//                     placeholder="info@hospital.com"
//                     autoComplete="off"
//                     value={form.email}
//                     onChange={(e) => set("email", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Address</label>
//                   <input
//                     style={inp}
//                     placeholder="Street, Area"
//                     autoComplete="off"
//                     value={form.address}
//                     onChange={(e) => set("address", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>City *</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. Mumbai, MH"
//                     autoComplete="off"
//                     value={form.city}
//                     onChange={(e) => set("city", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Established Year</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. 2010"
//                     autoComplete="off"
//                     value={form.established}
//                     onChange={(e) => set("established", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Plan</label>
//                   <select
//                     style={inp}
//                     value={form.plan}
//                     onChange={(e) => set("plan", e.target.value)}
//                   >
//                     {PLANS.map((p) => (
//                       <option key={p.id} value={p.id}>
//                         {p.label}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//               <button
//                 onClick={next}
//                 style={{
//                   width: "100%",
//                   padding: 13,
//                   background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 10,
//                   fontSize: 15,
//                   fontWeight: 700,
//                   cursor: "pointer",
//                 }}
//               >
//                 Next: Create Admin Account →
//               </button>
//             </>
//           )}

//           {/* ── STEP 2: Admin Credentials + Secret Key ── */}
//           {step === 2 && (
//             <>
//               <div
//                 style={{
//                   background: "#f0fdf4",
//                   border: "1px solid #bbf7d0",
//                   borderRadius: 10,
//                   padding: "12px 16px",
//                   marginBottom: 20,
//                   fontSize: 13,
//                   color: "#166534",
//                 }}
//               >
//                 ✅ <strong>{form.name}</strong> · {form.city}
//               </div>

//               <label style={lbl}>Admin ID *</label>
//               <input
//                 style={inp}
//                 placeholder="e.g. saidental_admin"
//                 autoComplete="off"
//                 value={form.adminId}
//                 onChange={(e) => set("adminId", e.target.value)}
//               />

//               <label style={lbl}>Password *</label>
//               <input
//                 style={inp}
//                 type="password"
//                 placeholder="Create a strong password"
//                 autoComplete="new-password"
//                 value={form.password}
//                 onChange={(e) => set("password", e.target.value)}
//               />

//               <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 18 }}>
//                 💡 Save these credentials — you'll use them to login to your
//                 admin panel.
//               </div>

//               {/* ✅ Secret Key Field */}
//               <div
//                 style={{
//                   background: "#fffbeb",
//                   border: "1px solid #fde68a",
//                   borderRadius: 10,
//                   padding: "14px 16px",
//                   marginBottom: 16,
//                 }}
//               >
//                 <div
//                   style={{
//                     fontSize: 13,
//                     fontWeight: 700,
//                     color: "#92400e",
//                     marginBottom: 8,
//                   }}
//                 >
//                   🔐 Registration Access Key Required
//                 </div>
//                 <div
//                   style={{
//                     fontSize: 12,
//                     color: "#92400e",
//                     marginBottom: 10,
//                     lineHeight: 1.5,
//                   }}
//                 >
//                   This is a private key provided by VidyaOne. Without it,
//                   registration is not allowed. Contact us on WhatsApp to get
//                   your key before registering.
//                 </div>
//                 <a
//                   href="https://wa.me/918793608083?text=Hi%20VidyaOne%2C%20I%20want%20to%20register%20my%20hospital.%20Please%20share%20the%20registration%20key."
//                   target="_blank"
//                   rel="noreferrer"
//                   style={{
//                     display: "inline-flex",
//                     alignItems: "center",
//                     gap: 8,
//                     margin: "6px 0 12px",
//                     background: "#25d366",
//                     color: "#fff",
//                     borderRadius: 8,
//                     padding: "9px 16px",
//                     fontSize: 13,
//                     fontWeight: 700,
//                     textDecoration: "none",
//                   }}
//                 >
//                   <svg width="15" height="15" viewBox="0 0 24 24" fill="white">
//                     <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                     <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                   </svg>
//                   Contact VidyaOne Owner — +91 87936 08083
//                 </a>
//                 <label style={{ ...lbl, color: "#92400e" }}>Access Key *</label>
//                 <input
//                   style={{
//                     ...inp,
//                     marginBottom: 0,
//                     background: "#fff",
//                     border: "1.5px solid #fcd34d",
//                   }}
//                   type="password"
//                   placeholder="Enter your VidyaOne registration key"
//                   autoComplete="new-password"
//                   autoComplete="new-password"
//                   value={form.registrationKey}
//                   onChange={(e) => set("registrationKey", e.target.value)}
//                 />
//               </div>

//               <div style={{ display: "flex", gap: 10 }}>
//                 <button
//                   onClick={() => setStep(1)}
//                   style={{
//                     flex: 1,
//                     padding: 13,
//                     background: "#f1f5f9",
//                     color: "#475569",
//                     border: "none",
//                     borderRadius: 10,
//                     fontSize: 14,
//                     fontWeight: 600,
//                     cursor: "pointer",
//                   }}
//                 >
//                   ← Back
//                 </button>
//                 <button
//                   onClick={submit}
//                   disabled={saving}
//                   style={{
//                     flex: 2,
//                     padding: 13,
//                     background: saving
//                       ? "#94a3b8"
//                       : "linear-gradient(135deg,#0d7377,#14a0a5)",
//                     color: "#fff",
//                     border: "none",
//                     borderRadius: 10,
//                     fontSize: 15,
//                     fontWeight: 700,
//                     cursor: saving ? "not-allowed" : "pointer",
//                   }}
//                 >
//                   {saving ? "Registering..." : "🚀 Complete Registration"}
//                 </button>
//               </div>
//             </>
//           )}

//           {/* ── STEP 3: Success ── */}
//           {step === 3 && (
//             <div style={{ textAlign: "center", padding: "20px 0" }}>
//               <div style={{ fontSize: 64, marginBottom: 16 }}>🎉</div>
//               <h3
//                 style={{
//                   fontSize: 22,
//                   fontWeight: 700,
//                   color: "#0a1628",
//                   marginBottom: 8,
//                 }}
//               >
//                 {form.name}
//               </h3>
//               <p
//                 style={{
//                   fontSize: 14,
//                   color: "#64748b",
//                   marginBottom: 24,
//                   lineHeight: 1.6,
//                 }}
//               >
//                 Your hospital is now live on VidyaOne! Use your credentials to
//                 login.
//               </p>
//               <div
//                 style={{
//                   background: "#f0fdf4",
//                   border: "1px solid #bbf7d0",
//                   borderRadius: 12,
//                   padding: "16px 20px",
//                   marginBottom: 24,
//                   textAlign: "left",
//                 }}
//               >
//                 <div
//                   style={{
//                     fontSize: 12,
//                     fontWeight: 700,
//                     color: "#16a34a",
//                     marginBottom: 8,
//                   }}
//                 >
//                   YOUR LOGIN CREDENTIALS
//                 </div>
//                 <div style={{ fontSize: 14, color: "#166534" }}>
//                   Admin ID: <strong>{form.adminId}</strong>
//                 </div>
//                 <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>
//                   (Save your password securely)
//                 </div>
//               </div>
//               <button
//                 onClick={onClose}
//                 style={{
//                   width: "100%",
//                   padding: 13,
//                   background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 10,
//                   fontSize: 15,
//                   fontWeight: 700,
//                   cursor: "pointer",
//                 }}
//               >
//                 Done ✓
//               </button>
//             </div>
//           )}
//         </form>
//       </div>
//     </div>
//   );
// }

// // ── Main VidyaOne Page ────────────────────────────────────────
// export default function VidyaOne() {
//   const navigate = useNavigate();
//   const [hospitals, setHospitals] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState("");
//   const [activeCat, setActiveCat] = useState("all");
//   const [regOpen, setRegOpen] = useState(false);
//   const [menuOpen, setMenuOpen] = useState(false);

//   const fetchHospitals = useCallback(async () => {
//     setLoading(true);
//     try {
//       const r = await fetch(`${API_URL}/hospitals`);
//       if (r.ok) {
//         const data = await r.json();
//         setHospitals(Array.isArray(data) ? data : []);
//       }
//     } catch (_) {}
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     fetchHospitals();
//   }, [fetchHospitals]);

//   const allHospitals = [
//     PEARLSMILE_CARD,
//     ...hospitals.filter((h) => h.slug !== "pearlsmile"),
//   ];

//   const filtered = allHospitals.filter((h) => {
//     const matchCat =
//       activeCat === "all" || (h.type || "").toLowerCase() === activeCat;
//     const q = search.toLowerCase();
//     const matchSearch =
//       !q ||
//       (h.name || "").toLowerCase().includes(q) ||
//       (h.city || "").toLowerCase().includes(q) ||
//       (h.type || "").toLowerCase().includes(q);
//     return matchCat && matchSearch;
//   });

//   const css = `
//     * { box-sizing: border-box; margin: 0; padding: 0; }
//     body { font-family: "DM Sans", sans-serif; }
//     .vo-nav { position:fixed; top:0; left:0; right:0; z-index:1000; background:rgba(10,22,40,0.97); backdrop-filter:blur(12px); border-bottom:1px solid rgba(255,255,255,0.06); display:flex; align-items:center; justify-content:space-between; padding:0 40px; height:68px; }
//     .vo-logo { display:flex; align-items:center; gap:10px; cursor:pointer; }
//     .vo-logo-icon { width:38px; height:38px; background:linear-gradient(135deg,#0d7377,#14a0a5); border-radius:10px; display:flex; align-items:center; justify-content:center; font-size:20px; }
//     .vo-logo-text { font-family:"Cormorant Garamond",serif; font-size:22px; font-weight:700; color:#fff; }
//     .vo-logo-sub  { font-size:9px; color:#c9a845; letter-spacing:2px; text-transform:uppercase; }
//     .vo-nav-btn { background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; padding:10px 22px; border-radius:8px; font-weight:700; font-size:13px; font-family:"DM Sans",sans-serif; cursor:pointer; transition:opacity 0.2s; }
//     .vo-nav-btn:hover { opacity:0.9; }
//     .vo-nav-sa { background:rgba(255,255,255,0.06); color:rgba(255,255,255,0.55); border:1px solid rgba(255,255,255,0.12); padding:8px 14px; border-radius:8px; font-weight:600; font-size:12px; font-family:"DM Sans",sans-serif; cursor:pointer; transition:all 0.2s; }
//     .vo-nav-sa:hover { background:rgba(255,255,255,0.12); color:#fff; }
//     .vo-hamburger { display:none; flex-direction:column; gap:5px; background:none; border:none; cursor:pointer; padding:6px; z-index:1100; }
//     .vo-hamburger span { display:block; width:24px; height:2px; background:#fff; border-radius:2px; transition:all 0.3s; }
//     .vo-mobile-menu { display:none; position:fixed; top:68px; left:0; right:0; background:rgba(10,22,40,0.98); backdrop-filter:blur(16px); border-bottom:1px solid rgba(255,255,255,0.08); padding:16px 20px 20px; flex-direction:column; gap:12px; z-index:999; }
//     .vo-mobile-menu.open { display:flex; }
//     .vo-mobile-link { color:rgba(255,255,255,0.8); font-size:15px; font-weight:500; padding:10px 0; border-bottom:1px solid rgba(255,255,255,0.07); cursor:pointer; font-family:"DM Sans",sans-serif; background:none; border-left:none; border-right:none; border-top:none; text-align:left; }
//     .vo-mobile-link:last-child { border-bottom:none; }
//     .vo-mobile-btn { width:100%; padding:12px; background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; border-radius:10px; font-size:14px; font-weight:700; cursor:pointer; font-family:"DM Sans",sans-serif; margin-top:4px; }
//     .vo-mobile-sa { width:100%; padding:10px; background:rgba(255,255,255,0.06); color:rgba(255,255,255,0.7); border:1px solid rgba(255,255,255,0.15); border-radius:10px; font-size:13px; font-weight:600; cursor:pointer; font-family:"DM Sans",sans-serif; margin-top:4px; }
//     .vo-hero { min-height:100vh; background:linear-gradient(135deg,#0a1628 0%,#0d2444 50%,#0a1f3a 100%); display:flex; align-items:center; padding-top:68px; position:relative; overflow:hidden; }
//     .vo-hero::before { content:""; position:absolute; top:-200px; right:-200px; width:600px; height:600px; background:radial-gradient(circle,rgba(13,115,119,0.15) 0%,transparent 70%); border-radius:50%; }
//     .vo-hero-inner { max-width:1200px; margin:0 auto; padding:80px 24px; display:grid; grid-template-columns:1fr 1fr; gap:60px; align-items:center; position:relative; z-index:1; }
//     .vo-badge { display:inline-flex; align-items:center; gap:8px; background:rgba(201,168,76,0.15); border:1px solid rgba(201,168,76,0.3); color:#c9a845; font-size:11px; font-weight:700; letter-spacing:1px; text-transform:uppercase; padding:7px 16px; border-radius:100px; margin-bottom:24px; }
//     .vo-hero h1 { font-family:"Cormorant Garamond",serif; font-size:clamp(40px,5vw,64px); font-weight:700; color:#fff; line-height:1.1; margin-bottom:20px; }
//     .vo-hero h1 em { font-style:italic; color:#14a0a5; }
//     .vo-hero-desc { font-size:16px; color:rgba(255,255,255,0.7); line-height:1.7; margin-bottom:36px; max-width:480px; }
//     .vo-actions { display:flex; gap:14px; flex-wrap:wrap; }
//     .vo-btn-primary { background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; padding:14px 28px; border-radius:10px; font-size:15px; font-weight:700; font-family:"DM Sans",sans-serif; cursor:pointer; transition:opacity 0.2s,transform 0.2s; }
//     .vo-btn-primary:hover { opacity:0.92; transform:translateY(-1px); }
//     .vo-btn-outline { background:transparent; color:#fff; border:1.5px solid rgba(255,255,255,0.3); padding:14px 28px; border-radius:10px; font-size:15px; font-weight:600; font-family:"DM Sans",sans-serif; cursor:pointer; transition:border-color 0.2s; }
//     .vo-btn-outline:hover { border-color:rgba(255,255,255,0.6); }
//     .vo-stats { display:flex; gap:32px; margin-top:40px; }
//     .vo-stat-num { font-family:"Cormorant Garamond",serif; font-size:28px; font-weight:700; color:#14a0a5; }
//     .vo-stat-lbl { font-size:12px; color:rgba(255,255,255,0.5); margin-top:2px; }
//     .vo-float-cards { display:flex; flex-direction:column; gap:14px; }
//     .vo-float-card { background:rgba(255,255,255,0.06); border:1px solid rgba(255,255,255,0.1); backdrop-filter:blur(12px); border-radius:16px; padding:18px 22px; display:flex; align-items:center; gap:14px; transition:transform 0.3s; }
//     .vo-float-card:hover { transform:translateX(6px); }
//     .vo-float-icon { width:46px; height:46px; border-radius:12px; display:flex; align-items:center; justify-content:center; font-size:22px; flex-shrink:0; }
//     .vo-float-title { font-size:14px; font-weight:700; color:#fff; margin-bottom:3px; }
//     .vo-float-desc  { font-size:12px; color:rgba(255,255,255,0.55); }
//     .vo-hospitals { padding:100px 0; background:#f8fafc; }
//     .vo-container { max-width:1200px; margin:0 auto; padding:0 24px; }
//     .vo-section-tag { display:inline-flex; align-items:center; gap:6px; background:rgba(13,115,119,0.1); border:1px solid rgba(13,115,119,0.25); color:#0d7377; font-size:11px; font-weight:700; letter-spacing:1.2px; text-transform:uppercase; padding:6px 14px; border-radius:100px; margin-bottom:16px; }
//     .vo-section-title { font-family:"Cormorant Garamond",serif; font-size:clamp(32px,4vw,52px); font-weight:700; color:#0a1628; line-height:1.15; margin-bottom:16px; }
//     .vo-section-title em { font-style:italic; color:#0d7377; }
//     .vo-controls { display:flex; gap:16px; margin-bottom:32px; flex-wrap:wrap; align-items:center; }
//     .vo-search { flex:1; min-width:260px; padding:12px 18px; border-radius:10px; border:1.5px solid #e2e8f0; font-size:14px; font-family:"DM Sans",sans-serif; outline:none; background:#fff; transition:border-color 0.2s; }
//     .vo-search:focus { border-color:#0d7377; }
//     .vo-cats { display:flex; gap:8px; flex-wrap:wrap; }
//     .vo-cat { padding:8px 14px; border-radius:100px; border:1.5px solid #e2e8f0; background:#fff; font-size:13px; font-weight:600; color:#475569; cursor:pointer; transition:all 0.2s; white-space:nowrap; font-family:"DM Sans",sans-serif; }
//     .vo-cat:hover { border-color:#0d7377; color:#0d7377; }
//     .vo-cat.active { background:#0d7377; border-color:#0d7377; color:#fff; }
//     .vo-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(300px,1fr)); gap:28px; }
//     .vo-card { background:#fff; border-radius:20px; overflow:hidden; box-shadow:0 4px 32px rgba(0,0,0,0.08); transition:transform 0.28s,box-shadow 0.28s; cursor:pointer; border:1px solid #f1f5f9; }
//     .vo-card:hover { transform:translateY(-6px); box-shadow:0 12px 48px rgba(0,0,0,0.14); }
//     .vo-card-top { height:140px; display:flex; align-items:center; justify-content:center; position:relative; font-size:52px; }
//     .vo-card-badge { position:absolute; top:14px; right:14px; background:rgba(255,255,255,0.2); backdrop-filter:blur(8px); border:1px solid rgba(255,255,255,0.3); border-radius:20px; padding:4px 12px; font-size:11px; font-weight:700; color:#fff; }
//     .vo-card-body { padding:20px 22px 22px; }
//     .vo-card-name { font-family:"Cormorant Garamond",serif; font-size:20px; font-weight:700; color:#0a1628; margin-bottom:4px; }
//     .vo-card-type { font-size:12px; font-weight:700; color:#0d7377; text-transform:uppercase; letter-spacing:0.5px; margin-bottom:8px; }
//     .vo-card-city { font-size:13px; color:#94a3b8; margin-bottom:14px; }
//     .vo-card-stats { display:flex; gap:16px; padding:12px 0; border-top:1px solid #f1f5f9; border-bottom:1px solid #f1f5f9; margin-bottom:14px; }
//     .vo-card-stat { text-align:center; flex:1; }
//     .vo-card-stat-num { font-size:15px; font-weight:700; color:#0a1628; }
//     .vo-card-stat-lbl { font-size:10px; color:#94a3b8; margin-top:2px; }
//     .vo-card-btn { width:100%; padding:11px; background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; border-radius:10px; font-size:13px; font-weight:700; cursor:pointer; font-family:"DM Sans",sans-serif; transition:opacity 0.2s; }
//     .vo-card-btn:hover { opacity:0.9; }
//     .vo-empty { grid-column:1/-1; text-align:center; padding:60px 0; color:#94a3b8; font-size:15px; }
//     @keyframes vopulse { 0%,100%{opacity:1}50%{opacity:0.45} }
//     .vo-skel { background:#e2e8f0; border-radius:8px; animation:vopulse 1.5s ease-in-out infinite; }
//     .vo-cta { padding:100px 0; background:linear-gradient(135deg,#0a1628,#0d2444); text-align:center; }
//     .vo-cta-title { font-family:"Cormorant Garamond",serif; font-size:clamp(32px,4vw,52px); font-weight:700; color:#fff; margin-bottom:16px; }
//     .vo-cta-title em { font-style:italic; color:#14a0a5; }
//     .vo-cta-desc { font-size:16px; color:rgba(255,255,255,0.65); max-width:520px; margin:0 auto 40px; line-height:1.7; }
//     .vo-plans { display:flex; gap:20px; justify-content:center; flex-wrap:wrap; margin-bottom:36px; }
//     .vo-plan { background:rgba(255,255,255,0.08); border:1px solid rgba(255,255,255,0.15); border-radius:16px; padding:22px 26px; min-width:180px; transition:background 0.2s; }
//     .vo-plan:hover { background:rgba(255,255,255,0.12); }
//     .vo-plan.featured { background:linear-gradient(135deg,#0d7377,#14a0a5); border-color:transparent; }
//     .vo-plan-name { font-size:12px; font-weight:700; color:rgba(255,255,255,0.65); text-transform:uppercase; letter-spacing:1px; margin-bottom:8px; }
//     .vo-plan-price { font-family:"Cormorant Garamond",serif; font-size:30px; font-weight:700; color:#fff; line-height:1; margin-bottom:4px; }
//     .vo-plan-period { font-size:12px; color:rgba(255,255,255,0.5); margin-bottom:10px; }
//     .vo-plan-features { font-size:12px; color:rgba(255,255,255,0.6); line-height:1.6; }
//     .vo-how { padding:100px 0; background:#fff; }
//     .vo-how-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:28px; margin-top:56px; }
//     .vo-how-card { text-align:center; padding:28px 20px; border-radius:20px; background:#f8fafc; border:1px solid #f1f5f9; transition:transform 0.25s,box-shadow 0.25s; }
//     .vo-how-card:hover { transform:translateY(-4px); box-shadow:0 4px 24px rgba(0,0,0,0.08); }
//     .vo-how-step { width:46px; height:46px; border-radius:50%; background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; font-size:18px; font-weight:800; display:flex; align-items:center; justify-content:center; margin:0 auto 14px; }
//     .vo-how-icon { font-size:30px; margin-bottom:12px; }
//     .vo-how-title { font-size:15px; font-weight:700; color:#0a1628; margin-bottom:8px; }
//     .vo-how-desc  { font-size:13px; color:#475569; line-height:1.6; }
//     .vo-footer { background:#0a1628; padding:56px 0 24px; border-top:1px solid rgba(255,255,255,0.06); }
//     .vo-footer-inner { max-width:1200px; margin:0 auto; padding:0 24px 40px; display:grid; grid-template-columns:2fr 1fr 1fr; gap:48px; }
//     .vo-footer-desc { font-size:14px; color:rgba(255,255,255,0.5); line-height:1.7; margin-top:10px; max-width:280px; }
//     .vo-footer-col h4 { font-size:12px; font-weight:700; color:rgba(255,255,255,0.85); text-transform:uppercase; letter-spacing:1px; margin-bottom:14px; }
//     .vo-footer-col ul { list-style:none; }
//     .vo-footer-col ul li { margin-bottom:8px; }
//     .vo-footer-col ul li a { font-size:13px; color:rgba(255,255,255,0.5); cursor:pointer; transition:color 0.2s; }
//     .vo-footer-col ul li a:hover { color:rgba(255,255,255,0.85); }
//     .vo-footer-bottom { max-width:1200px; margin:0 auto; padding:20px 24px 0; border-top:1px solid rgba(255,255,255,0.07); display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:12px; font-size:13px; color:rgba(255,255,255,0.35); }
//     @media(max-width:860px) { .vo-hero-inner{grid-template-columns:1fr;} .vo-float-cards{display:none;} .vo-how-grid{grid-template-columns:repeat(2,1fr);} .vo-footer-inner{grid-template-columns:1fr;gap:28px;} .vo-nav{padding:0 20px;} .vo-nav-sa{display:none;} .vo-nav-links{display:none;} .vo-hamburger{display:flex;} }
//     @media(max-width:600px) { .vo-grid{grid-template-columns:1fr;} .vo-how-grid{grid-template-columns:1fr;} .vo-stats{gap:20px;} .vo-plans{flex-direction:column;align-items:center;} }
//   `;

//   const scrollTo = (id) =>
//     document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

//   return (
//     <div style={{ fontFamily: "DM Sans,sans-serif" }}>
//       <style>{css}</style>

//       {/* ── Navbar ── */}
//       <div className="vo-nav">
//         <div className="vo-logo">
//           <div className="vo-logo-icon">🏥</div>
//           <div>
//             <div className="vo-logo-text">VidyaOne</div>
//             <div className="vo-logo-sub">Healthcare Platform</div>
//           </div>
//         </div>

//         {/* Desktop links */}
//         <div
//           className="vo-nav-links"
//           style={{ display: "flex", gap: 12, alignItems: "center" }}
//         >
//           <a
//             onClick={() => scrollTo("hospitals")}
//             style={{
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 14,
//               fontWeight: 500,
//               cursor: "pointer",
//             }}
//           >
//             Hospitals
//           </a>
//           <a
//             onClick={() => scrollTo("how")}
//             style={{
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 14,
//               fontWeight: 500,
//               cursor: "pointer",
//             }}
//           >
//             How It Works
//           </a>
//           <button className="vo-nav-btn" onClick={() => setRegOpen(true)}>
//             Register Hospital
//           </button>
//           <button className="vo-nav-sa" onClick={() => navigate("/superadmin")}>
//             🛡️ Admin
//           </button>
//         </div>

//         {/* Hamburger — mobile only */}
//         <button
//           className="vo-hamburger"
//           onClick={() => setMenuOpen((m) => !m)}
//           aria-label="Menu"
//         >
//           <span
//             style={{
//               transform: menuOpen ? "rotate(45deg) translate(5px,5px)" : "none",
//             }}
//           />
//           <span style={{ opacity: menuOpen ? 0 : 1 }} />
//           <span
//             style={{
//               transform: menuOpen
//                 ? "rotate(-45deg) translate(5px,-5px)"
//                 : "none",
//             }}
//           />
//         </button>
//       </div>

//       {/* Mobile Menu */}
//       <div className={`vo-mobile-menu${menuOpen ? " open" : ""}`}>
//         <button
//           className="vo-mobile-link"
//           onClick={() => {
//             scrollTo("hospitals");
//             setMenuOpen(false);
//           }}
//         >
//           🏥 Hospitals
//         </button>
//         <button
//           className="vo-mobile-link"
//           onClick={() => {
//             scrollTo("how");
//             setMenuOpen(false);
//           }}
//         >
//           ⚙️ How It Works
//         </button>
//         <button
//           className="vo-mobile-link"
//           onClick={() => {
//             scrollTo("pricing");
//             setMenuOpen(false);
//           }}
//         >
//           💰 Pricing
//         </button>
//         <button
//           className="vo-mobile-btn"
//           onClick={() => {
//             setRegOpen(true);
//             setMenuOpen(false);
//           }}
//         >
//           Register Your Hospital →
//         </button>
//         <button
//           className="vo-mobile-sa"
//           onClick={() => {
//             navigate("/superadmin");
//             setMenuOpen(false);
//           }}
//         >
//           🛡️ Admin
//         </button>
//       </div>

//       {/* ── Hero ── */}
//       <section className="vo-hero" id="home">
//         <div className="vo-hero-inner">
//           <div>
//             <div className="vo-badge">
//               🌟 India's Healthcare Management Platform
//             </div>
//             <h1>
//               Find & Book
//               <br />
//               <em>Top Hospitals</em>
//               <br />
//               Near You
//             </h1>
//             <p className="vo-hero-desc">
//               From Dental to Ortho, Ayurved to Cardiology — discover verified
//               hospitals, book appointments instantly, and manage your health all
//               in one place.
//             </p>
//             <div className="vo-actions">
//               <button
//                 className="vo-btn-primary"
//                 onClick={() => scrollTo("hospitals")}
//               >
//                 Find Hospitals →
//               </button>
//               <button
//                 className="vo-btn-outline"
//                 onClick={() => setRegOpen(true)}
//               >
//                 Register Your Hospital
//               </button>
//             </div>
//             <div className="vo-stats">
//               {[
//                 ["200+", "Hospitals"],
//                 ["50K+", "Patients"],
//                 ["7", "Specialities"],
//               ].map(([n, l]) => (
//                 <div key={l}>
//                   <div className="vo-stat-num">{n}</div>
//                   <div className="vo-stat-lbl">{l}</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//           <div className="vo-float-cards">
//             {[
//               {
//                 icon: "🦷",
//                 bg: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                 title: "Dental Care",
//                 desc: "Root canal, implants, whitening",
//               },
//               {
//                 icon: "🦴",
//                 bg: "linear-gradient(135deg,#1a3a6b,#2563eb)",
//                 title: "Ortho Care",
//                 desc: "Joint replacement, physiotherapy",
//               },
//               {
//                 icon: "🌿",
//                 bg: "linear-gradient(135deg,#166534,#16a34a)",
//                 title: "Ayurved",
//                 desc: "Panchakarma, herbal treatments",
//               },
//               {
//                 icon: "❤️",
//                 bg: "linear-gradient(135deg,#881337,#dc2626)",
//                 title: "Cardiology",
//                 desc: "Heart care, ECG, consultations",
//               },
//             ].map((c) => (
//               <div key={c.title} className="vo-float-card">
//                 <div className="vo-float-icon" style={{ background: c.bg }}>
//                   {c.icon}
//                 </div>
//                 <div>
//                   <div className="vo-float-title">{c.title}</div>
//                   <div className="vo-float-desc">{c.desc}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ── Hospital Grid ── */}
//       <section className="vo-hospitals" id="hospitals">
//         <div className="vo-container">
//           <div style={{ textAlign: "center", marginBottom: 48 }}>
//             <div className="vo-section-tag">🏥 Browse Hospitals</div>
//             <h2 className="vo-section-title">
//               Find the Right
//               <br />
//               <em>Hospital for You</em>
//             </h2>
//             <p
//               style={{
//                 fontSize: 16,
//                 color: "#475569",
//                 maxWidth: 540,
//                 margin: "0 auto",
//                 lineHeight: 1.7,
//               }}
//             >
//               Browse verified hospitals by speciality or city.
//             </p>
//           </div>
//           <div className="vo-controls">
//             <input
//               className="vo-search"
//               placeholder="🔍 Search by hospital name or city..."
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               autoComplete="off"
//             />
//             <div className="vo-cats">
//               {CATEGORIES.map((c) => (
//                 <button
//                   key={c.id}
//                   className={`vo-cat${activeCat === c.id ? " active" : ""}`}
//                   onClick={() => setActiveCat(c.id)}
//                 >
//                   {c.icon} {c.label}
//                 </button>
//               ))}
//             </div>
//           </div>
//           <div style={{ fontSize: 13, color: "#94a3b8", marginBottom: 24 }}>
//             {loading
//               ? "Loading hospitals..."
//               : `${filtered.length} hospital${filtered.length !== 1 ? "s" : ""} found`}
//           </div>
//           <div className="vo-grid">
//             {loading ? (
//               [1, 2, 3, 4, 5, 6].map((i) => (
//                 <div
//                   key={i}
//                   style={{
//                     background: "#fff",
//                     borderRadius: 20,
//                     overflow: "hidden",
//                     boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
//                   }}
//                 >
//                   <div className="vo-skel" style={{ height: 140 }} />
//                   <div style={{ padding: "20px 22px" }}>
//                     <div
//                       className="vo-skel"
//                       style={{ height: 20, width: "70%", marginBottom: 8 }}
//                     />
//                     <div
//                       className="vo-skel"
//                       style={{ height: 13, width: "40%", marginBottom: 14 }}
//                     />
//                     <div
//                       className="vo-skel"
//                       style={{ height: 38, borderRadius: 10 }}
//                     />
//                   </div>
//                 </div>
//               ))
//             ) : filtered.length === 0 ? (
//               <div className="vo-empty">No hospitals match your search.</div>
//             ) : (
//               filtered.map((h) => {
//                 const type = (h.type || "general").toLowerCase();
//                 const grad = CAT_GRADIENTS[type] || CAT_GRADIENTS.general;
//                 const cat = CATEGORIES.find((c) => c.id === type);
//                 return (
//                   <div
//                     key={h._id}
//                     className="vo-card"
//                     onClick={() => navigate(`/hospital/${h.slug}`)}
//                   >
//                     <div className="vo-card-top" style={{ background: grad }}>
//                       <div className="vo-card-badge">
//                         {cat?.label || "Hospital"}
//                       </div>
//                       {h.logoUrl ? (
//                         <img
//                           src={h.logoUrl}
//                           alt={h.name}
//                           style={{
//                             width: 70,
//                             height: 70,
//                             borderRadius: "50%",
//                             objectFit: "cover",
//                             border: "3px solid rgba(255,255,255,0.3)",
//                           }}
//                         />
//                       ) : (
//                         <span>{CAT_ICONS[type] || "🏥"}</span>
//                       )}
//                     </div>
//                     <div className="vo-card-body">
//                       <div className="vo-card-name">{h.name}</div>
//                       <div className="vo-card-type">
//                         {cat?.icon} {cat?.label || "Hospital"}
//                       </div>
//                       <div className="vo-card-city">
//                         📍 {h.city || "Location not specified"}
//                       </div>
//                       <div className="vo-card-stats">
//                         {[
//                           ["Patients", h.statPatients],
//                           ["Doctors", h.statDoctors],
//                           ["Rating", h.statRating],
//                         ].map(([l, v]) => (
//                           <div key={l} className="vo-card-stat">
//                             <div className="vo-card-stat-num">{v || "—"}</div>
//                             <div className="vo-card-stat-lbl">{l}</div>
//                           </div>
//                         ))}
//                       </div>
//                       <button className="vo-card-btn">
//                         Book Appointment →
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>
//       </section>

//       {/* ── How It Works ── */}
//       <section className="vo-how" id="how">
//         <div className="vo-container">
//           <div style={{ textAlign: "center" }}>
//             <div className="vo-section-tag">Simple Process</div>
//             <h2 className="vo-section-title">
//               How <em>VidyaOne</em> Works
//             </h2>
//             <p
//               style={{
//                 fontSize: 16,
//                 color: "#475569",
//                 maxWidth: 520,
//                 margin: "0 auto",
//                 lineHeight: 1.7,
//               }}
//             >
//               Get your hospital live in under 10 minutes. No technical knowledge
//               required.
//             </p>
//           </div>
//           <div className="vo-how-grid">
//             {[
//               {
//                 step: "1",
//                 icon: "🏥",
//                 title: "Register Hospital",
//                 desc: "Fill your hospital details, choose a plan and pay securely.",
//               },
//               {
//                 step: "2",
//                 icon: "⚙️",
//                 title: "Setup Your Panel",
//                 desc: "Add your doctors, services and pricing inside your admin dashboard.",
//               },
//               {
//                 step: "3",
//                 icon: "📅",
//                 title: "Patients Book",
//                 desc: "Patients find your hospital on VidyaOne and book appointments online.",
//               },
//               {
//                 step: "4",
//                 icon: "📊",
//                 title: "Manage Everything",
//                 desc: "Track appointments, patients, billing and doctor availability in one panel.",
//               },
//             ].map((s) => (
//               <div key={s.step} className="vo-how-card">
//                 <div className="vo-how-step">{s.step}</div>
//                 <div className="vo-how-icon">{s.icon}</div>
//                 <div className="vo-how-title">{s.title}</div>
//                 <div className="vo-how-desc">{s.desc}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ── CTA / Pricing ── */}
//       <section className="vo-cta" id="pricing">
//         <div className="vo-container">
//           <div
//             className="vo-section-tag"
//             style={{
//               background: "rgba(201,168,76,0.15)",
//               borderColor: "rgba(201,168,76,0.3)",
//               color: "#c9a845",
//             }}
//           >
//             💰 Simple Pricing
//           </div>
//           <h2 className="vo-cta-title">
//             Register Your Hospital
//             <br />
//             <em>Start Today</em>
//           </h2>
//           <p className="vo-cta-desc">
//             Choose a plan that fits your hospital. All plans include full admin
//             panel, patient management & WhatsApp integration.
//           </p>
//           <div className="vo-plans">
//             {[
//               {
//                 name: "Starter",
//                 price: "₹999",
//                 period: "/month",
//                 features: "3 Doctors · Appointments · Patients",
//               },
//               {
//                 name: "Pro",
//                 price: "₹1,999",
//                 period: "/month",
//                 features: "10 Doctors · Billing · WhatsApp",
//                 featured: true,
//               },
//               {
//                 name: "Enterprise",
//                 price: "₹3,499",
//                 period: "/month",
//                 features: "Unlimited · Priority Support · Custom Domain",
//               },
//             ].map((p) => (
//               <div
//                 key={p.name}
//                 className={`vo-plan${p.featured ? " featured" : ""}`}
//               >
//                 <div className="vo-plan-name">{p.name}</div>
//                 <div className="vo-plan-price">{p.price}</div>
//                 <div className="vo-plan-period">{p.period}</div>
//                 <div className="vo-plan-features">{p.features}</div>
//               </div>
//             ))}
//           </div>
//           <button
//             className="vo-btn-primary"
//             style={{ fontSize: 16, padding: "15px 36px" }}
//             onClick={() => setRegOpen(true)}
//           >
//             Register Your Hospital Now →
//           </button>
//           <div
//             style={{
//               fontSize: 12,
//               color: "rgba(255,255,255,0.4)",
//               marginTop: 14,
//             }}
//           >
//             14-day free trial · No credit card required to start
//           </div>
//         </div>
//       </section>

//       {/* ── Footer ── */}
//       <footer className="vo-footer">
//         <div className="vo-footer-inner">
//           <div>
//             <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//               <div
//                 style={{
//                   width: 36,
//                   height: 36,
//                   background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   borderRadius: 10,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   fontSize: 18,
//                 }}
//               >
//                 🏥
//               </div>
//               <div>
//                 <div
//                   style={{
//                     fontFamily: "Cormorant Garamond,serif",
//                     fontSize: 20,
//                     fontWeight: 700,
//                     color: "#fff",
//                   }}
//                 >
//                   VidyaOne
//                 </div>
//                 <div
//                   style={{
//                     fontSize: 9,
//                     color: "#c9a845",
//                     letterSpacing: 2,
//                     textTransform: "uppercase",
//                   }}
//                 >
//                   Healthcare Platform
//                 </div>
//               </div>
//             </div>
//             <p className="vo-footer-desc">
//               India's premier hospital management platform. Connecting patients
//               with the best hospitals.
//             </p>
//           </div>
//           <div className="vo-footer-col">
//             <h4>For Hospitals</h4>
//             <ul>
//               {[
//                 "Register Hospital",
//                 "Pricing Plans",
//                 "How It Works",
//                 "Admin Login",
//               ].map((s) => (
//                 <li key={s}>
//                   <a>{s}</a>
//                 </li>
//               ))}
//             </ul>
//           </div>
//           <div className="vo-footer-col">
//             <h4>Specialities</h4>
//             <ul>
//               {[
//                 "🦷 Dental",
//                 "🦴 Ortho",
//                 "🌿 Ayurved",
//                 "❤️ Cardiology",
//                 "👁️ Eye Care",
//                 "👶 Pediatric",
//               ].map((s) => (
//                 <li key={s}>
//                   <a>{s}</a>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>
//         <div className="vo-footer-bottom">
//           <p>© 2026 VidyaOne Healthcare Platform. All rights reserved.</p>
//           <div style={{ display: "flex", gap: 24 }}>
//             <a>Privacy Policy</a>
//             <a>Terms of Service</a>
//           </div>
//         </div>
//       </footer>

//       {regOpen && (
//         <RegisterModal
//           onClose={() => {
//             setRegOpen(false);
//             fetchHospitals();
//           }}
//         />
//       )}
//     </div>
//   );
// }

// pranjeev main
// // ============================================================
// // src/pages/PranJeev.js  (renamed from VidyaOne.js)
// // ✅ Full rebrand: VidyaOne → PranJeev
// // ✅ Super Admin button in navbar
// // ✅ Registration secret key gate
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";

// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// const PEARLSMILE_CARD = {
//   _id: "pearlsmile-static",
//   name: "PearlSmile Dental Hospital",
//   type: "dental",
//   city: "Pune, Maharashtra",
//   slug: "pearlsmile",
//   statPatients: "18K+",
//   statDoctors: "20+",
//   statRating: "4.9★",
//   logoUrl: "",
// };

// const CATEGORIES = [
//   { id: "all", label: "All", icon: "🏥" },
//   { id: "dental", label: "Dental", icon: "🦷" },
//   { id: "ortho", label: "Ortho", icon: "🦴" },
//   { id: "ayurved", label: "Ayurved", icon: "🌿" },
//   { id: "cardiology", label: "Cardiology", icon: "❤️" },
//   { id: "eye", label: "Eye", icon: "👁️" },
//   { id: "pediatric", label: "Pediatric", icon: "👶" },
//   { id: "general", label: "General", icon: "➕" },
// ];

// const CAT_GRADIENTS = {
//   dental: "linear-gradient(135deg,#0d7377,#14a0a5)",
//   ortho: "linear-gradient(135deg,#1a3a6b,#2563eb)",
//   ayurved: "linear-gradient(135deg,#166534,#16a34a)",
//   cardiology: "linear-gradient(135deg,#881337,#dc2626)",
//   eye: "linear-gradient(135deg,#4338ca,#7c3aed)",
//   pediatric: "linear-gradient(135deg,#c2410c,#f97316)",
//   general: "linear-gradient(135deg,#0f766e,#0d9488)",
// };

// const CAT_ICONS = {
//   dental: "🦷",
//   ortho: "🦴",
//   ayurved: "🌿",
//   cardiology: "❤️",
//   eye: "👁️",
//   pediatric: "👶",
//   general: "➕",
// };

// const TYPES = [
//   "Dental",
//   "Ortho",
//   "Ayurved",
//   "Cardiology",
//   "Eye",
//   "Pediatric",
//   "General",
// ];
// const PLANS = [
//   { id: "starter", label: "Starter — ₹999/mo" },
//   { id: "pro", label: "Pro — ₹1,999/mo" },
//   { id: "enterprise", label: "Enterprise — ₹3,499/mo" },
// ];

// // ── Register Modal ────────────────────────────────────────────
// function RegisterModal({ onClose }) {
//   const [step, setStep] = useState(1);
//   const [saving, setSaving] = useState(false);
//   const [msg, setMsg] = useState("");
//   const [form, setForm] = useState({
//     name: "",
//     type: "",
//     phone: "",
//     whatsapp: "",
//     email: "",
//     address: "",
//     city: "",
//     established: "",
//     plan: "pro",
//     adminId: "",
//     password: "",
//     registrationKey: "",
//   });
//   const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

//   const inp = {
//     width: "100%",
//     padding: "10px 14px",
//     borderRadius: 8,
//     border: "1.5px solid #e2e8f0",
//     fontSize: 14,
//     fontFamily: "DM Sans,sans-serif",
//     outline: "none",
//     background: "#f8fafc",
//     boxSizing: "border-box",
//     marginTop: 4,
//     marginBottom: 12,
//   };
//   const lbl = {
//     fontSize: 12,
//     fontWeight: 600,
//     color: "#475569",
//     display: "block",
//   };

//   const next = () => {
//     if (!form.name || !form.type || !form.phone || !form.city) {
//       setMsg("Please fill all required fields.");
//       return;
//     }
//     setMsg("");
//     setStep(2);
//   };

//   const submit = async () => {
//     if (!form.adminId || !form.password) {
//       setMsg("Admin ID and password are required.");
//       return;
//     }
//     if (!form.registrationKey.trim()) {
//       setMsg(
//         "Registration access key is required. Contact PranJeev on WhatsApp to get your key.",
//       );
//       return;
//     }
//     setSaving(true);
//     setMsg("");
//     try {
//       const slug = form.name
//         .toLowerCase()
//         .replace(/[^a-z0-9]+/g, "-")
//         .replace(/^-|-$/g, "");
//       const res = await fetch(`${API_URL}/hospitals/register`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ ...form, slug }),
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message || "Registration failed");
//       setStep(3);
//     } catch (err) {
//       setMsg(err.message);
//     }
//     setSaving(false);
//   };

//   return (
//     <div
//       style={{
//         position: "fixed",
//         inset: 0,
//         background: "rgba(0,0,0,0.6)",
//         backdropFilter: "blur(4px)",
//         zIndex: 2000,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: 20,
//       }}
//       onClick={(e) => {
//         if (e.target === e.currentTarget) onClose();
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 24,
//           width: "100%",
//           maxWidth: 520,
//           maxHeight: "90vh",
//           overflowY: "auto",
//           boxShadow: "0 24px 80px rgba(0,0,0,0.4)",
//         }}
//       >
//         {/* Header */}
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             padding: "22px 28px",
//             borderRadius: "24px 24px 0 0",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div>
//             <div style={{ fontSize: 17, fontWeight: 700, color: "#fff" }}>
//               {step === 3
//                 ? "🎉 Registration Successful!"
//                 : "🏥 Register Your Hospital"}
//             </div>
//             <div
//               style={{
//                 fontSize: 12,
//                 color: "rgba(255,255,255,0.55)",
//                 marginTop: 3,
//               }}
//             >
//               {step === 1 && "Step 1 of 2 — Hospital Details"}
//               {step === 2 && "Step 2 of 2 — Admin Credentials & Access Key"}
//               {step === 3 && "Your hospital is now live on PranJeev!"}
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.12)",
//               border: "none",
//               color: "#fff",
//               width: 32,
//               height: 32,
//               borderRadius: "50%",
//               fontSize: 16,
//               cursor: "pointer",
//             }}
//           >
//             ✕
//           </button>
//         </div>

//         <form
//           autoComplete="off"
//           onSubmit={(e) => e.preventDefault()}
//           style={{ padding: 28 }}
//         >
//           {msg && (
//             <div
//               style={{
//                 background: "#fef2f2",
//                 border: "1px solid #fecaca",
//                 borderRadius: 8,
//                 padding: "10px 14px",
//                 marginBottom: 16,
//                 fontSize: 13,
//                 color: "#dc2626",
//               }}
//             >
//               {msg}
//             </div>
//           )}

//           {/* STEP 1 */}
//           {step === 1 && (
//             <>
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "1fr 1fr",
//                   gap: "0 14px",
//                 }}
//               >
//                 <div>
//                   <label style={lbl}>Hospital Name *</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. Sai Dental Hospital"
//                     autoComplete="off"
//                     value={form.name}
//                     onChange={(e) => set("name", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Hospital Type *</label>
//                   <select
//                     style={inp}
//                     value={form.type}
//                     onChange={(e) => set("type", e.target.value)}
//                   >
//                     <option value="">Select type</option>
//                     {TYPES.map((t) => (
//                       <option key={t} value={t.toLowerCase()}>
//                         {t}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 <div>
//                   <label style={lbl}>Phone *</label>
//                   <input
//                     style={inp}
//                     placeholder="+91 98765 43210"
//                     autoComplete="off"
//                     value={form.phone}
//                     onChange={(e) => set("phone", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>WhatsApp (no +)</label>
//                   <input
//                     style={inp}
//                     placeholder="919876543210"
//                     autoComplete="off"
//                     value={form.whatsapp}
//                     onChange={(e) => set("whatsapp", e.target.value)}
//                   />
//                 </div>
//                 <div style={{ gridColumn: "1/-1" }}>
//                   <label style={lbl}>Email</label>
//                   <input
//                     style={inp}
//                     type="email"
//                     placeholder="info@hospital.com"
//                     autoComplete="off"
//                     value={form.email}
//                     onChange={(e) => set("email", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Address</label>
//                   <input
//                     style={inp}
//                     placeholder="Street, Area"
//                     autoComplete="off"
//                     value={form.address}
//                     onChange={(e) => set("address", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>City *</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. Mumbai, MH"
//                     autoComplete="off"
//                     value={form.city}
//                     onChange={(e) => set("city", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Established Year</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. 2010"
//                     autoComplete="off"
//                     value={form.established}
//                     onChange={(e) => set("established", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Plan</label>
//                   <select
//                     style={inp}
//                     value={form.plan}
//                     onChange={(e) => set("plan", e.target.value)}
//                   >
//                     {PLANS.map((p) => (
//                       <option key={p.id} value={p.id}>
//                         {p.label}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//               <button
//                 onClick={next}
//                 style={{
//                   width: "100%",
//                   padding: 13,
//                   background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 10,
//                   fontSize: 15,
//                   fontWeight: 700,
//                   cursor: "pointer",
//                 }}
//               >
//                 Next: Create Admin Account →
//               </button>
//             </>
//           )}

//           {/* STEP 2 */}
//           {step === 2 && (
//             <>
//               <div
//                 style={{
//                   background: "#f0fdf4",
//                   border: "1px solid #bbf7d0",
//                   borderRadius: 10,
//                   padding: "12px 16px",
//                   marginBottom: 20,
//                   fontSize: 13,
//                   color: "#166534",
//                 }}
//               >
//                 ✅ <strong>{form.name}</strong> · {form.city}
//               </div>
//               <label style={lbl}>Admin ID *</label>
//               <input
//                 style={inp}
//                 placeholder="e.g. saidental_admin"
//                 autoComplete="off"
//                 value={form.adminId}
//                 onChange={(e) => set("adminId", e.target.value)}
//               />
//               <label style={lbl}>Password *</label>
//               <input
//                 style={inp}
//                 type="password"
//                 placeholder="Create a strong password"
//                 autoComplete="new-password"
//                 value={form.password}
//                 onChange={(e) => set("password", e.target.value)}
//               />
//               <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 18 }}>
//                 💡 Save these credentials — you'll use them to login to your
//                 admin panel.
//               </div>

//               {/* Secret Key */}
//               <div
//                 style={{
//                   background: "#fffbeb",
//                   border: "1px solid #fde68a",
//                   borderRadius: 10,
//                   padding: "14px 16px",
//                   marginBottom: 16,
//                 }}
//               >
//                 <div
//                   style={{
//                     fontSize: 13,
//                     fontWeight: 700,
//                     color: "#92400e",
//                     marginBottom: 8,
//                   }}
//                 >
//                   🔐 Registration Access Key Required
//                 </div>
//                 <div
//                   style={{
//                     fontSize: 12,
//                     color: "#92400e",
//                     marginBottom: 10,
//                     lineHeight: 1.5,
//                   }}
//                 >
//                   This is a private key provided by PranJeev. Without it,
//                   registration is not allowed. Contact us on WhatsApp to get
//                   your key before registering.
//                 </div>
//                 <a
//                   href="https://wa.me/918793608083?text=Hi%20PranJeev%2C%20I%20want%20to%20register%20my%20hospital.%20Please%20share%20the%20registration%20key."
//                   target="_blank"
//                   rel="noreferrer"
//                   style={{
//                     display: "inline-flex",
//                     alignItems: "center",
//                     gap: 8,
//                     margin: "6px 0 12px",
//                     background: "#25d366",
//                     color: "#fff",
//                     borderRadius: 8,
//                     padding: "9px 16px",
//                     fontSize: 13,
//                     fontWeight: 700,
//                     textDecoration: "none",
//                   }}
//                 >
//                   💬 Contact PranJeev Owner — +91 87936 08083
//                 </a>
//                 <label style={{ ...lbl, color: "#92400e" }}>Access Key *</label>
//                 <input
//                   style={{
//                     ...inp,
//                     marginBottom: 0,
//                     background: "#fff",
//                     border: "1.5px solid #fcd34d",
//                   }}
//                   type="password"
//                   placeholder="Enter your PranJeev registration key"
//                   autoComplete="new-password"
//                   value={form.registrationKey}
//                   onChange={(e) => set("registrationKey", e.target.value)}
//                 />
//               </div>

//               <div style={{ display: "flex", gap: 10 }}>
//                 <button
//                   onClick={() => setStep(1)}
//                   style={{
//                     flex: 1,
//                     padding: 13,
//                     background: "#f1f5f9",
//                     color: "#475569",
//                     border: "none",
//                     borderRadius: 10,
//                     fontSize: 14,
//                     fontWeight: 600,
//                     cursor: "pointer",
//                   }}
//                 >
//                   ← Back
//                 </button>
//                 <button
//                   onClick={submit}
//                   disabled={saving}
//                   style={{
//                     flex: 2,
//                     padding: 13,
//                     background: saving
//                       ? "#94a3b8"
//                       : "linear-gradient(135deg,#0d7377,#14a0a5)",
//                     color: "#fff",
//                     border: "none",
//                     borderRadius: 10,
//                     fontSize: 15,
//                     fontWeight: 700,
//                     cursor: saving ? "not-allowed" : "pointer",
//                   }}
//                 >
//                   {saving ? "Registering..." : "🚀 Complete Registration"}
//                 </button>
//               </div>
//             </>
//           )}

//           {/* STEP 3 */}
//           {step === 3 && (
//             <div style={{ textAlign: "center", padding: "20px 0" }}>
//               <div style={{ fontSize: 64, marginBottom: 16 }}>🎉</div>
//               <h3
//                 style={{
//                   fontSize: 22,
//                   fontWeight: 700,
//                   color: "#0a1628",
//                   marginBottom: 8,
//                 }}
//               >
//                 {form.name}
//               </h3>
//               <p
//                 style={{
//                   fontSize: 14,
//                   color: "#64748b",
//                   marginBottom: 24,
//                   lineHeight: 1.6,
//                 }}
//               >
//                 Your hospital is now live on PranJeev! Use your credentials to
//                 login.
//               </p>
//               <div
//                 style={{
//                   background: "#f0fdf4",
//                   border: "1px solid #bbf7d0",
//                   borderRadius: 12,
//                   padding: "16px 20px",
//                   marginBottom: 24,
//                   textAlign: "left",
//                 }}
//               >
//                 <div
//                   style={{
//                     fontSize: 12,
//                     fontWeight: 700,
//                     color: "#16a34a",
//                     marginBottom: 8,
//                   }}
//                 >
//                   YOUR LOGIN CREDENTIALS
//                 </div>
//                 <div style={{ fontSize: 14, color: "#166534" }}>
//                   Admin ID: <strong>{form.adminId}</strong>
//                 </div>
//                 <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>
//                   (Save your password securely)
//                 </div>
//               </div>
//               <button
//                 onClick={onClose}
//                 style={{
//                   width: "100%",
//                   padding: 13,
//                   background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 10,
//                   fontSize: 15,
//                   fontWeight: 700,
//                   cursor: "pointer",
//                 }}
//               >
//                 Done ✓
//               </button>
//             </div>
//           )}
//         </form>
//       </div>
//     </div>
//   );
// }

// // ── Main PranJeev Page ────────────────────────────────────────
// export default function PranJeev() {
//   const navigate = useNavigate();
//   const [hospitals, setHospitals] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState("");
//   const [activeCat, setActiveCat] = useState("all");
//   const [regOpen, setRegOpen] = useState(false);
//   const [menuOpen, setMenuOpen] = useState(false);

//   const fetchHospitals = useCallback(async () => {
//     setLoading(true);
//     try {
//       const r = await fetch(`${API_URL}/hospitals`);
//       if (r.ok) {
//         const data = await r.json();
//         setHospitals(Array.isArray(data) ? data : []);
//       }
//     } catch (_) {}
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     fetchHospitals();
//   }, [fetchHospitals]);

//   const allHospitals = [
//     PEARLSMILE_CARD,
//     ...hospitals.filter((h) => h.slug !== "pearlsmile"),
//   ];

//   const filtered = allHospitals.filter((h) => {
//     const matchCat =
//       activeCat === "all" || (h.type || "").toLowerCase() === activeCat;
//     const q = search.toLowerCase();
//     const matchSearch =
//       !q ||
//       (h.name || "").toLowerCase().includes(q) ||
//       (h.city || "").toLowerCase().includes(q) ||
//       (h.type || "").toLowerCase().includes(q);
//     return matchCat && matchSearch;
//   });

//   const css = `
//     * { box-sizing:border-box; margin:0; padding:0; }
//     body { font-family:"DM Sans",sans-serif; }
//     .vo-nav { position:fixed; top:0; left:0; right:0; z-index:1000; background:rgba(10,22,40,0.97); backdrop-filter:blur(12px); border-bottom:1px solid rgba(255,255,255,0.06); display:flex; align-items:center; justify-content:space-between; padding:0 40px; height:68px; }
//     .vo-logo { display:flex; align-items:center; gap:10px; cursor:pointer; }
//     .vo-logo-icon { width:38px; height:38px; background:linear-gradient(135deg,#0d7377,#14a0a5); border-radius:10px; display:flex; align-items:center; justify-content:center; font-size:20px; }
//     .vo-logo-text { font-family:"Cormorant Garamond",serif; font-size:22px; font-weight:700; color:#fff; }
//     .vo-logo-sub  { font-size:9px; color:#c9a845; letter-spacing:2px; text-transform:uppercase; }
//     .vo-nav-btn { background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; padding:10px 22px; border-radius:8px; font-weight:700; font-size:13px; font-family:"DM Sans",sans-serif; cursor:pointer; }
//     .vo-nav-sa  { background:rgba(255,255,255,0.06); color:rgba(255,255,255,0.55); border:1px solid rgba(255,255,255,0.12); padding:8px 14px; border-radius:8px; font-weight:600; font-size:12px; font-family:"DM Sans",sans-serif; cursor:pointer; }
//     .vo-nav-sa:hover { background:rgba(255,255,255,0.12); color:#fff; }
//     .vo-hamburger { display:none; flex-direction:column; gap:5px; background:none; border:none; cursor:pointer; padding:6px; z-index:1100; }
//     .vo-hamburger span { display:block; width:24px; height:2px; background:#fff; border-radius:2px; transition:all 0.3s; }
//     .vo-mobile-menu { display:none; position:fixed; top:68px; left:0; right:0; background:rgba(10,22,40,0.98); backdrop-filter:blur(16px); border-bottom:1px solid rgba(255,255,255,0.08); padding:16px 20px 20px; flex-direction:column; gap:12px; z-index:999; }
//     .vo-mobile-menu.open { display:flex; }
//     .vo-mobile-link { color:rgba(255,255,255,0.8); font-size:15px; font-weight:500; padding:10px 0; border-bottom:1px solid rgba(255,255,255,0.07); cursor:pointer; font-family:"DM Sans",sans-serif; background:none; border-left:none; border-right:none; border-top:none; text-align:left; }
//     .vo-mobile-btn { width:100%; padding:12px; background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; border-radius:10px; font-size:14px; font-weight:700; cursor:pointer; font-family:"DM Sans",sans-serif; margin-top:4px; }
//     .vo-mobile-sa  { width:100%; padding:10px; background:rgba(255,255,255,0.06); color:rgba(255,255,255,0.7); border:1px solid rgba(255,255,255,0.15); border-radius:10px; font-size:13px; font-weight:600; cursor:pointer; font-family:"DM Sans",sans-serif; }
//     .vo-hero { min-height:100vh; background:linear-gradient(135deg,#0a1628 0%,#0d2444 50%,#0a1f3a 100%); display:flex; align-items:center; padding-top:68px; position:relative; overflow:hidden; }
//     .vo-hero::before { content:""; position:absolute; top:-200px; right:-200px; width:600px; height:600px; background:radial-gradient(circle,rgba(13,115,119,0.15) 0%,transparent 70%); border-radius:50%; }
//     .vo-hero-inner { max-width:1200px; margin:0 auto; padding:80px 24px; display:grid; grid-template-columns:1fr 1fr; gap:60px; align-items:center; position:relative; z-index:1; }
//     .vo-badge { display:inline-flex; align-items:center; gap:8px; background:rgba(201,168,76,0.15); border:1px solid rgba(201,168,76,0.3); color:#c9a845; font-size:11px; font-weight:700; letter-spacing:1px; text-transform:uppercase; padding:7px 16px; border-radius:100px; margin-bottom:24px; }
//     .vo-hero h1 { font-family:"Cormorant Garamond",serif; font-size:clamp(40px,5vw,64px); font-weight:700; color:#fff; line-height:1.1; margin-bottom:20px; }
//     .vo-hero h1 em { font-style:italic; color:#14a0a5; }
//     .vo-hero-desc { font-size:16px; color:rgba(255,255,255,0.7); line-height:1.7; margin-bottom:36px; max-width:480px; }
//     .vo-actions { display:flex; gap:14px; flex-wrap:wrap; }
//     .vo-btn-primary { background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; padding:14px 28px; border-radius:10px; font-size:15px; font-weight:700; font-family:"DM Sans",sans-serif; cursor:pointer; transition:opacity 0.2s,transform 0.2s; }
//     .vo-btn-primary:hover { opacity:0.92; transform:translateY(-1px); }
//     .vo-btn-outline { background:transparent; color:#fff; border:1.5px solid rgba(255,255,255,0.3); padding:14px 28px; border-radius:10px; font-size:15px; font-weight:600; font-family:"DM Sans",sans-serif; cursor:pointer; }
//     .vo-stats { display:flex; gap:32px; margin-top:40px; }
//     .vo-stat-num { font-family:"Cormorant Garamond",serif; font-size:28px; font-weight:700; color:#14a0a5; }
//     .vo-stat-lbl { font-size:12px; color:rgba(255,255,255,0.5); margin-top:2px; }
//     .vo-float-cards { display:flex; flex-direction:column; gap:14px; }
//     .vo-float-card { background:rgba(255,255,255,0.06); border:1px solid rgba(255,255,255,0.1); backdrop-filter:blur(12px); border-radius:16px; padding:18px 22px; display:flex; align-items:center; gap:14px; transition:transform 0.3s; }
//     .vo-float-card:hover { transform:translateX(6px); }
//     .vo-float-icon { width:46px; height:46px; border-radius:12px; display:flex; align-items:center; justify-content:center; font-size:22px; flex-shrink:0; }
//     .vo-float-title { font-size:14px; font-weight:700; color:#fff; margin-bottom:3px; }
//     .vo-float-desc  { font-size:12px; color:rgba(255,255,255,0.55); }
//     .vo-hospitals { padding:100px 0; background:#f8fafc; }
//     .vo-container { max-width:1200px; margin:0 auto; padding:0 24px; }
//     .vo-section-tag { display:inline-flex; align-items:center; gap:6px; background:rgba(13,115,119,0.1); border:1px solid rgba(13,115,119,0.25); color:#0d7377; font-size:11px; font-weight:700; letter-spacing:1.2px; text-transform:uppercase; padding:6px 14px; border-radius:100px; margin-bottom:16px; }
//     .vo-section-title { font-family:"Cormorant Garamond",serif; font-size:clamp(32px,4vw,52px); font-weight:700; color:#0a1628; line-height:1.15; margin-bottom:16px; }
//     .vo-section-title em { font-style:italic; color:#0d7377; }
//     .vo-controls { display:flex; gap:16px; margin-bottom:32px; flex-wrap:wrap; align-items:center; }
//     .vo-search { flex:1; min-width:260px; padding:12px 18px; border-radius:10px; border:1.5px solid #e2e8f0; font-size:14px; font-family:"DM Sans",sans-serif; outline:none; background:#fff; transition:border-color 0.2s; }
//     .vo-search:focus { border-color:#0d7377; }
//     .vo-cats { display:flex; gap:8px; flex-wrap:wrap; }
//     .vo-cat { padding:8px 14px; border-radius:100px; border:1.5px solid #e2e8f0; background:#fff; font-size:13px; font-weight:600; color:#475569; cursor:pointer; transition:all 0.2s; white-space:nowrap; font-family:"DM Sans",sans-serif; }
//     .vo-cat:hover { border-color:#0d7377; color:#0d7377; }
//     .vo-cat.active { background:#0d7377; border-color:#0d7377; color:#fff; }
//     .vo-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(300px,1fr)); gap:28px; }
//     .vo-card { background:#fff; border-radius:20px; overflow:hidden; box-shadow:0 4px 32px rgba(0,0,0,0.08); transition:transform 0.28s,box-shadow 0.28s; cursor:pointer; border:1px solid #f1f5f9; }
//     .vo-card:hover { transform:translateY(-6px); box-shadow:0 12px 48px rgba(0,0,0,0.14); }
//     .vo-card-top { height:140px; display:flex; align-items:center; justify-content:center; position:relative; font-size:52px; }
//     .vo-card-badge { position:absolute; top:14px; right:14px; background:rgba(255,255,255,0.2); backdrop-filter:blur(8px); border:1px solid rgba(255,255,255,0.3); border-radius:20px; padding:4px 12px; font-size:11px; font-weight:700; color:#fff; }
//     .vo-card-body { padding:20px 22px 22px; }
//     .vo-card-name { font-family:"Cormorant Garamond",serif; font-size:20px; font-weight:700; color:#0a1628; margin-bottom:4px; }
//     .vo-card-type { font-size:12px; font-weight:700; color:#0d7377; text-transform:uppercase; letter-spacing:0.5px; margin-bottom:8px; }
//     .vo-card-city { font-size:13px; color:#94a3b8; margin-bottom:14px; }
//     .vo-card-stats { display:flex; gap:16px; padding:12px 0; border-top:1px solid #f1f5f9; border-bottom:1px solid #f1f5f9; margin-bottom:14px; }
//     .vo-card-stat { text-align:center; flex:1; }
//     .vo-card-stat-num { font-size:15px; font-weight:700; color:#0a1628; }
//     .vo-card-stat-lbl { font-size:10px; color:#94a3b8; margin-top:2px; }
//     .vo-card-btn { width:100%; padding:11px; background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; border-radius:10px; font-size:13px; font-weight:700; cursor:pointer; font-family:"DM Sans",sans-serif; }
//     .vo-empty { grid-column:1/-1; text-align:center; padding:60px 0; color:#94a3b8; font-size:15px; }
//     @keyframes vopulse { 0%,100%{opacity:1}50%{opacity:0.45} }
//     .vo-skel { background:#e2e8f0; border-radius:8px; animation:vopulse 1.5s ease-in-out infinite; }
//     .vo-cta { padding:100px 0; background:linear-gradient(135deg,#0a1628,#0d2444); text-align:center; }
//     .vo-cta-title { font-family:"Cormorant Garamond",serif; font-size:clamp(32px,4vw,52px); font-weight:700; color:#fff; margin-bottom:16px; }
//     .vo-cta-title em { font-style:italic; color:#14a0a5; }
//     .vo-cta-desc { font-size:16px; color:rgba(255,255,255,0.65); max-width:520px; margin:0 auto 40px; line-height:1.7; }
//     .vo-plans { display:flex; gap:20px; justify-content:center; flex-wrap:wrap; margin-bottom:36px; }
//     .vo-plan { background:rgba(255,255,255,0.08); border:1px solid rgba(255,255,255,0.15); border-radius:16px; padding:22px 26px; min-width:180px; }
//     .vo-plan.featured { background:linear-gradient(135deg,#0d7377,#14a0a5); border-color:transparent; }
//     .vo-plan-name { font-size:12px; font-weight:700; color:rgba(255,255,255,0.65); text-transform:uppercase; letter-spacing:1px; margin-bottom:8px; }
//     .vo-plan-price { font-family:"Cormorant Garamond",serif; font-size:30px; font-weight:700; color:#fff; line-height:1; margin-bottom:4px; }
//     .vo-plan-period { font-size:12px; color:rgba(255,255,255,0.5); margin-bottom:10px; }
//     .vo-plan-features { font-size:12px; color:rgba(255,255,255,0.6); line-height:1.6; }
//     .vo-how { padding:100px 0; background:#fff; }
//     .vo-how-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:28px; margin-top:56px; }
//     .vo-how-card { text-align:center; padding:28px 20px; border-radius:20px; background:#f8fafc; border:1px solid #f1f5f9; }
//     .vo-how-step { width:46px; height:46px; border-radius:50%; background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; font-size:18px; font-weight:800; display:flex; align-items:center; justify-content:center; margin:0 auto 14px; }
//     .vo-how-icon { font-size:30px; margin-bottom:12px; }
//     .vo-how-title { font-size:15px; font-weight:700; color:#0a1628; margin-bottom:8px; }
//     .vo-how-desc  { font-size:13px; color:#475569; line-height:1.6; }
//     .vo-footer { background:#0a1628; padding:56px 0 24px; border-top:1px solid rgba(255,255,255,0.06); }
//     .vo-footer-inner { max-width:1200px; margin:0 auto; padding:0 24px 40px; display:grid; grid-template-columns:2fr 1fr 1fr; gap:48px; }
//     .vo-footer-desc { font-size:14px; color:rgba(255,255,255,0.5); line-height:1.7; margin-top:10px; max-width:280px; }
//     .vo-footer-col h4 { font-size:12px; font-weight:700; color:rgba(255,255,255,0.85); text-transform:uppercase; letter-spacing:1px; margin-bottom:14px; }
//     .vo-footer-col ul { list-style:none; }
//     .vo-footer-col ul li { margin-bottom:8px; }
//     .vo-footer-col ul li a { font-size:13px; color:rgba(255,255,255,0.5); cursor:pointer; }
//     .vo-footer-bottom { max-width:1200px; margin:0 auto; padding:20px 24px 0; border-top:1px solid rgba(255,255,255,0.07); display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:12px; font-size:13px; color:rgba(255,255,255,0.35); }
//     @media(max-width:860px) { .vo-hero-inner{grid-template-columns:1fr;} .vo-float-cards{display:none;} .vo-how-grid{grid-template-columns:repeat(2,1fr);} .vo-footer-inner{grid-template-columns:1fr;gap:28px;} .vo-nav{padding:0 20px;} .vo-nav-sa{display:none;} .vo-nav-links{display:none;} .vo-hamburger{display:flex;} }
//     @media(max-width:600px) { .vo-grid{grid-template-columns:1fr;} .vo-how-grid{grid-template-columns:1fr;} .vo-stats{gap:20px;} .vo-plans{flex-direction:column;align-items:center;} }
//   `;

//   const scrollTo = (id) =>
//     document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

//   return (
//     <div style={{ fontFamily: "DM Sans,sans-serif" }}>
//       <style>{css}</style>

//       {/* Navbar */}
//       <div className="vo-nav">
//         <div className="vo-logo">
//           <div className="vo-logo-icon">🏥</div>
//           <div>
//             <div className="vo-logo-text">PranJeev</div>
//             <div className="vo-logo-sub">Life-Giving Healthcare</div>
//           </div>
//         </div>
//         <div
//           className="vo-nav-links"
//           style={{ display: "flex", gap: 12, alignItems: "center" }}
//         >
//           <a
//             onClick={() => scrollTo("hospitals")}
//             style={{
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 14,
//               fontWeight: 500,
//               cursor: "pointer",
//             }}
//           >
//             Hospitals
//           </a>
//           <a
//             onClick={() => scrollTo("how")}
//             style={{
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 14,
//               fontWeight: 500,
//               cursor: "pointer",
//             }}
//           >
//             How It Works
//           </a>
//           <button className="vo-nav-btn" onClick={() => setRegOpen(true)}>
//             Register Hospital
//           </button>
//           <button className="vo-nav-sa" onClick={() => navigate("/superadmin")}>
//             🛡️ Admin
//           </button>
//         </div>
//         <button
//           className="vo-hamburger"
//           onClick={() => setMenuOpen((m) => !m)}
//           aria-label="Menu"
//         >
//           <span
//             style={{
//               transform: menuOpen ? "rotate(45deg) translate(5px,5px)" : "none",
//             }}
//           />
//           <span style={{ opacity: menuOpen ? 0 : 1 }} />
//           <span
//             style={{
//               transform: menuOpen
//                 ? "rotate(-45deg) translate(5px,-5px)"
//                 : "none",
//             }}
//           />
//         </button>
//       </div>

//       {/* Mobile Menu */}
//       <div className={`vo-mobile-menu${menuOpen ? " open" : ""}`}>
//         <button
//           className="vo-mobile-link"
//           onClick={() => {
//             scrollTo("hospitals");
//             setMenuOpen(false);
//           }}
//         >
//           🏥 Hospitals
//         </button>
//         <button
//           className="vo-mobile-link"
//           onClick={() => {
//             scrollTo("how");
//             setMenuOpen(false);
//           }}
//         >
//           ⚙️ How It Works
//         </button>
//         <button
//           className="vo-mobile-link"
//           onClick={() => {
//             scrollTo("pricing");
//             setMenuOpen(false);
//           }}
//         >
//           💰 Pricing
//         </button>
//         <button
//           className="vo-mobile-btn"
//           onClick={() => {
//             setRegOpen(true);
//             setMenuOpen(false);
//           }}
//         >
//           Register Your Hospital →
//         </button>
//         <button
//           className="vo-mobile-sa"
//           onClick={() => {
//             navigate("/superadmin");
//             setMenuOpen(false);
//           }}
//         >
//           🛡️ Admin
//         </button>
//       </div>

//       {/* Hero */}
//       <section className="vo-hero" id="home">
//         <div className="vo-hero-inner">
//           <div>
//             <div className="vo-badge">
//               🌟 India's Life-Giving Healthcare Platform
//             </div>
//             <h1>
//               Find & Book
//               <br />
//               <em>Top Hospitals</em>
//               <br />
//               Near You
//             </h1>
//             <p className="vo-hero-desc">
//               From Dental to Ortho, Ayurved to Cardiology — discover verified
//               hospitals, book appointments instantly, and manage your health all
//               in one place.
//             </p>
//             <div className="vo-actions">
//               <button
//                 className="vo-btn-primary"
//                 onClick={() => scrollTo("hospitals")}
//               >
//                 Find Hospitals →
//               </button>
//               <button
//                 className="vo-btn-outline"
//                 onClick={() => setRegOpen(true)}
//               >
//                 Register Your Hospital
//               </button>
//             </div>
//             <div className="vo-stats">
//               {[
//                 ["200+", "Hospitals"],
//                 ["50K+", "Patients"],
//                 ["7", "Specialities"],
//               ].map(([n, l]) => (
//                 <div key={l}>
//                   <div className="vo-stat-num">{n}</div>
//                   <div className="vo-stat-lbl">{l}</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//           <div className="vo-float-cards">
//             {[
//               {
//                 icon: "🦷",
//                 bg: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                 title: "Dental Care",
//                 desc: "Root canal, implants, whitening",
//               },
//               {
//                 icon: "🦴",
//                 bg: "linear-gradient(135deg,#1a3a6b,#2563eb)",
//                 title: "Ortho Care",
//                 desc: "Joint replacement, physiotherapy",
//               },
//               {
//                 icon: "🌿",
//                 bg: "linear-gradient(135deg,#166534,#16a34a)",
//                 title: "Ayurved",
//                 desc: "Panchakarma, herbal treatments",
//               },
//               {
//                 icon: "❤️",
//                 bg: "linear-gradient(135deg,#881337,#dc2626)",
//                 title: "Cardiology",
//                 desc: "Heart care, ECG, consultations",
//               },
//             ].map((c) => (
//               <div key={c.title} className="vo-float-card">
//                 <div className="vo-float-icon" style={{ background: c.bg }}>
//                   {c.icon}
//                 </div>
//                 <div>
//                   <div className="vo-float-title">{c.title}</div>
//                   <div className="vo-float-desc">{c.desc}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Hospital Grid */}
//       <section className="vo-hospitals" id="hospitals">
//         <div className="vo-container">
//           <div style={{ textAlign: "center", marginBottom: 48 }}>
//             <div className="vo-section-tag">🏥 Browse Hospitals</div>
//             <h2 className="vo-section-title">
//               Find the Right
//               <br />
//               <em>Hospital for You</em>
//             </h2>
//             <p
//               style={{
//                 fontSize: 16,
//                 color: "#475569",
//                 maxWidth: 540,
//                 margin: "0 auto",
//                 lineHeight: 1.7,
//               }}
//             >
//               Browse verified hospitals by speciality or city.
//             </p>
//           </div>
//           <div className="vo-controls">
//             <input
//               className="vo-search"
//               placeholder="🔍 Search by hospital name or city..."
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               autoComplete="off"
//             />
//             <div className="vo-cats">
//               {CATEGORIES.map((c) => (
//                 <button
//                   key={c.id}
//                   className={`vo-cat${activeCat === c.id ? " active" : ""}`}
//                   onClick={() => setActiveCat(c.id)}
//                 >
//                   {c.icon} {c.label}
//                 </button>
//               ))}
//             </div>
//           </div>
//           <div style={{ fontSize: 13, color: "#94a3b8", marginBottom: 24 }}>
//             {loading
//               ? "Loading hospitals..."
//               : `${filtered.length} hospital${filtered.length !== 1 ? "s" : ""} found`}
//           </div>
//           <div className="vo-grid">
//             {loading ? (
//               [1, 2, 3, 4, 5, 6].map((i) => (
//                 <div
//                   key={i}
//                   style={{
//                     background: "#fff",
//                     borderRadius: 20,
//                     overflow: "hidden",
//                   }}
//                 >
//                   <div className="vo-skel" style={{ height: 140 }} />
//                   <div style={{ padding: "20px 22px" }}>
//                     <div
//                       className="vo-skel"
//                       style={{ height: 20, width: "70%", marginBottom: 8 }}
//                     />
//                     <div
//                       className="vo-skel"
//                       style={{ height: 13, width: "40%", marginBottom: 14 }}
//                     />
//                     <div
//                       className="vo-skel"
//                       style={{ height: 38, borderRadius: 10 }}
//                     />
//                   </div>
//                 </div>
//               ))
//             ) : filtered.length === 0 ? (
//               <div className="vo-empty">No hospitals match your search.</div>
//             ) : (
//               filtered.map((h) => {
//                 const type = (h.type || "general").toLowerCase();
//                 const grad = CAT_GRADIENTS[type] || CAT_GRADIENTS.general;
//                 const cat = CATEGORIES.find((c) => c.id === type);
//                 return (
//                   <div
//                     key={h._id}
//                     className="vo-card"
//                     onClick={() => navigate(`/hospital/${h.slug}`)}
//                   >
//                     <div className="vo-card-top" style={{ background: grad }}>
//                       <div className="vo-card-badge">
//                         {cat?.label || "Hospital"}
//                       </div>
//                       {h.logoUrl ? (
//                         <img
//                           src={h.logoUrl}
//                           alt={h.name}
//                           style={{
//                             width: 70,
//                             height: 70,
//                             borderRadius: "50%",
//                             objectFit: "cover",
//                             border: "3px solid rgba(255,255,255,0.3)",
//                           }}
//                         />
//                       ) : (
//                         <span>{CAT_ICONS[type] || "🏥"}</span>
//                       )}
//                     </div>
//                     <div className="vo-card-body">
//                       <div className="vo-card-name">{h.name}</div>
//                       <div className="vo-card-type">
//                         {cat?.icon} {cat?.label || "Hospital"}
//                       </div>
//                       <div className="vo-card-city">
//                         📍 {h.city || "Location not specified"}
//                       </div>
//                       <div className="vo-card-stats">
//                         {[
//                           ["Patients", h.statPatients],
//                           ["Doctors", h.statDoctors],
//                           ["Rating", h.statRating],
//                         ].map(([l, v]) => (
//                           <div key={l} className="vo-card-stat">
//                             <div className="vo-card-stat-num">{v || "—"}</div>
//                             <div className="vo-card-stat-lbl">{l}</div>
//                           </div>
//                         ))}
//                       </div>
//                       <button className="vo-card-btn">
//                         Book Appointment →
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>
//       </section>

//       {/* How It Works */}
//       <section className="vo-how" id="how">
//         <div className="vo-container">
//           <div style={{ textAlign: "center" }}>
//             <div className="vo-section-tag">Simple Process</div>
//             <h2 className="vo-section-title">
//               How <em>PranJeev</em> Works
//             </h2>
//             <p
//               style={{
//                 fontSize: 16,
//                 color: "#475569",
//                 maxWidth: 520,
//                 margin: "0 auto",
//                 lineHeight: 1.7,
//               }}
//             >
//               Get your hospital live in under 10 minutes. No technical knowledge
//               required.
//             </p>
//           </div>
//           <div className="vo-how-grid">
//             {[
//               {
//                 step: "1",
//                 icon: "🏥",
//                 title: "Register Hospital",
//                 desc: "Fill your hospital details, choose a plan and pay securely.",
//               },
//               {
//                 step: "2",
//                 icon: "⚙️",
//                 title: "Setup Your Panel",
//                 desc: "Add your doctors, services and pricing inside your admin dashboard.",
//               },
//               {
//                 step: "3",
//                 icon: "📅",
//                 title: "Patients Book",
//                 desc: "Patients find your hospital on PranJeev and book appointments online.",
//               },
//               {
//                 step: "4",
//                 icon: "📊",
//                 title: "Manage Everything",
//                 desc: "Track appointments, patients, billing and doctor availability in one panel.",
//               },
//             ].map((s) => (
//               <div key={s.step} className="vo-how-card">
//                 <div className="vo-how-step">{s.step}</div>
//                 <div className="vo-how-icon">{s.icon}</div>
//                 <div className="vo-how-title">{s.title}</div>
//                 <div className="vo-how-desc">{s.desc}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA / Pricing */}
//       <section className="vo-cta" id="pricing">
//         <div className="vo-container">
//           <div
//             className="vo-section-tag"
//             style={{
//               background: "rgba(201,168,76,0.15)",
//               borderColor: "rgba(201,168,76,0.3)",
//               color: "#c9a845",
//             }}
//           >
//             💰 Simple Pricing
//           </div>
//           <h2 className="vo-cta-title">
//             Register Your Hospital
//             <br />
//             <em>Start Today</em>
//           </h2>
//           <p className="vo-cta-desc">
//             Choose a plan that fits your hospital. All plans include full admin
//             panel, patient management & WhatsApp integration.
//           </p>
//           <div className="vo-plans">
//             {[
//               {
//                 name: "Starter",
//                 price: "₹999",
//                 period: "/month",
//                 features: "3 Doctors · Appointments · Patients",
//               },
//               {
//                 name: "Pro",
//                 price: "₹1,999",
//                 period: "/month",
//                 features: "10 Doctors · Billing · WhatsApp",
//                 featured: true,
//               },
//               {
//                 name: "Enterprise",
//                 price: "₹3,499",
//                 period: "/month",
//                 features: "Unlimited · Priority Support · Custom Domain",
//               },
//             ].map((p) => (
//               <div
//                 key={p.name}
//                 className={`vo-plan${p.featured ? " featured" : ""}`}
//               >
//                 <div className="vo-plan-name">{p.name}</div>
//                 <div className="vo-plan-price">{p.price}</div>
//                 <div className="vo-plan-period">{p.period}</div>
//                 <div className="vo-plan-features">{p.features}</div>
//               </div>
//             ))}
//           </div>
//           <button
//             className="vo-btn-primary"
//             style={{ fontSize: 16, padding: "15px 36px" }}
//             onClick={() => setRegOpen(true)}
//           >
//             Register Your Hospital Now →
//           </button>
//           <div
//             style={{
//               fontSize: 12,
//               color: "rgba(255,255,255,0.4)",
//               marginTop: 14,
//             }}
//           >
//             14-day free trial · No credit card required to start
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="vo-footer">
//         <div className="vo-footer-inner">
//           <div>
//             <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//               <div
//                 style={{
//                   width: 36,
//                   height: 36,
//                   background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   borderRadius: 10,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   fontSize: 18,
//                 }}
//               >
//                 🏥
//               </div>
//               <div>
//                 <div
//                   style={{
//                     fontFamily: "Cormorant Garamond,serif",
//                     fontSize: 20,
//                     fontWeight: 700,
//                     color: "#fff",
//                   }}
//                 >
//                   PranJeev
//                 </div>
//                 <div
//                   style={{
//                     fontSize: 9,
//                     color: "#c9a845",
//                     letterSpacing: 2,
//                     textTransform: "uppercase",
//                   }}
//                 >
//                   Life-Giving Healthcare
//                 </div>
//               </div>
//             </div>
//             <p className="vo-footer-desc">
//               Prana (life force) + Jeev (living being) — India's life-giving
//               hospital management platform.
//             </p>
//           </div>
//           <div className="vo-footer-col">
//             <h4>For Hospitals</h4>
//             <ul>
//               {[
//                 "Register Hospital",
//                 "Pricing Plans",
//                 "How It Works",
//                 "Admin Login",
//               ].map((s) => (
//                 <li key={s}>
//                   <a>{s}</a>
//                 </li>
//               ))}
//             </ul>
//           </div>
//           <div className="vo-footer-col">
//             <h4>Specialities</h4>
//             <ul>
//               {[
//                 "🦷 Dental",
//                 "🦴 Ortho",
//                 "🌿 Ayurved",
//                 "❤️ Cardiology",
//                 "👁️ Eye Care",
//                 "👶 Pediatric",
//               ].map((s) => (
//                 <li key={s}>
//                   <a>{s}</a>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>
//         <div className="vo-footer-bottom">
//           <p>
//             © 2026 PranJeev · Life-Giving Healthcare Platform. All rights
//             reserved.
//           </p>
//           <div style={{ display: "flex", gap: 24 }}>
//             <a>Privacy Policy</a>
//             <a>Terms of Service</a>
//           </div>
//         </div>
//       </footer>

//       {regOpen && (
//         <RegisterModal
//           onClose={() => {
//             setRegOpen(false);
//             fetchHospitals();
//           }}
//         />
//       )}
//     </div>
//   );
// }

// logo
// // ============================================================
// // src/pages/PranJeev.js  (renamed from VidyaOne.js)
// // ✅ Full rebrand: VidyaOne → PranJeev
// // ✅ Super Admin button in navbar
// // ✅ Registration secret key gate
// // ✅ Logo: replaced emoji with logo.jpeg
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import logo from "../assets/logo.jpeg";

// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// const PEARLSMILE_CARD = {
//   _id: "pearlsmile-static",
//   name: "PearlSmile Dental Hospital",
//   type: "dental",
//   city: "Pune, Maharashtra",
//   slug: "pearlsmile",
//   statPatients: "18K+",
//   statDoctors: "20+",
//   statRating: "4.9★",
//   logoUrl: "",
// };

// const CATEGORIES = [
//   { id: "all", label: "All", icon: "🏥" },
//   { id: "dental", label: "Dental", icon: "🦷" },
//   { id: "ortho", label: "Ortho", icon: "🦴" },
//   { id: "ayurved", label: "Ayurved", icon: "🌿" },
//   { id: "cardiology", label: "Cardiology", icon: "❤️" },
//   { id: "eye", label: "Eye", icon: "👁️" },
//   { id: "pediatric", label: "Pediatric", icon: "👶" },
//   { id: "general", label: "General", icon: "➕" },
// ];

// const CAT_GRADIENTS = {
//   dental: "linear-gradient(135deg,#0d7377,#14a0a5)",
//   ortho: "linear-gradient(135deg,#1a3a6b,#2563eb)",
//   ayurved: "linear-gradient(135deg,#166534,#16a34a)",
//   cardiology: "linear-gradient(135deg,#881337,#dc2626)",
//   eye: "linear-gradient(135deg,#4338ca,#7c3aed)",
//   pediatric: "linear-gradient(135deg,#c2410c,#f97316)",
//   general: "linear-gradient(135deg,#0f766e,#0d9488)",
// };

// const CAT_ICONS = {
//   dental: "🦷",
//   ortho: "🦴",
//   ayurved: "🌿",
//   cardiology: "❤️",
//   eye: "👁️",
//   pediatric: "👶",
//   general: "➕",
// };

// const TYPES = [
//   "Dental",
//   "Ortho",
//   "Ayurved",
//   "Cardiology",
//   "Eye",
//   "Pediatric",
//   "General",
// ];
// const PLANS = [
//   { id: "starter", label: "Starter — ₹999/mo" },
//   { id: "pro", label: "Pro — ₹1,999/mo" },
//   { id: "enterprise", label: "Enterprise — ₹3,499/mo" },
// ];

// // ── Register Modal ────────────────────────────────────────────
// function RegisterModal({ onClose }) {
//   const [step, setStep] = useState(1);
//   const [saving, setSaving] = useState(false);
//   const [msg, setMsg] = useState("");
//   const [form, setForm] = useState({
//     name: "",
//     type: "",
//     phone: "",
//     whatsapp: "",
//     email: "",
//     address: "",
//     city: "",
//     established: "",
//     plan: "pro",
//     adminId: "",
//     password: "",
//     registrationKey: "",
//   });
//   const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

//   const inp = {
//     width: "100%",
//     padding: "10px 14px",
//     borderRadius: 8,
//     border: "1.5px solid #e2e8f0",
//     fontSize: 14,
//     fontFamily: "DM Sans,sans-serif",
//     outline: "none",
//     background: "#f8fafc",
//     boxSizing: "border-box",
//     marginTop: 4,
//     marginBottom: 12,
//   };
//   const lbl = {
//     fontSize: 12,
//     fontWeight: 600,
//     color: "#475569",
//     display: "block",
//   };

//   const next = () => {
//     if (!form.name || !form.type || !form.phone || !form.city) {
//       setMsg("Please fill all required fields.");
//       return;
//     }
//     setMsg("");
//     setStep(2);
//   };

//   const submit = async () => {
//     if (!form.adminId || !form.password) {
//       setMsg("Admin ID and password are required.");
//       return;
//     }
//     if (!form.registrationKey.trim()) {
//       setMsg(
//         "Registration access key is required. Contact PranJeev on WhatsApp to get your key.",
//       );
//       return;
//     }
//     setSaving(true);
//     setMsg("");
//     try {
//       const slug = form.name
//         .toLowerCase()
//         .replace(/[^a-z0-9]+/g, "-")
//         .replace(/^-|-$/g, "");
//       const res = await fetch(`${API_URL}/hospitals/register`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ ...form, slug }),
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message || "Registration failed");
//       setStep(3);
//     } catch (err) {
//       setMsg(err.message);
//     }
//     setSaving(false);
//   };

//   return (
//     <div
//       style={{
//         position: "fixed",
//         inset: 0,
//         background: "rgba(0,0,0,0.6)",
//         backdropFilter: "blur(4px)",
//         zIndex: 2000,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: 20,
//       }}
//       onClick={(e) => {
//         if (e.target === e.currentTarget) onClose();
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 24,
//           width: "100%",
//           maxWidth: 520,
//           maxHeight: "90vh",
//           overflowY: "auto",
//           boxShadow: "0 24px 80px rgba(0,0,0,0.4)",
//         }}
//       >
//         {/* Header */}
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             padding: "22px 28px",
//             borderRadius: "24px 24px 0 0",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div>
//             <div style={{ fontSize: 17, fontWeight: 700, color: "#fff" }}>
//               {step === 3
//                 ? "🎉 Registration Successful!"
//                 : "🏥 Register Your Hospital"}
//             </div>
//             <div
//               style={{
//                 fontSize: 12,
//                 color: "rgba(255,255,255,0.55)",
//                 marginTop: 3,
//               }}
//             >
//               {step === 1 && "Step 1 of 2 — Hospital Details"}
//               {step === 2 && "Step 2 of 2 — Admin Credentials & Access Key"}
//               {step === 3 && "Your hospital is now live on PranJeev!"}
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.12)",
//               border: "none",
//               color: "#fff",
//               width: 32,
//               height: 32,
//               borderRadius: "50%",
//               fontSize: 16,
//               cursor: "pointer",
//             }}
//           >
//             ✕
//           </button>
//         </div>

//         <form
//           autoComplete="off"
//           onSubmit={(e) => e.preventDefault()}
//           style={{ padding: 28 }}
//         >
//           {msg && (
//             <div
//               style={{
//                 background: "#fef2f2",
//                 border: "1px solid #fecaca",
//                 borderRadius: 8,
//                 padding: "10px 14px",
//                 marginBottom: 16,
//                 fontSize: 13,
//                 color: "#dc2626",
//               }}
//             >
//               {msg}
//             </div>
//           )}

//           {/* STEP 1 */}
//           {step === 1 && (
//             <>
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "1fr 1fr",
//                   gap: "0 14px",
//                 }}
//               >
//                 <div>
//                   <label style={lbl}>Hospital Name *</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. Sai Dental Hospital"
//                     autoComplete="off"
//                     value={form.name}
//                     onChange={(e) => set("name", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Hospital Type *</label>
//                   <select
//                     style={inp}
//                     value={form.type}
//                     onChange={(e) => set("type", e.target.value)}
//                   >
//                     <option value="">Select type</option>
//                     {TYPES.map((t) => (
//                       <option key={t} value={t.toLowerCase()}>
//                         {t}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 <div>
//                   <label style={lbl}>Phone *</label>
//                   <input
//                     style={inp}
//                     placeholder="+91 98765 43210"
//                     autoComplete="off"
//                     value={form.phone}
//                     onChange={(e) => set("phone", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>WhatsApp (no +)</label>
//                   <input
//                     style={inp}
//                     placeholder="919876543210"
//                     autoComplete="off"
//                     value={form.whatsapp}
//                     onChange={(e) => set("whatsapp", e.target.value)}
//                   />
//                 </div>
//                 <div style={{ gridColumn: "1/-1" }}>
//                   <label style={lbl}>Email</label>
//                   <input
//                     style={inp}
//                     type="email"
//                     placeholder="info@hospital.com"
//                     autoComplete="off"
//                     value={form.email}
//                     onChange={(e) => set("email", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Address</label>
//                   <input
//                     style={inp}
//                     placeholder="Street, Area"
//                     autoComplete="off"
//                     value={form.address}
//                     onChange={(e) => set("address", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>City *</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. Mumbai, MH"
//                     autoComplete="off"
//                     value={form.city}
//                     onChange={(e) => set("city", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Established Year</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. 2010"
//                     autoComplete="off"
//                     value={form.established}
//                     onChange={(e) => set("established", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Plan</label>
//                   <select
//                     style={inp}
//                     value={form.plan}
//                     onChange={(e) => set("plan", e.target.value)}
//                   >
//                     {PLANS.map((p) => (
//                       <option key={p.id} value={p.id}>
//                         {p.label}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//               <button
//                 onClick={next}
//                 style={{
//                   width: "100%",
//                   padding: 13,
//                   background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 10,
//                   fontSize: 15,
//                   fontWeight: 700,
//                   cursor: "pointer",
//                 }}
//               >
//                 Next: Create Admin Account →
//               </button>
//             </>
//           )}

//           {/* STEP 2 */}
//           {step === 2 && (
//             <>
//               <div
//                 style={{
//                   background: "#f0fdf4",
//                   border: "1px solid #bbf7d0",
//                   borderRadius: 10,
//                   padding: "12px 16px",
//                   marginBottom: 20,
//                   fontSize: 13,
//                   color: "#166534",
//                 }}
//               >
//                 ✅ <strong>{form.name}</strong> · {form.city}
//               </div>
//               <label style={lbl}>Admin ID *</label>
//               <input
//                 style={inp}
//                 placeholder="e.g. saidental_admin"
//                 autoComplete="off"
//                 value={form.adminId}
//                 onChange={(e) => set("adminId", e.target.value)}
//               />
//               <label style={lbl}>Password *</label>
//               <input
//                 style={inp}
//                 type="password"
//                 placeholder="Create a strong password"
//                 autoComplete="new-password"
//                 value={form.password}
//                 onChange={(e) => set("password", e.target.value)}
//               />
//               <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 18 }}>
//                 💡 Save these credentials — you'll use them to login to your
//                 admin panel.
//               </div>

//               {/* Secret Key */}
//               <div
//                 style={{
//                   background: "#fffbeb",
//                   border: "1px solid #fde68a",
//                   borderRadius: 10,
//                   padding: "14px 16px",
//                   marginBottom: 16,
//                 }}
//               >
//                 <div
//                   style={{
//                     fontSize: 13,
//                     fontWeight: 700,
//                     color: "#92400e",
//                     marginBottom: 8,
//                   }}
//                 >
//                   🔐 Registration Access Key Required
//                 </div>
//                 <div
//                   style={{
//                     fontSize: 12,
//                     color: "#92400e",
//                     marginBottom: 10,
//                     lineHeight: 1.5,
//                   }}
//                 >
//                   This is a private key provided by PranJeev. Without it,
//                   registration is not allowed. Contact us on WhatsApp to get
//                   your key before registering.
//                 </div>
//                 <a
//                   href="https://wa.me/918793608083?text=Hi%20PranJeev%2C%20I%20want%20to%20register%20my%20hospital.%20Please%20share%20the%20registration%20key."
//                   target="_blank"
//                   rel="noreferrer"
//                   style={{
//                     display: "inline-flex",
//                     alignItems: "center",
//                     gap: 8,
//                     margin: "6px 0 12px",
//                     background: "#25d366",
//                     color: "#fff",
//                     borderRadius: 8,
//                     padding: "9px 16px",
//                     fontSize: 13,
//                     fontWeight: 700,
//                     textDecoration: "none",
//                   }}
//                 >
//                   💬 Contact PranJeev Owner — +91 87936 08083
//                 </a>
//                 <label style={{ ...lbl, color: "#92400e" }}>Access Key *</label>
//                 <input
//                   style={{
//                     ...inp,
//                     marginBottom: 0,
//                     background: "#fff",
//                     border: "1.5px solid #fcd34d",
//                   }}
//                   type="password"
//                   placeholder="Enter your PranJeev registration key"
//                   autoComplete="new-password"
//                   value={form.registrationKey}
//                   onChange={(e) => set("registrationKey", e.target.value)}
//                 />
//               </div>

//               <div style={{ display: "flex", gap: 10 }}>
//                 <button
//                   onClick={() => setStep(1)}
//                   style={{
//                     flex: 1,
//                     padding: 13,
//                     background: "#f1f5f9",
//                     color: "#475569",
//                     border: "none",
//                     borderRadius: 10,
//                     fontSize: 14,
//                     fontWeight: 600,
//                     cursor: "pointer",
//                   }}
//                 >
//                   ← Back
//                 </button>
//                 <button
//                   onClick={submit}
//                   disabled={saving}
//                   style={{
//                     flex: 2,
//                     padding: 13,
//                     background: saving
//                       ? "#94a3b8"
//                       : "linear-gradient(135deg,#0d7377,#14a0a5)",
//                     color: "#fff",
//                     border: "none",
//                     borderRadius: 10,
//                     fontSize: 15,
//                     fontWeight: 700,
//                     cursor: saving ? "not-allowed" : "pointer",
//                   }}
//                 >
//                   {saving ? "Registering..." : "🚀 Complete Registration"}
//                 </button>
//               </div>
//             </>
//           )}

//           {/* STEP 3 */}
//           {step === 3 && (
//             <div style={{ textAlign: "center", padding: "20px 0" }}>
//               <div style={{ fontSize: 64, marginBottom: 16 }}>🎉</div>
//               <h3
//                 style={{
//                   fontSize: 22,
//                   fontWeight: 700,
//                   color: "#0a1628",
//                   marginBottom: 8,
//                 }}
//               >
//                 {form.name}
//               </h3>
//               <p
//                 style={{
//                   fontSize: 14,
//                   color: "#64748b",
//                   marginBottom: 24,
//                   lineHeight: 1.6,
//                 }}
//               >
//                 Your hospital is now live on PranJeev! Use your credentials to
//                 login.
//               </p>
//               <div
//                 style={{
//                   background: "#f0fdf4",
//                   border: "1px solid #bbf7d0",
//                   borderRadius: 12,
//                   padding: "16px 20px",
//                   marginBottom: 24,
//                   textAlign: "left",
//                 }}
//               >
//                 <div
//                   style={{
//                     fontSize: 12,
//                     fontWeight: 700,
//                     color: "#16a34a",
//                     marginBottom: 8,
//                   }}
//                 >
//                   YOUR LOGIN CREDENTIALS
//                 </div>
//                 <div style={{ fontSize: 14, color: "#166534" }}>
//                   Admin ID: <strong>{form.adminId}</strong>
//                 </div>
//                 <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>
//                   (Save your password securely)
//                 </div>
//               </div>
//               <button
//                 onClick={onClose}
//                 style={{
//                   width: "100%",
//                   padding: 13,
//                   background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 10,
//                   fontSize: 15,
//                   fontWeight: 700,
//                   cursor: "pointer",
//                 }}
//               >
//                 Done ✓
//               </button>
//             </div>
//           )}
//         </form>
//       </div>
//     </div>
//   );
// }

// // ── Main PranJeev Page ────────────────────────────────────────
// export default function PranJeev() {
//   const navigate = useNavigate();
//   const [hospitals, setHospitals] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState("");
//   const [activeCat, setActiveCat] = useState("all");
//   const [regOpen, setRegOpen] = useState(false);
//   const [menuOpen, setMenuOpen] = useState(false);

//   const fetchHospitals = useCallback(async () => {
//     setLoading(true);
//     try {
//       const r = await fetch(`${API_URL}/hospitals`);
//       if (r.ok) {
//         const data = await r.json();
//         setHospitals(Array.isArray(data) ? data : []);
//       }
//     } catch (_) {}
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     fetchHospitals();
//   }, [fetchHospitals]);

//   const allHospitals = [
//     PEARLSMILE_CARD,
//     ...hospitals.filter((h) => h.slug !== "pearlsmile"),
//   ];

//   const filtered = allHospitals.filter((h) => {
//     const matchCat =
//       activeCat === "all" || (h.type || "").toLowerCase() === activeCat;
//     const q = search.toLowerCase();
//     const matchSearch =
//       !q ||
//       (h.name || "").toLowerCase().includes(q) ||
//       (h.city || "").toLowerCase().includes(q) ||
//       (h.type || "").toLowerCase().includes(q);
//     return matchCat && matchSearch;
//   });

//   const css = `
//     * { box-sizing:border-box; margin:0; padding:0; }
//     body { font-family:"DM Sans",sans-serif; }
//     .vo-nav { position:fixed; top:0; left:0; right:0; z-index:1000; background:rgba(10,22,40,0.97); backdrop-filter:blur(12px); border-bottom:1px solid rgba(255,255,255,0.06); display:flex; align-items:center; justify-content:space-between; padding:0 40px; height:68px; gap:16px; }
//     .vo-logo { display:flex; align-items:center; gap:10px; cursor:pointer; flex-shrink:0; min-width:0; }
//     .vo-logo-icon {
//       width:38px;
//       height:38px;
//       border-radius:10px;
//       overflow:hidden;
//       flex-shrink:0;
//       display:flex;
//       align-items:center;
//       justify-content:center;
//       background:linear-gradient(135deg,#0d7377,#14a0a5);
//     }
//     .vo-logo-icon img {
//       width:100%;
//       height:100%;
//       object-fit:cover;
//       display:block;
//       border-radius:10px;
//     }
//     .vo-logo-textblock { display:flex; flex-direction:column; min-width:0; }
//     .vo-logo-text { font-family:"Cormorant Garamond",serif; font-size:22px; font-weight:700; color:#fff; white-space:nowrap; line-height:1.2; }
//     .vo-logo-sub  { font-size:9px; color:#c9a845; letter-spacing:2px; text-transform:uppercase; white-space:nowrap; }
//     .vo-nav-links { display:flex; align-items:center; gap:12px; flex-shrink:0; }
//     .vo-nav-btn { background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; padding:10px 22px; border-radius:8px; font-weight:700; font-size:13px; font-family:"DM Sans",sans-serif; cursor:pointer; white-space:nowrap; }
//     .vo-nav-sa  { background:rgba(255,255,255,0.06); color:rgba(255,255,255,0.55); border:1px solid rgba(255,255,255,0.12); padding:8px 14px; border-radius:8px; font-weight:600; font-size:12px; font-family:"DM Sans",sans-serif; cursor:pointer; white-space:nowrap; }
//     .vo-nav-sa:hover { background:rgba(255,255,255,0.12); color:#fff; }
//     .vo-hamburger { display:none; flex-direction:column; gap:5px; background:none; border:none; cursor:pointer; padding:6px; z-index:1100; flex-shrink:0; }
//     .vo-hamburger span { display:block; width:24px; height:2px; background:#fff; border-radius:2px; transition:all 0.3s; }
//     .vo-mobile-menu { display:none; position:fixed; top:68px; left:0; right:0; background:rgba(10,22,40,0.98); backdrop-filter:blur(16px); border-bottom:1px solid rgba(255,255,255,0.08); padding:16px 20px 20px; flex-direction:column; gap:12px; z-index:999; }
//     .vo-mobile-menu.open { display:flex; }
//     .vo-mobile-link { color:rgba(255,255,255,0.8); font-size:15px; font-weight:500; padding:10px 0; border-bottom:1px solid rgba(255,255,255,0.07); cursor:pointer; font-family:"DM Sans",sans-serif; background:none; border-left:none; border-right:none; border-top:none; text-align:left; }
//     .vo-mobile-btn { width:100%; padding:12px; background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; border-radius:10px; font-size:14px; font-weight:700; cursor:pointer; font-family:"DM Sans",sans-serif; margin-top:4px; }
//     .vo-mobile-sa  { width:100%; padding:10px; background:rgba(255,255,255,0.06); color:rgba(255,255,255,0.7); border:1px solid rgba(255,255,255,0.15); border-radius:10px; font-size:13px; font-weight:600; cursor:pointer; font-family:"DM Sans",sans-serif; }
//     .vo-hero { min-height:100vh; background:linear-gradient(135deg,#0a1628 0%,#0d2444 50%,#0a1f3a 100%); display:flex; align-items:center; padding-top:68px; position:relative; overflow:hidden; }
//     .vo-hero::before { content:""; position:absolute; top:-200px; right:-200px; width:600px; height:600px; background:radial-gradient(circle,rgba(13,115,119,0.15) 0%,transparent 70%); border-radius:50%; }
//     .vo-hero-inner { max-width:1200px; margin:0 auto; padding:80px 24px; display:grid; grid-template-columns:1fr 1fr; gap:60px; align-items:center; position:relative; z-index:1; }
//     .vo-badge { display:inline-flex; align-items:center; gap:8px; background:rgba(201,168,76,0.15); border:1px solid rgba(201,168,76,0.3); color:#c9a845; font-size:11px; font-weight:700; letter-spacing:1px; text-transform:uppercase; padding:7px 16px; border-radius:100px; margin-bottom:24px; }
//     .vo-hero h1 { font-family:"Cormorant Garamond",serif; font-size:clamp(40px,5vw,64px); font-weight:700; color:#fff; line-height:1.1; margin-bottom:20px; }
//     .vo-hero h1 em { font-style:italic; color:#14a0a5; }
//     .vo-hero-desc { font-size:16px; color:rgba(255,255,255,0.7); line-height:1.7; margin-bottom:36px; max-width:480px; }
//     .vo-actions { display:flex; gap:14px; flex-wrap:wrap; }
//     .vo-btn-primary { background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; padding:14px 28px; border-radius:10px; font-size:15px; font-weight:700; font-family:"DM Sans",sans-serif; cursor:pointer; transition:opacity 0.2s,transform 0.2s; }
//     .vo-btn-primary:hover { opacity:0.92; transform:translateY(-1px); }
//     .vo-btn-outline { background:transparent; color:#fff; border:1.5px solid rgba(255,255,255,0.3); padding:14px 28px; border-radius:10px; font-size:15px; font-weight:600; font-family:"DM Sans",sans-serif; cursor:pointer; }
//     .vo-stats { display:flex; gap:32px; margin-top:40px; }
//     .vo-stat-num { font-family:"Cormorant Garamond",serif; font-size:28px; font-weight:700; color:#14a0a5; }
//     .vo-stat-lbl { font-size:12px; color:rgba(255,255,255,0.5); margin-top:2px; }
//     .vo-float-cards { display:flex; flex-direction:column; gap:14px; }
//     .vo-float-card { background:rgba(255,255,255,0.06); border:1px solid rgba(255,255,255,0.1); backdrop-filter:blur(12px); border-radius:16px; padding:18px 22px; display:flex; align-items:center; gap:14px; transition:transform 0.3s; }
//     .vo-float-card:hover { transform:translateX(6px); }
//     .vo-float-icon { width:46px; height:46px; border-radius:12px; display:flex; align-items:center; justify-content:center; font-size:22px; flex-shrink:0; }
//     .vo-float-title { font-size:14px; font-weight:700; color:#fff; margin-bottom:3px; }
//     .vo-float-desc  { font-size:12px; color:rgba(255,255,255,0.55); }
//     .vo-hospitals { padding:100px 0; background:#f8fafc; }
//     .vo-container { max-width:1200px; margin:0 auto; padding:0 24px; }
//     .vo-section-tag { display:inline-flex; align-items:center; gap:6px; background:rgba(13,115,119,0.1); border:1px solid rgba(13,115,119,0.25); color:#0d7377; font-size:11px; font-weight:700; letter-spacing:1.2px; text-transform:uppercase; padding:6px 14px; border-radius:100px; margin-bottom:16px; }
//     .vo-section-title { font-family:"Cormorant Garamond",serif; font-size:clamp(32px,4vw,52px); font-weight:700; color:#0a1628; line-height:1.15; margin-bottom:16px; }
//     .vo-section-title em { font-style:italic; color:#0d7377; }
//     .vo-controls { display:flex; gap:16px; margin-bottom:32px; flex-wrap:wrap; align-items:center; }
//     .vo-search { flex:1; min-width:260px; padding:12px 18px; border-radius:10px; border:1.5px solid #e2e8f0; font-size:14px; font-family:"DM Sans",sans-serif; outline:none; background:#fff; transition:border-color 0.2s; }
//     .vo-search:focus { border-color:#0d7377; }
//     .vo-cats { display:flex; gap:8px; flex-wrap:wrap; }
//     .vo-cat { padding:8px 14px; border-radius:100px; border:1.5px solid #e2e8f0; background:#fff; font-size:13px; font-weight:600; color:#475569; cursor:pointer; transition:all 0.2s; white-space:nowrap; font-family:"DM Sans",sans-serif; }
//     .vo-cat:hover { border-color:#0d7377; color:#0d7377; }
//     .vo-cat.active { background:#0d7377; border-color:#0d7377; color:#fff; }
//     .vo-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(300px,1fr)); gap:28px; }
//     .vo-card { background:#fff; border-radius:20px; overflow:hidden; box-shadow:0 4px 32px rgba(0,0,0,0.08); transition:transform 0.28s,box-shadow 0.28s; cursor:pointer; border:1px solid #f1f5f9; }
//     .vo-card:hover { transform:translateY(-6px); box-shadow:0 12px 48px rgba(0,0,0,0.14); }
//     .vo-card-top { height:140px; display:flex; align-items:center; justify-content:center; position:relative; font-size:52px; }
//     .vo-card-badge { position:absolute; top:14px; right:14px; background:rgba(255,255,255,0.2); backdrop-filter:blur(8px); border:1px solid rgba(255,255,255,0.3); border-radius:20px; padding:4px 12px; font-size:11px; font-weight:700; color:#fff; }
//     .vo-card-body { padding:20px 22px 22px; }
//     .vo-card-name { font-family:"Cormorant Garamond",serif; font-size:20px; font-weight:700; color:#0a1628; margin-bottom:4px; }
//     .vo-card-type { font-size:12px; font-weight:700; color:#0d7377; text-transform:uppercase; letter-spacing:0.5px; margin-bottom:8px; }
//     .vo-card-city { font-size:13px; color:#94a3b8; margin-bottom:14px; }
//     .vo-card-stats { display:flex; gap:16px; padding:12px 0; border-top:1px solid #f1f5f9; border-bottom:1px solid #f1f5f9; margin-bottom:14px; }
//     .vo-card-stat { text-align:center; flex:1; }
//     .vo-card-stat-num { font-size:15px; font-weight:700; color:#0a1628; }
//     .vo-card-stat-lbl { font-size:10px; color:#94a3b8; margin-top:2px; }
//     .vo-card-btn { width:100%; padding:11px; background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; border-radius:10px; font-size:13px; font-weight:700; cursor:pointer; font-family:"DM Sans",sans-serif; }
//     .vo-empty { grid-column:1/-1; text-align:center; padding:60px 0; color:#94a3b8; font-size:15px; }
//     @keyframes vopulse { 0%,100%{opacity:1}50%{opacity:0.45} }
//     .vo-skel { background:#e2e8f0; border-radius:8px; animation:vopulse 1.5s ease-in-out infinite; }
//     .vo-cta { padding:100px 0; background:linear-gradient(135deg,#0a1628,#0d2444); text-align:center; }
//     .vo-cta-title { font-family:"Cormorant Garamond",serif; font-size:clamp(32px,4vw,52px); font-weight:700; color:#fff; margin-bottom:16px; }
//     .vo-cta-title em { font-style:italic; color:#14a0a5; }
//     .vo-cta-desc { font-size:16px; color:rgba(255,255,255,0.65); max-width:520px; margin:0 auto 40px; line-height:1.7; }
//     .vo-plans { display:flex; gap:20px; justify-content:center; flex-wrap:wrap; margin-bottom:36px; }
//     .vo-plan { background:rgba(255,255,255,0.08); border:1px solid rgba(255,255,255,0.15); border-radius:16px; padding:22px 26px; min-width:180px; }
//     .vo-plan.featured { background:linear-gradient(135deg,#0d7377,#14a0a5); border-color:transparent; }
//     .vo-plan-name { font-size:12px; font-weight:700; color:rgba(255,255,255,0.65); text-transform:uppercase; letter-spacing:1px; margin-bottom:8px; }
//     .vo-plan-price { font-family:"Cormorant Garamond",serif; font-size:30px; font-weight:700; color:#fff; line-height:1; margin-bottom:4px; }
//     .vo-plan-period { font-size:12px; color:rgba(255,255,255,0.5); margin-bottom:10px; }
//     .vo-plan-features { font-size:12px; color:rgba(255,255,255,0.6); line-height:1.6; }
//     .vo-how { padding:100px 0; background:#fff; }
//     .vo-how-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:28px; margin-top:56px; }
//     .vo-how-card { text-align:center; padding:28px 20px; border-radius:20px; background:#f8fafc; border:1px solid #f1f5f9; }
//     .vo-how-step { width:46px; height:46px; border-radius:50%; background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; font-size:18px; font-weight:800; display:flex; align-items:center; justify-content:center; margin:0 auto 14px; }
//     .vo-how-icon { font-size:30px; margin-bottom:12px; }
//     .vo-how-title { font-size:15px; font-weight:700; color:#0a1628; margin-bottom:8px; }
//     .vo-how-desc  { font-size:13px; color:#475569; line-height:1.6; }
//     .vo-footer { background:#0a1628; padding:56px 0 24px; border-top:1px solid rgba(255,255,255,0.06); }
//     .vo-footer-inner { max-width:1200px; margin:0 auto; padding:0 24px 40px; display:grid; grid-template-columns:2fr 1fr 1fr; gap:48px; }
//     .vo-footer-desc { font-size:14px; color:rgba(255,255,255,0.5); line-height:1.7; margin-top:10px; max-width:280px; }
//     .vo-footer-col h4 { font-size:12px; font-weight:700; color:rgba(255,255,255,0.85); text-transform:uppercase; letter-spacing:1px; margin-bottom:14px; }
//     .vo-footer-col ul { list-style:none; }
//     .vo-footer-col ul li { margin-bottom:8px; }
//     .vo-footer-col ul li a { font-size:13px; color:rgba(255,255,255,0.5); cursor:pointer; }
//     .vo-footer-bottom { max-width:1200px; margin:0 auto; padding:20px 24px 0; border-top:1px solid rgba(255,255,255,0.07); display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:12px; font-size:13px; color:rgba(255,255,255,0.35); }

//     /* ── Footer logo ── */
//     .vo-footer-logo-icon {
//       width:36px;
//       height:36px;
//       border-radius:10px;
//       overflow:hidden;
//       flex-shrink:0;
//       display:flex;
//       align-items:center;
//       justify-content:center;
//       background:linear-gradient(135deg,#0d7377,#14a0a5);
//     }
//     .vo-footer-logo-icon img {
//       width:100%;
//       height:100%;
//       object-fit:cover;
//       display:block;
//       border-radius:10px;
//     }

//     /* ── Responsive navbar ── */
//     @media(max-width:860px) {
//       .vo-nav { padding:0 16px; }
//       .vo-nav-links { display:none !important; }
//       .vo-hamburger { display:flex; }
//       .vo-logo-icon { width:34px; height:34px; border-radius:8px; }
//       .vo-logo-text { font-size:18px; }
//       .vo-logo-sub  { font-size:8px; letter-spacing:1.5px; }
//       .vo-footer-logo-icon { width:32px; height:32px; border-radius:8px; }
//       .vo-hero-inner { grid-template-columns:1fr; }
//       .vo-float-cards { display:none; }
//       .vo-how-grid { grid-template-columns:repeat(2,1fr); }
//       .vo-footer-inner { grid-template-columns:1fr; gap:28px; }
//     }
//     @media(max-width:480px) {
//       .vo-nav { padding:0 12px; height:60px; }
//       .vo-mobile-menu { top:60px; }
//       .vo-logo-icon { width:30px; height:30px; border-radius:7px; }
//       .vo-logo-text { font-size:16px; }
//       .vo-logo-sub  { display:none; }
//       .vo-footer-logo-icon { width:28px; height:28px; border-radius:7px; }
//     }
//     @media(max-width:600px) {
//       .vo-grid { grid-template-columns:1fr; }
//       .vo-how-grid { grid-template-columns:1fr; }
//       .vo-stats { gap:20px; }
//       .vo-plans { flex-direction:column; align-items:center; }
//     }
//   `;

//   const scrollTo = (id) =>
//     document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

//   return (
//     <div style={{ fontFamily: "DM Sans,sans-serif" }}>
//       <style>{css}</style>

//       {/* Navbar */}
//       <div className="vo-nav">
//         <div className="vo-logo">
//           <div className="vo-logo-icon">
//             <img src={logo} alt="PranJeev Logo" />
//           </div>
//           <div className="vo-logo-textblock">
//             <div className="vo-logo-text">PranJeev</div>
//             <div className="vo-logo-sub">Life-Giving Healthcare</div>
//           </div>
//         </div>
//         <div className="vo-nav-links">
//           <a
//             onClick={() => scrollTo("hospitals")}
//             style={{
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 14,
//               fontWeight: 500,
//               cursor: "pointer",
//             }}
//           >
//             Hospitals
//           </a>
//           <a
//             onClick={() => scrollTo("how")}
//             style={{
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 14,
//               fontWeight: 500,
//               cursor: "pointer",
//             }}
//           >
//             How It Works
//           </a>
//           <button className="vo-nav-btn" onClick={() => setRegOpen(true)}>
//             Register Hospital
//           </button>
//           <button className="vo-nav-sa" onClick={() => navigate("/superadmin")}>
//             🛡️ Admin
//           </button>
//         </div>
//         <button
//           className="vo-hamburger"
//           onClick={() => setMenuOpen((m) => !m)}
//           aria-label="Menu"
//         >
//           <span
//             style={{
//               transform: menuOpen ? "rotate(45deg) translate(5px,5px)" : "none",
//             }}
//           />
//           <span style={{ opacity: menuOpen ? 0 : 1 }} />
//           <span
//             style={{
//               transform: menuOpen
//                 ? "rotate(-45deg) translate(5px,-5px)"
//                 : "none",
//             }}
//           />
//         </button>
//       </div>

//       {/* Mobile Menu */}
//       <div className={`vo-mobile-menu${menuOpen ? " open" : ""}`}>
//         <button
//           className="vo-mobile-link"
//           onClick={() => {
//             scrollTo("hospitals");
//             setMenuOpen(false);
//           }}
//         >
//           🏥 Hospitals
//         </button>
//         <button
//           className="vo-mobile-link"
//           onClick={() => {
//             scrollTo("how");
//             setMenuOpen(false);
//           }}
//         >
//           ⚙️ How It Works
//         </button>
//         <button
//           className="vo-mobile-link"
//           onClick={() => {
//             scrollTo("pricing");
//             setMenuOpen(false);
//           }}
//         >
//           💰 Pricing
//         </button>
//         <button
//           className="vo-mobile-btn"
//           onClick={() => {
//             setRegOpen(true);
//             setMenuOpen(false);
//           }}
//         >
//           Register Your Hospital →
//         </button>
//         <button
//           className="vo-mobile-sa"
//           onClick={() => {
//             navigate("/superadmin");
//             setMenuOpen(false);
//           }}
//         >
//           🛡️ Admin
//         </button>
//       </div>

//       {/* Hero */}
//       <section className="vo-hero" id="home">
//         <div className="vo-hero-inner">
//           <div>
//             <div className="vo-badge">
//               🌟 India's Life-Giving Healthcare Platform
//             </div>
//             <h1>
//               Find & Book
//               <br />
//               <em>Top Hospitals</em>
//               <br />
//               Near You
//             </h1>
//             <p className="vo-hero-desc">
//               From Dental to Ortho, Ayurved to Cardiology — discover verified
//               hospitals, book appointments instantly, and manage your health all
//               in one place.
//             </p>
//             <div className="vo-actions">
//               <button
//                 className="vo-btn-primary"
//                 onClick={() => scrollTo("hospitals")}
//               >
//                 Find Hospitals →
//               </button>
//               <button
//                 className="vo-btn-outline"
//                 onClick={() => setRegOpen(true)}
//               >
//                 Register Your Hospital
//               </button>
//             </div>
//             <div className="vo-stats">
//               {[
//                 ["200+", "Hospitals"],
//                 ["50K+", "Patients"],
//                 ["7", "Specialities"],
//               ].map(([n, l]) => (
//                 <div key={l}>
//                   <div className="vo-stat-num">{n}</div>
//                   <div className="vo-stat-lbl">{l}</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//           <div className="vo-float-cards">
//             {[
//               {
//                 icon: "🦷",
//                 bg: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                 title: "Dental Care",
//                 desc: "Root canal, implants, whitening",
//               },
//               {
//                 icon: "🦴",
//                 bg: "linear-gradient(135deg,#1a3a6b,#2563eb)",
//                 title: "Ortho Care",
//                 desc: "Joint replacement, physiotherapy",
//               },
//               {
//                 icon: "🌿",
//                 bg: "linear-gradient(135deg,#166534,#16a34a)",
//                 title: "Ayurved",
//                 desc: "Panchakarma, herbal treatments",
//               },
//               {
//                 icon: "❤️",
//                 bg: "linear-gradient(135deg,#881337,#dc2626)",
//                 title: "Cardiology",
//                 desc: "Heart care, ECG, consultations",
//               },
//             ].map((c) => (
//               <div key={c.title} className="vo-float-card">
//                 <div className="vo-float-icon" style={{ background: c.bg }}>
//                   {c.icon}
//                 </div>
//                 <div>
//                   <div className="vo-float-title">{c.title}</div>
//                   <div className="vo-float-desc">{c.desc}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Hospital Grid */}
//       <section className="vo-hospitals" id="hospitals">
//         <div className="vo-container">
//           <div style={{ textAlign: "center", marginBottom: 48 }}>
//             <div className="vo-section-tag">🏥 Browse Hospitals</div>
//             <h2 className="vo-section-title">
//               Find the Right
//               <br />
//               <em>Hospital for You</em>
//             </h2>
//             <p
//               style={{
//                 fontSize: 16,
//                 color: "#475569",
//                 maxWidth: 540,
//                 margin: "0 auto",
//                 lineHeight: 1.7,
//               }}
//             >
//               Browse verified hospitals by speciality or city.
//             </p>
//           </div>
//           <div className="vo-controls">
//             <input
//               className="vo-search"
//               placeholder="🔍 Search by hospital name or city..."
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               autoComplete="off"
//             />
//             <div className="vo-cats">
//               {CATEGORIES.map((c) => (
//                 <button
//                   key={c.id}
//                   className={`vo-cat${activeCat === c.id ? " active" : ""}`}
//                   onClick={() => setActiveCat(c.id)}
//                 >
//                   {c.icon} {c.label}
//                 </button>
//               ))}
//             </div>
//           </div>
//           <div style={{ fontSize: 13, color: "#94a3b8", marginBottom: 24 }}>
//             {loading
//               ? "Loading hospitals..."
//               : `${filtered.length} hospital${filtered.length !== 1 ? "s" : ""} found`}
//           </div>
//           <div className="vo-grid">
//             {loading ? (
//               [1, 2, 3, 4, 5, 6].map((i) => (
//                 <div
//                   key={i}
//                   style={{
//                     background: "#fff",
//                     borderRadius: 20,
//                     overflow: "hidden",
//                   }}
//                 >
//                   <div className="vo-skel" style={{ height: 140 }} />
//                   <div style={{ padding: "20px 22px" }}>
//                     <div
//                       className="vo-skel"
//                       style={{ height: 20, width: "70%", marginBottom: 8 }}
//                     />
//                     <div
//                       className="vo-skel"
//                       style={{ height: 13, width: "40%", marginBottom: 14 }}
//                     />
//                     <div
//                       className="vo-skel"
//                       style={{ height: 38, borderRadius: 10 }}
//                     />
//                   </div>
//                 </div>
//               ))
//             ) : filtered.length === 0 ? (
//               <div className="vo-empty">No hospitals match your search.</div>
//             ) : (
//               filtered.map((h) => {
//                 const type = (h.type || "general").toLowerCase();
//                 const grad = CAT_GRADIENTS[type] || CAT_GRADIENTS.general;
//                 const cat = CATEGORIES.find((c) => c.id === type);
//                 return (
//                   <div
//                     key={h._id}
//                     className="vo-card"
//                     onClick={() => navigate(`/hospital/${h.slug}`)}
//                   >
//                     <div className="vo-card-top" style={{ background: grad }}>
//                       <div className="vo-card-badge">
//                         {cat?.label || "Hospital"}
//                       </div>
//                       {h.logoUrl ? (
//                         <img
//                           src={h.logoUrl}
//                           alt={h.name}
//                           style={{
//                             width: 70,
//                             height: 70,
//                             borderRadius: "50%",
//                             objectFit: "cover",
//                             border: "3px solid rgba(255,255,255,0.3)",
//                           }}
//                         />
//                       ) : (
//                         <span>{CAT_ICONS[type] || "🏥"}</span>
//                       )}
//                     </div>
//                     <div className="vo-card-body">
//                       <div className="vo-card-name">{h.name}</div>
//                       <div className="vo-card-type">
//                         {cat?.icon} {cat?.label || "Hospital"}
//                       </div>
//                       <div className="vo-card-city">
//                         📍 {h.city || "Location not specified"}
//                       </div>
//                       <div className="vo-card-stats">
//                         {[
//                           ["Patients", h.statPatients],
//                           ["Doctors", h.statDoctors],
//                           ["Rating", h.statRating],
//                         ].map(([l, v]) => (
//                           <div key={l} className="vo-card-stat">
//                             <div className="vo-card-stat-num">{v || "—"}</div>
//                             <div className="vo-card-stat-lbl">{l}</div>
//                           </div>
//                         ))}
//                       </div>
//                       <button className="vo-card-btn">
//                         Book Appointment →
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>
//       </section>

//       {/* How It Works */}
//       <section className="vo-how" id="how">
//         <div className="vo-container">
//           <div style={{ textAlign: "center" }}>
//             <div className="vo-section-tag">Simple Process</div>
//             <h2 className="vo-section-title">
//               How <em>PranJeev</em> Works
//             </h2>
//             <p
//               style={{
//                 fontSize: 16,
//                 color: "#475569",
//                 maxWidth: 520,
//                 margin: "0 auto",
//                 lineHeight: 1.7,
//               }}
//             >
//               Get your hospital live in under 10 minutes. No technical knowledge
//               required.
//             </p>
//           </div>
//           <div className="vo-how-grid">
//             {[
//               {
//                 step: "1",
//                 icon: "🏥",
//                 title: "Register Hospital",
//                 desc: "Fill your hospital details, choose a plan and pay securely.",
//               },
//               {
//                 step: "2",
//                 icon: "⚙️",
//                 title: "Setup Your Panel",
//                 desc: "Add your doctors, services and pricing inside your admin dashboard.",
//               },
//               {
//                 step: "3",
//                 icon: "📅",
//                 title: "Patients Book",
//                 desc: "Patients find your hospital on PranJeev and book appointments online.",
//               },
//               {
//                 step: "4",
//                 icon: "📊",
//                 title: "Manage Everything",
//                 desc: "Track appointments, patients, billing and doctor availability in one panel.",
//               },
//             ].map((s) => (
//               <div key={s.step} className="vo-how-card">
//                 <div className="vo-how-step">{s.step}</div>
//                 <div className="vo-how-icon">{s.icon}</div>
//                 <div className="vo-how-title">{s.title}</div>
//                 <div className="vo-how-desc">{s.desc}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA / Pricing */}
//       <section className="vo-cta" id="pricing">
//         <div className="vo-container">
//           <div
//             className="vo-section-tag"
//             style={{
//               background: "rgba(201,168,76,0.15)",
//               borderColor: "rgba(201,168,76,0.3)",
//               color: "#c9a845",
//             }}
//           >
//             💰 Simple Pricing
//           </div>
//           <h2 className="vo-cta-title">
//             Register Your Hospital
//             <br />
//             <em>Start Today</em>
//           </h2>
//           <p className="vo-cta-desc">
//             Choose a plan that fits your hospital. All plans include full admin
//             panel, patient management & WhatsApp integration.
//           </p>
//           <div className="vo-plans">
//             {[
//               {
//                 name: "Starter",
//                 price: "₹999",
//                 period: "/month",
//                 features: "3 Doctors · Appointments · Patients",
//               },
//               {
//                 name: "Pro",
//                 price: "₹1,999",
//                 period: "/month",
//                 features: "10 Doctors · Billing · WhatsApp",
//                 featured: true,
//               },
//               {
//                 name: "Enterprise",
//                 price: "₹3,499",
//                 period: "/month",
//                 features: "Unlimited · Priority Support · Custom Domain",
//               },
//             ].map((p) => (
//               <div
//                 key={p.name}
//                 className={`vo-plan${p.featured ? " featured" : ""}`}
//               >
//                 <div className="vo-plan-name">{p.name}</div>
//                 <div className="vo-plan-price">{p.price}</div>
//                 <div className="vo-plan-period">{p.period}</div>
//                 <div className="vo-plan-features">{p.features}</div>
//               </div>
//             ))}
//           </div>
//           <button
//             className="vo-btn-primary"
//             style={{ fontSize: 16, padding: "15px 36px" }}
//             onClick={() => setRegOpen(true)}
//           >
//             Register Your Hospital Now →
//           </button>
//           <div
//             style={{
//               fontSize: 12,
//               color: "rgba(255,255,255,0.4)",
//               marginTop: 14,
//             }}
//           >
//             14-day free trial · No credit card required to start
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="vo-footer">
//         <div className="vo-footer-inner">
//           <div>
//             <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//               <div className="vo-footer-logo-icon">
//                 <img src={logo} alt="PranJeev Logo" />
//               </div>
//               <div>
//                 <div
//                   style={{
//                     fontFamily: "Cormorant Garamond,serif",
//                     fontSize: 20,
//                     fontWeight: 700,
//                     color: "#fff",
//                   }}
//                 >
//                   PranJeev
//                 </div>
//                 <div
//                   style={{
//                     fontSize: 9,
//                     color: "#c9a845",
//                     letterSpacing: 2,
//                     textTransform: "uppercase",
//                   }}
//                 >
//                   Life-Giving Healthcare
//                 </div>
//               </div>
//             </div>
//             <p className="vo-footer-desc">
//               Prana (life force) + Jeev (living being) — India's life-giving
//               hospital management platform.
//             </p>
//           </div>
//           <div className="vo-footer-col">
//             <h4>For Hospitals</h4>
//             <ul>
//               {[
//                 "Register Hospital",
//                 "Pricing Plans",
//                 "How It Works",
//                 "Admin Login",
//               ].map((s) => (
//                 <li key={s}>
//                   <a>{s}</a>
//                 </li>
//               ))}
//             </ul>
//           </div>
//           <div className="vo-footer-col">
//             <h4>Specialities</h4>
//             <ul>
//               {[
//                 "🦷 Dental",
//                 "🦴 Ortho",
//                 "🌿 Ayurved",
//                 "❤️ Cardiology",
//                 "👁️ Eye Care",
//                 "👶 Pediatric",
//               ].map((s) => (
//                 <li key={s}>
//                   <a>{s}</a>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>
//         <div className="vo-footer-bottom">
//           <p>
//             © 2026 PranJeev · Life-Giving Healthcare Platform. All rights
//             reserved.
//           </p>
//           <div style={{ display: "flex", gap: 24 }}>
//             <a>Privacy Policy</a>
//             <a>Terms of Service</a>
//           </div>
//         </div>
//       </footer>

//       {regOpen && (
//         <RegisterModal
//           onClose={() => {
//             setRegOpen(false);
//             fetchHospitals();
//           }}
//         />
//       )}
//     </div>
//   );
// }

// logofixed
// // ============================================================
// // src/pages/PranJeev.js  (renamed from VidyaOne.js)
// // ✅ Full rebrand: VidyaOne → PranJeev
// // ✅ Super Admin button in navbar
// // ✅ Registration secret key gate
// // ✅ Logo: replaced emoji with logo.jpeg
// // ✅ FIXED: Mobile navbar larger, logo 2x on mobile/tablet
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import logo from "../assets/logo.jpeg";

// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// const PEARLSMILE_CARD = {
//   _id: "pearlsmile-static",
//   name: "PearlSmile Dental Hospital",
//   type: "dental",
//   city: "Pune, Maharashtra",
//   slug: "pearlsmile",
//   statPatients: "18K+",
//   statDoctors: "20+",
//   statRating: "4.9★",
//   logoUrl: "",
// };

// const CATEGORIES = [
//   { id: "all", label: "All", icon: "🏥" },
//   { id: "dental", label: "Dental", icon: "🦷" },
//   { id: "ortho", label: "Ortho", icon: "🦴" },
//   { id: "ayurved", label: "Ayurved", icon: "🌿" },
//   { id: "cardiology", label: "Cardiology", icon: "❤️" },
//   { id: "eye", label: "Eye", icon: "👁️" },
//   { id: "pediatric", label: "Pediatric", icon: "👶" },
//   { id: "general", label: "General", icon: "➕" },
// ];

// const CAT_GRADIENTS = {
//   dental: "linear-gradient(135deg,#0d7377,#14a0a5)",
//   ortho: "linear-gradient(135deg,#1a3a6b,#2563eb)",
//   ayurved: "linear-gradient(135deg,#166534,#16a34a)",
//   cardiology: "linear-gradient(135deg,#881337,#dc2626)",
//   eye: "linear-gradient(135deg,#4338ca,#7c3aed)",
//   pediatric: "linear-gradient(135deg,#c2410c,#f97316)",
//   general: "linear-gradient(135deg,#0f766e,#0d9488)",
// };

// const CAT_ICONS = {
//   dental: "🦷",
//   ortho: "🦴",
//   ayurved: "🌿",
//   cardiology: "❤️",
//   eye: "👁️",
//   pediatric: "👶",
//   general: "➕",
// };

// const TYPES = [
//   "Dental",
//   "Ortho",
//   "Ayurved",
//   "Cardiology",
//   "Eye",
//   "Pediatric",
//   "General",
// ];
// const PLANS = [
//   { id: "starter", label: "Starter — ₹999/mo" },
//   { id: "pro", label: "Pro — ₹1,999/mo" },
//   { id: "enterprise", label: "Enterprise — ₹3,499/mo" },
// ];

// // ── Register Modal ────────────────────────────────────────────
// function RegisterModal({ onClose }) {
//   const [step, setStep] = useState(1);
//   const [saving, setSaving] = useState(false);
//   const [msg, setMsg] = useState("");
//   const [form, setForm] = useState({
//     name: "",
//     type: "",
//     phone: "",
//     whatsapp: "",
//     email: "",
//     address: "",
//     city: "",
//     established: "",
//     plan: "pro",
//     adminId: "",
//     password: "",
//     registrationKey: "",
//   });
//   const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

//   const inp = {
//     width: "100%",
//     padding: "10px 14px",
//     borderRadius: 8,
//     border: "1.5px solid #e2e8f0",
//     fontSize: 14,
//     fontFamily: "DM Sans,sans-serif",
//     outline: "none",
//     background: "#f8fafc",
//     boxSizing: "border-box",
//     marginTop: 4,
//     marginBottom: 12,
//   };
//   const lbl = {
//     fontSize: 12,
//     fontWeight: 600,
//     color: "#475569",
//     display: "block",
//   };

//   const next = () => {
//     if (!form.name || !form.type || !form.phone || !form.city) {
//       setMsg("Please fill all required fields.");
//       return;
//     }
//     setMsg("");
//     setStep(2);
//   };

//   const submit = async () => {
//     if (!form.adminId || !form.password) {
//       setMsg("Admin ID and password are required.");
//       return;
//     }
//     if (!form.registrationKey.trim()) {
//       setMsg(
//         "Registration access key is required. Contact PranJeev on WhatsApp to get your key.",
//       );
//       return;
//     }
//     setSaving(true);
//     setMsg("");
//     try {
//       const slug = form.name
//         .toLowerCase()
//         .replace(/[^a-z0-9]+/g, "-")
//         .replace(/^-|-$/g, "");
//       const res = await fetch(`${API_URL}/hospitals/register`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ ...form, slug }),
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message || "Registration failed");
//       setStep(3);
//     } catch (err) {
//       setMsg(err.message);
//     }
//     setSaving(false);
//   };

//   return (
//     <div
//       style={{
//         position: "fixed",
//         inset: 0,
//         background: "rgba(0,0,0,0.6)",
//         backdropFilter: "blur(4px)",
//         zIndex: 2000,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: 20,
//       }}
//       onClick={(e) => {
//         if (e.target === e.currentTarget) onClose();
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 24,
//           width: "100%",
//           maxWidth: 520,
//           maxHeight: "90vh",
//           overflowY: "auto",
//           boxShadow: "0 24px 80px rgba(0,0,0,0.4)",
//         }}
//       >
//         {/* Header */}
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             padding: "22px 28px",
//             borderRadius: "24px 24px 0 0",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div>
//             <div style={{ fontSize: 17, fontWeight: 700, color: "#fff" }}>
//               {step === 3
//                 ? "🎉 Registration Successful!"
//                 : "🏥 Register Your Hospital"}
//             </div>
//             <div
//               style={{
//                 fontSize: 12,
//                 color: "rgba(255,255,255,0.55)",
//                 marginTop: 3,
//               }}
//             >
//               {step === 1 && "Step 1 of 2 — Hospital Details"}
//               {step === 2 && "Step 2 of 2 — Admin Credentials & Access Key"}
//               {step === 3 && "Your hospital is now live on PranJeev!"}
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.12)",
//               border: "none",
//               color: "#fff",
//               width: 32,
//               height: 32,
//               borderRadius: "50%",
//               fontSize: 16,
//               cursor: "pointer",
//             }}
//           >
//             ✕
//           </button>
//         </div>

//         <form
//           autoComplete="off"
//           onSubmit={(e) => e.preventDefault()}
//           style={{ padding: 28 }}
//         >
//           {msg && (
//             <div
//               style={{
//                 background: "#fef2f2",
//                 border: "1px solid #fecaca",
//                 borderRadius: 8,
//                 padding: "10px 14px",
//                 marginBottom: 16,
//                 fontSize: 13,
//                 color: "#dc2626",
//               }}
//             >
//               {msg}
//             </div>
//           )}

//           {/* STEP 1 */}
//           {step === 1 && (
//             <>
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "1fr 1fr",
//                   gap: "0 14px",
//                 }}
//               >
//                 <div>
//                   <label style={lbl}>Hospital Name *</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. Sai Dental Hospital"
//                     autoComplete="off"
//                     value={form.name}
//                     onChange={(e) => set("name", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Hospital Type *</label>
//                   <select
//                     style={inp}
//                     value={form.type}
//                     onChange={(e) => set("type", e.target.value)}
//                   >
//                     <option value="">Select type</option>
//                     {TYPES.map((t) => (
//                       <option key={t} value={t.toLowerCase()}>
//                         {t}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 <div>
//                   <label style={lbl}>Phone *</label>
//                   <input
//                     style={inp}
//                     placeholder="+91 98765 43210"
//                     autoComplete="off"
//                     value={form.phone}
//                     onChange={(e) => set("phone", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>WhatsApp (no +)</label>
//                   <input
//                     style={inp}
//                     placeholder="919876543210"
//                     autoComplete="off"
//                     value={form.whatsapp}
//                     onChange={(e) => set("whatsapp", e.target.value)}
//                   />
//                 </div>
//                 <div style={{ gridColumn: "1/-1" }}>
//                   <label style={lbl}>Email</label>
//                   <input
//                     style={inp}
//                     type="email"
//                     placeholder="info@hospital.com"
//                     autoComplete="off"
//                     value={form.email}
//                     onChange={(e) => set("email", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Address</label>
//                   <input
//                     style={inp}
//                     placeholder="Street, Area"
//                     autoComplete="off"
//                     value={form.address}
//                     onChange={(e) => set("address", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>City *</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. Mumbai, MH"
//                     autoComplete="off"
//                     value={form.city}
//                     onChange={(e) => set("city", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Established Year</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. 2010"
//                     autoComplete="off"
//                     value={form.established}
//                     onChange={(e) => set("established", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Plan</label>
//                   <select
//                     style={inp}
//                     value={form.plan}
//                     onChange={(e) => set("plan", e.target.value)}
//                   >
//                     {PLANS.map((p) => (
//                       <option key={p.id} value={p.id}>
//                         {p.label}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//               <button
//                 onClick={next}
//                 style={{
//                   width: "100%",
//                   padding: 13,
//                   background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 10,
//                   fontSize: 15,
//                   fontWeight: 700,
//                   cursor: "pointer",
//                 }}
//               >
//                 Next: Create Admin Account →
//               </button>
//             </>
//           )}

//           {/* STEP 2 */}
//           {step === 2 && (
//             <>
//               <div
//                 style={{
//                   background: "#f0fdf4",
//                   border: "1px solid #bbf7d0",
//                   borderRadius: 10,
//                   padding: "12px 16px",
//                   marginBottom: 20,
//                   fontSize: 13,
//                   color: "#166534",
//                 }}
//               >
//                 ✅ <strong>{form.name}</strong> · {form.city}
//               </div>
//               <label style={lbl}>Admin ID *</label>
//               <input
//                 style={inp}
//                 placeholder="e.g. saidental_admin"
//                 autoComplete="off"
//                 value={form.adminId}
//                 onChange={(e) => set("adminId", e.target.value)}
//               />
//               <label style={lbl}>Password *</label>
//               <input
//                 style={inp}
//                 type="password"
//                 placeholder="Create a strong password"
//                 autoComplete="new-password"
//                 value={form.password}
//                 onChange={(e) => set("password", e.target.value)}
//               />
//               <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 18 }}>
//                 💡 Save these credentials — you'll use them to login to your
//                 admin panel.
//               </div>
//               <div
//                 style={{
//                   background: "#fffbeb",
//                   border: "1px solid #fde68a",
//                   borderRadius: 10,
//                   padding: "14px 16px",
//                   marginBottom: 16,
//                 }}
//               >
//                 <div
//                   style={{
//                     fontSize: 13,
//                     fontWeight: 700,
//                     color: "#92400e",
//                     marginBottom: 8,
//                   }}
//                 >
//                   🔐 Registration Access Key Required
//                 </div>
//                 <div
//                   style={{
//                     fontSize: 12,
//                     color: "#92400e",
//                     marginBottom: 10,
//                     lineHeight: 1.5,
//                   }}
//                 >
//                   This is a private key provided by PranJeev. Without it,
//                   registration is not allowed. Contact us on WhatsApp to get
//                   your key before registering.
//                 </div>
//                 <a
//                   href="https://wa.me/918793608083?text=Hi%20PranJeev%2C%20I%20want%20to%20register%20my%20hospital.%20Please%20share%20the%20registration%20key."
//                   target="_blank"
//                   rel="noreferrer"
//                   style={{
//                     display: "inline-flex",
//                     alignItems: "center",
//                     gap: 8,
//                     margin: "6px 0 12px",
//                     background: "#25d366",
//                     color: "#fff",
//                     borderRadius: 8,
//                     padding: "9px 16px",
//                     fontSize: 13,
//                     fontWeight: 700,
//                     textDecoration: "none",
//                   }}
//                 >
//                   💬 Contact PranJeev Owner — +91 87936 08083
//                 </a>
//                 <label style={{ ...lbl, color: "#92400e" }}>Access Key *</label>
//                 <input
//                   style={{
//                     ...inp,
//                     marginBottom: 0,
//                     background: "#fff",
//                     border: "1.5px solid #fcd34d",
//                   }}
//                   type="password"
//                   placeholder="Enter your PranJeev registration key"
//                   autoComplete="new-password"
//                   value={form.registrationKey}
//                   onChange={(e) => set("registrationKey", e.target.value)}
//                 />
//               </div>
//               <div style={{ display: "flex", gap: 10 }}>
//                 <button
//                   onClick={() => setStep(1)}
//                   style={{
//                     flex: 1,
//                     padding: 13,
//                     background: "#f1f5f9",
//                     color: "#475569",
//                     border: "none",
//                     borderRadius: 10,
//                     fontSize: 14,
//                     fontWeight: 600,
//                     cursor: "pointer",
//                   }}
//                 >
//                   ← Back
//                 </button>
//                 <button
//                   onClick={submit}
//                   disabled={saving}
//                   style={{
//                     flex: 2,
//                     padding: 13,
//                     background: saving
//                       ? "#94a3b8"
//                       : "linear-gradient(135deg,#0d7377,#14a0a5)",
//                     color: "#fff",
//                     border: "none",
//                     borderRadius: 10,
//                     fontSize: 15,
//                     fontWeight: 700,
//                     cursor: saving ? "not-allowed" : "pointer",
//                   }}
//                 >
//                   {saving ? "Registering..." : "🚀 Complete Registration"}
//                 </button>
//               </div>
//             </>
//           )}

//           {/* STEP 3 */}
//           {step === 3 && (
//             <div style={{ textAlign: "center", padding: "20px 0" }}>
//               <div style={{ fontSize: 64, marginBottom: 16 }}>🎉</div>
//               <h3
//                 style={{
//                   fontSize: 22,
//                   fontWeight: 700,
//                   color: "#0a1628",
//                   marginBottom: 8,
//                 }}
//               >
//                 {form.name}
//               </h3>
//               <p
//                 style={{
//                   fontSize: 14,
//                   color: "#64748b",
//                   marginBottom: 24,
//                   lineHeight: 1.6,
//                 }}
//               >
//                 Your hospital is now live on PranJeev! Use your credentials to
//                 login.
//               </p>
//               <div
//                 style={{
//                   background: "#f0fdf4",
//                   border: "1px solid #bbf7d0",
//                   borderRadius: 12,
//                   padding: "16px 20px",
//                   marginBottom: 24,
//                   textAlign: "left",
//                 }}
//               >
//                 <div
//                   style={{
//                     fontSize: 12,
//                     fontWeight: 700,
//                     color: "#16a34a",
//                     marginBottom: 8,
//                   }}
//                 >
//                   YOUR LOGIN CREDENTIALS
//                 </div>
//                 <div style={{ fontSize: 14, color: "#166534" }}>
//                   Admin ID: <strong>{form.adminId}</strong>
//                 </div>
//                 <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>
//                   (Save your password securely)
//                 </div>
//               </div>
//               <button
//                 onClick={onClose}
//                 style={{
//                   width: "100%",
//                   padding: 13,
//                   background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 10,
//                   fontSize: 15,
//                   fontWeight: 700,
//                   cursor: "pointer",
//                 }}
//               >
//                 Done ✓
//               </button>
//             </div>
//           )}
//         </form>
//       </div>
//     </div>
//   );
// }

// // ── Main PranJeev Page ────────────────────────────────────────
// export default function PranJeev() {
//   const navigate = useNavigate();
//   const [hospitals, setHospitals] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState("");
//   const [activeCat, setActiveCat] = useState("all");
//   const [regOpen, setRegOpen] = useState(false);
//   const [menuOpen, setMenuOpen] = useState(false);

//   const fetchHospitals = useCallback(async () => {
//     setLoading(true);
//     try {
//       const r = await fetch(`${API_URL}/hospitals`);
//       if (r.ok) {
//         const data = await r.json();
//         setHospitals(Array.isArray(data) ? data : []);
//       }
//     } catch (_) {}
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     fetchHospitals();
//   }, [fetchHospitals]);

//   const allHospitals = [
//     PEARLSMILE_CARD,
//     ...hospitals.filter((h) => h.slug !== "pearlsmile"),
//   ];

//   const filtered = allHospitals.filter((h) => {
//     const matchCat =
//       activeCat === "all" || (h.type || "").toLowerCase() === activeCat;
//     const q = search.toLowerCase();
//     const matchSearch =
//       !q ||
//       (h.name || "").toLowerCase().includes(q) ||
//       (h.city || "").toLowerCase().includes(q) ||
//       (h.type || "").toLowerCase().includes(q);
//     return matchCat && matchSearch;
//   });

//   const css = `
//     * { box-sizing:border-box; margin:0; padding:0; }
//     body { font-family:"DM Sans",sans-serif; }
//     .vo-nav { position:fixed; top:0; left:0; right:0; z-index:1000; background:rgba(10,22,40,0.97); backdrop-filter:blur(12px); border-bottom:1px solid rgba(255,255,255,0.06); display:flex; align-items:center; justify-content:space-between; padding:0 40px; height:68px; gap:16px; }
//     .vo-logo { display:flex; align-items:center; gap:10px; cursor:pointer; flex-shrink:0; min-width:0; }
//     .vo-logo-icon { width:38px; height:38px; border-radius:10px; overflow:hidden; flex-shrink:0; display:flex; align-items:center; justify-content:center; background:linear-gradient(135deg,#0d7377,#14a0a5); }
//     .vo-logo-icon img { width:100%; height:100%; object-fit:cover; display:block; border-radius:10px; }
//     .vo-logo-textblock { display:flex; flex-direction:column; min-width:0; }
//     .vo-logo-text { font-family:"Cormorant Garamond",serif; font-size:22px; font-weight:700; color:#fff; white-space:nowrap; line-height:1.2; }
//     .vo-logo-sub  { font-size:9px; color:#c9a845; letter-spacing:2px; text-transform:uppercase; white-space:nowrap; }
//     .vo-nav-links { display:flex; align-items:center; gap:12px; flex-shrink:0; }
//     .vo-nav-btn { background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; padding:10px 22px; border-radius:8px; font-weight:700; font-size:13px; font-family:"DM Sans",sans-serif; cursor:pointer; white-space:nowrap; }
//     .vo-nav-sa  { background:rgba(255,255,255,0.06); color:rgba(255,255,255,0.55); border:1px solid rgba(255,255,255,0.12); padding:8px 14px; border-radius:8px; font-weight:600; font-size:12px; font-family:"DM Sans",sans-serif; cursor:pointer; white-space:nowrap; }
//     .vo-nav-sa:hover { background:rgba(255,255,255,0.12); color:#fff; }
//     .vo-hamburger { display:none; flex-direction:column; gap:5px; background:none; border:none; cursor:pointer; padding:6px; z-index:1100; flex-shrink:0; }
//     .vo-hamburger span { display:block; width:28px; height:2.5px; background:#fff; border-radius:2px; transition:all 0.3s; }
//     .vo-mobile-menu { display:none; position:fixed; top:68px; left:0; right:0; background:rgba(10,22,40,0.98); backdrop-filter:blur(16px); border-bottom:1px solid rgba(255,255,255,0.08); padding:16px 20px 20px; flex-direction:column; gap:12px; z-index:999; }
//     .vo-mobile-menu.open { display:flex; }
//     .vo-mobile-link { color:rgba(255,255,255,0.8); font-size:15px; font-weight:500; padding:10px 0; border-bottom:1px solid rgba(255,255,255,0.07); cursor:pointer; font-family:"DM Sans",sans-serif; background:none; border-left:none; border-right:none; border-top:none; text-align:left; }
//     .vo-mobile-btn { width:100%; padding:12px; background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; border-radius:10px; font-size:14px; font-weight:700; cursor:pointer; font-family:"DM Sans",sans-serif; margin-top:4px; }
//     .vo-mobile-sa  { width:100%; padding:10px; background:rgba(255,255,255,0.06); color:rgba(255,255,255,0.7); border:1px solid rgba(255,255,255,0.15); border-radius:10px; font-size:13px; font-weight:600; cursor:pointer; font-family:"DM Sans",sans-serif; }
//     .vo-hero { min-height:100vh; background:linear-gradient(135deg,#0a1628 0%,#0d2444 50%,#0a1f3a 100%); display:flex; align-items:center; padding-top:68px; position:relative; overflow:hidden; }
//     .vo-hero::before { content:""; position:absolute; top:-200px; right:-200px; width:600px; height:600px; background:radial-gradient(circle,rgba(13,115,119,0.15) 0%,transparent 70%); border-radius:50%; }
//     .vo-hero-inner { max-width:1200px; margin:0 auto; padding:80px 24px; display:grid; grid-template-columns:1fr 1fr; gap:60px; align-items:center; position:relative; z-index:1; }
//     .vo-badge { display:inline-flex; align-items:center; gap:8px; background:rgba(201,168,76,0.15); border:1px solid rgba(201,168,76,0.3); color:#c9a845; font-size:11px; font-weight:700; letter-spacing:1px; text-transform:uppercase; padding:7px 16px; border-radius:100px; margin-bottom:24px; }
//     .vo-hero h1 { font-family:"Cormorant Garamond",serif; font-size:clamp(40px,5vw,64px); font-weight:700; color:#fff; line-height:1.1; margin-bottom:20px; }
//     .vo-hero h1 em { font-style:italic; color:#14a0a5; }
//     .vo-hero-desc { font-size:16px; color:rgba(255,255,255,0.7); line-height:1.7; margin-bottom:36px; max-width:480px; }
//     .vo-actions { display:flex; gap:14px; flex-wrap:wrap; }
//     .vo-btn-primary { background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; padding:14px 28px; border-radius:10px; font-size:15px; font-weight:700; font-family:"DM Sans",sans-serif; cursor:pointer; transition:opacity 0.2s,transform 0.2s; }
//     .vo-btn-primary:hover { opacity:0.92; transform:translateY(-1px); }
//     .vo-btn-outline { background:transparent; color:#fff; border:1.5px solid rgba(255,255,255,0.3); padding:14px 28px; border-radius:10px; font-size:15px; font-weight:600; font-family:"DM Sans",sans-serif; cursor:pointer; }
//     .vo-stats { display:flex; gap:32px; margin-top:40px; }
//     .vo-stat-num { font-family:"Cormorant Garamond",serif; font-size:28px; font-weight:700; color:#14a0a5; }
//     .vo-stat-lbl { font-size:12px; color:rgba(255,255,255,0.5); margin-top:2px; }
//     .vo-float-cards { display:flex; flex-direction:column; gap:14px; }
//     .vo-float-card { background:rgba(255,255,255,0.06); border:1px solid rgba(255,255,255,0.1); backdrop-filter:blur(12px); border-radius:16px; padding:18px 22px; display:flex; align-items:center; gap:14px; transition:transform 0.3s; }
//     .vo-float-card:hover { transform:translateX(6px); }
//     .vo-float-icon { width:46px; height:46px; border-radius:12px; display:flex; align-items:center; justify-content:center; font-size:22px; flex-shrink:0; }
//     .vo-float-title { font-size:14px; font-weight:700; color:#fff; margin-bottom:3px; }
//     .vo-float-desc  { font-size:12px; color:rgba(255,255,255,0.55); }
//     .vo-hospitals { padding:100px 0; background:#f8fafc; }
//     .vo-container { max-width:1200px; margin:0 auto; padding:0 24px; }
//     .vo-section-tag { display:inline-flex; align-items:center; gap:6px; background:rgba(13,115,119,0.1); border:1px solid rgba(13,115,119,0.25); color:#0d7377; font-size:11px; font-weight:700; letter-spacing:1.2px; text-transform:uppercase; padding:6px 14px; border-radius:100px; margin-bottom:16px; }
//     .vo-section-title { font-family:"Cormorant Garamond",serif; font-size:clamp(32px,4vw,52px); font-weight:700; color:#0a1628; line-height:1.15; margin-bottom:16px; }
//     .vo-section-title em { font-style:italic; color:#0d7377; }
//     .vo-controls { display:flex; gap:16px; margin-bottom:32px; flex-wrap:wrap; align-items:center; }
//     .vo-search { flex:1; min-width:260px; padding:12px 18px; border-radius:10px; border:1.5px solid #e2e8f0; font-size:14px; font-family:"DM Sans",sans-serif; outline:none; background:#fff; transition:border-color 0.2s; }
//     .vo-search:focus { border-color:#0d7377; }
//     .vo-cats { display:flex; gap:8px; flex-wrap:wrap; }
//     .vo-cat { padding:8px 14px; border-radius:100px; border:1.5px solid #e2e8f0; background:#fff; font-size:13px; font-weight:600; color:#475569; cursor:pointer; transition:all 0.2s; white-space:nowrap; font-family:"DM Sans",sans-serif; }
//     .vo-cat:hover { border-color:#0d7377; color:#0d7377; }
//     .vo-cat.active { background:#0d7377; border-color:#0d7377; color:#fff; }
//     .vo-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(300px,1fr)); gap:28px; }
//     .vo-card { background:#fff; border-radius:20px; overflow:hidden; box-shadow:0 4px 32px rgba(0,0,0,0.08); transition:transform 0.28s,box-shadow 0.28s; cursor:pointer; border:1px solid #f1f5f9; }
//     .vo-card:hover { transform:translateY(-6px); box-shadow:0 12px 48px rgba(0,0,0,0.14); }
//     .vo-card-top { height:140px; display:flex; align-items:center; justify-content:center; position:relative; font-size:52px; }
//     .vo-card-badge { position:absolute; top:14px; right:14px; background:rgba(255,255,255,0.2); backdrop-filter:blur(8px); border:1px solid rgba(255,255,255,0.3); border-radius:20px; padding:4px 12px; font-size:11px; font-weight:700; color:#fff; }
//     .vo-card-body { padding:20px 22px 22px; }
//     .vo-card-name { font-family:"Cormorant Garamond",serif; font-size:20px; font-weight:700; color:#0a1628; margin-bottom:4px; }
//     .vo-card-type { font-size:12px; font-weight:700; color:#0d7377; text-transform:uppercase; letter-spacing:0.5px; margin-bottom:8px; }
//     .vo-card-city { font-size:13px; color:#94a3b8; margin-bottom:14px; }
//     .vo-card-stats { display:flex; gap:16px; padding:12px 0; border-top:1px solid #f1f5f9; border-bottom:1px solid #f1f5f9; margin-bottom:14px; }
//     .vo-card-stat { text-align:center; flex:1; }
//     .vo-card-stat-num { font-size:15px; font-weight:700; color:#0a1628; }
//     .vo-card-stat-lbl { font-size:10px; color:#94a3b8; margin-top:2px; }
//     .vo-card-btn { width:100%; padding:11px; background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; border-radius:10px; font-size:13px; font-weight:700; cursor:pointer; font-family:"DM Sans",sans-serif; }
//     .vo-empty { grid-column:1/-1; text-align:center; padding:60px 0; color:#94a3b8; font-size:15px; }
//     @keyframes vopulse { 0%,100%{opacity:1}50%{opacity:0.45} }
//     .vo-skel { background:#e2e8f0; border-radius:8px; animation:vopulse 1.5s ease-in-out infinite; }
//     .vo-cta { padding:100px 0; background:linear-gradient(135deg,#0a1628,#0d2444); text-align:center; }
//     .vo-cta-title { font-family:"Cormorant Garamond",serif; font-size:clamp(32px,4vw,52px); font-weight:700; color:#fff; margin-bottom:16px; }
//     .vo-cta-title em { font-style:italic; color:#14a0a5; }
//     .vo-cta-desc { font-size:16px; color:rgba(255,255,255,0.65); max-width:520px; margin:0 auto 40px; line-height:1.7; }
//     .vo-plans { display:flex; gap:20px; justify-content:center; flex-wrap:wrap; margin-bottom:36px; }
//     .vo-plan { background:rgba(255,255,255,0.08); border:1px solid rgba(255,255,255,0.15); border-radius:16px; padding:22px 26px; min-width:180px; }
//     .vo-plan.featured { background:linear-gradient(135deg,#0d7377,#14a0a5); border-color:transparent; }
//     .vo-plan-name { font-size:12px; font-weight:700; color:rgba(255,255,255,0.65); text-transform:uppercase; letter-spacing:1px; margin-bottom:8px; }
//     .vo-plan-price { font-family:"Cormorant Garamond",serif; font-size:30px; font-weight:700; color:#fff; line-height:1; margin-bottom:4px; }
//     .vo-plan-period { font-size:12px; color:rgba(255,255,255,0.5); margin-bottom:10px; }
//     .vo-plan-features { font-size:12px; color:rgba(255,255,255,0.6); line-height:1.6; }
//     .vo-how { padding:100px 0; background:#fff; }
//     .vo-how-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:28px; margin-top:56px; }
//     .vo-how-card { text-align:center; padding:28px 20px; border-radius:20px; background:#f8fafc; border:1px solid #f1f5f9; }
//     .vo-how-step { width:46px; height:46px; border-radius:50%; background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; font-size:18px; font-weight:800; display:flex; align-items:center; justify-content:center; margin:0 auto 14px; }
//     .vo-how-icon { font-size:30px; margin-bottom:12px; }
//     .vo-how-title { font-size:15px; font-weight:700; color:#0a1628; margin-bottom:8px; }
//     .vo-how-desc  { font-size:13px; color:#475569; line-height:1.6; }
//     .vo-footer { background:#0a1628; padding:56px 0 24px; border-top:1px solid rgba(255,255,255,0.06); }
//     .vo-footer-inner { max-width:1200px; margin:0 auto; padding:0 24px 40px; display:grid; grid-template-columns:2fr 1fr 1fr; gap:48px; }
//     .vo-footer-desc { font-size:14px; color:rgba(255,255,255,0.5); line-height:1.7; margin-top:10px; max-width:280px; }
//     .vo-footer-col h4 { font-size:12px; font-weight:700; color:rgba(255,255,255,0.85); text-transform:uppercase; letter-spacing:1px; margin-bottom:14px; }
//     .vo-footer-col ul { list-style:none; }
//     .vo-footer-col ul li { margin-bottom:8px; }
//     .vo-footer-col ul li a { font-size:13px; color:rgba(255,255,255,0.5); cursor:pointer; }
//     .vo-footer-bottom { max-width:1200px; margin:0 auto; padding:20px 24px 0; border-top:1px solid rgba(255,255,255,0.07); display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:12px; font-size:13px; color:rgba(255,255,255,0.35); }

//     /* ── Footer logo ── */
//     .vo-footer-logo-icon { width:36px; height:36px; border-radius:10px; overflow:hidden; flex-shrink:0; display:flex; align-items:center; justify-content:center; background:linear-gradient(135deg,#0d7377,#14a0a5); }
//     .vo-footer-logo-icon img { width:100%; height:100%; object-fit:cover; display:block; border-radius:10px; }

//     /* ── Responsive navbar — FIXED: bigger logo + navbar on mobile/tablet ── */
//     @media(max-width:860px) {
//       .vo-nav { padding:0 20px; height:76px; }
//       .vo-nav-links { display:none !important; }
//       .vo-hamburger { display:flex; }
//       .vo-mobile-menu { top:76px; }
//       /* ✅ Logo 2x bigger on tablet */
//       .vo-logo-icon { width:52px; height:52px; border-radius:12px; }
//       .vo-logo-text { font-size:26px; }
//       .vo-logo-sub  { font-size:9px; letter-spacing:1.5px; display:block; }
//       .vo-logo { gap:12px; }
//       /* ✅ Hamburger bigger */
//       .vo-hamburger span { width:30px; height:3px; }
//       .vo-footer-logo-icon { width:40px; height:40px; border-radius:10px; }
//       .vo-hero-inner { grid-template-columns:1fr; }
//       .vo-float-cards { display:none; }
//       .vo-how-grid { grid-template-columns:repeat(2,1fr); }
//       .vo-footer-inner { grid-template-columns:1fr; gap:28px; }
//     }
//     @media(max-width:480px) {
//       .vo-nav { padding:0 16px; height:72px; }
//       .vo-mobile-menu { top:72px; }
//       /* ✅ Logo 2x bigger on mobile */
//       .vo-logo-icon { width:48px; height:48px; border-radius:11px; }
//       .vo-logo-text { font-size:24px; }
//       .vo-logo-sub  { font-size:8px; letter-spacing:1.2px; display:block; }
//       .vo-logo { gap:11px; }
//       .vo-footer-logo-icon { width:36px; height:36px; border-radius:9px; }
//     }
//     @media(max-width:600px) {
//       .vo-grid { grid-template-columns:1fr; }
//       .vo-how-grid { grid-template-columns:1fr; }
//       .vo-stats { gap:20px; }
//       .vo-plans { flex-direction:column; align-items:center; }
//     }
//   `;

//   const scrollTo = (id) =>
//     document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

//   return (
//     <div style={{ fontFamily: "DM Sans,sans-serif" }}>
//       <style>{css}</style>

//       {/* Navbar */}
//       <div className="vo-nav">
//         <div className="vo-logo">
//           <div className="vo-logo-icon">
//             <img src={logo} alt="PranJeev Logo" />
//           </div>
//           <div className="vo-logo-textblock">
//             <div className="vo-logo-text">PranJeev</div>
//             <div className="vo-logo-sub">Life-Giving Healthcare</div>
//           </div>
//         </div>
//         <div className="vo-nav-links">
//           <a
//             onClick={() => scrollTo("hospitals")}
//             style={{
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 14,
//               fontWeight: 500,
//               cursor: "pointer",
//             }}
//           >
//             Hospitals
//           </a>
//           <a
//             onClick={() => scrollTo("how")}
//             style={{
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 14,
//               fontWeight: 500,
//               cursor: "pointer",
//             }}
//           >
//             How It Works
//           </a>
//           <button className="vo-nav-btn" onClick={() => setRegOpen(true)}>
//             Register Hospital
//           </button>
//           <button className="vo-nav-sa" onClick={() => navigate("/superadmin")}>
//             🛡️ Admin
//           </button>
//         </div>
//         <button
//           className="vo-hamburger"
//           onClick={() => setMenuOpen((m) => !m)}
//           aria-label="Menu"
//         >
//           <span
//             style={{
//               transform: menuOpen ? "rotate(45deg) translate(5px,5px)" : "none",
//             }}
//           />
//           <span style={{ opacity: menuOpen ? 0 : 1 }} />
//           <span
//             style={{
//               transform: menuOpen
//                 ? "rotate(-45deg) translate(5px,-5px)"
//                 : "none",
//             }}
//           />
//         </button>
//       </div>

//       {/* Mobile Menu */}
//       <div className={`vo-mobile-menu${menuOpen ? " open" : ""}`}>
//         <button
//           className="vo-mobile-link"
//           onClick={() => {
//             scrollTo("hospitals");
//             setMenuOpen(false);
//           }}
//         >
//           🏥 Hospitals
//         </button>
//         <button
//           className="vo-mobile-link"
//           onClick={() => {
//             scrollTo("how");
//             setMenuOpen(false);
//           }}
//         >
//           ⚙️ How It Works
//         </button>
//         <button
//           className="vo-mobile-link"
//           onClick={() => {
//             scrollTo("pricing");
//             setMenuOpen(false);
//           }}
//         >
//           💰 Pricing
//         </button>
//         <button
//           className="vo-mobile-btn"
//           onClick={() => {
//             setRegOpen(true);
//             setMenuOpen(false);
//           }}
//         >
//           Register Your Hospital →
//         </button>
//         <button
//           className="vo-mobile-sa"
//           onClick={() => {
//             navigate("/superadmin");
//             setMenuOpen(false);
//           }}
//         >
//           🛡️ Admin
//         </button>
//       </div>

//       {/* Hero */}
//       <section className="vo-hero" id="home">
//         <div className="vo-hero-inner">
//           <div>
//             <div className="vo-badge">
//               🌟 India's Life-Giving Healthcare Platform
//             </div>
//             <h1>
//               Find & Book
//               <br />
//               <em>Top Hospitals</em>
//               <br />
//               Near You
//             </h1>
//             <p className="vo-hero-desc">
//               From Dental to Ortho, Ayurved to Cardiology — discover verified
//               hospitals, book appointments instantly, and manage your health all
//               in one place.
//             </p>
//             <div className="vo-actions">
//               <button
//                 className="vo-btn-primary"
//                 onClick={() => scrollTo("hospitals")}
//               >
//                 Find Hospitals →
//               </button>
//               <button
//                 className="vo-btn-outline"
//                 onClick={() => setRegOpen(true)}
//               >
//                 Register Your Hospital
//               </button>
//             </div>
//             <div className="vo-stats">
//               {[
//                 ["200+", "Hospitals"],
//                 ["50K+", "Patients"],
//                 ["7", "Specialities"],
//               ].map(([n, l]) => (
//                 <div key={l}>
//                   <div className="vo-stat-num">{n}</div>
//                   <div className="vo-stat-lbl">{l}</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//           <div className="vo-float-cards">
//             {[
//               {
//                 icon: "🦷",
//                 bg: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                 title: "Dental Care",
//                 desc: "Root canal, implants, whitening",
//               },
//               {
//                 icon: "🦴",
//                 bg: "linear-gradient(135deg,#1a3a6b,#2563eb)",
//                 title: "Ortho Care",
//                 desc: "Joint replacement, physiotherapy",
//               },
//               {
//                 icon: "🌿",
//                 bg: "linear-gradient(135deg,#166534,#16a34a)",
//                 title: "Ayurved",
//                 desc: "Panchakarma, herbal treatments",
//               },
//               {
//                 icon: "❤️",
//                 bg: "linear-gradient(135deg,#881337,#dc2626)",
//                 title: "Cardiology",
//                 desc: "Heart care, ECG, consultations",
//               },
//             ].map((c) => (
//               <div key={c.title} className="vo-float-card">
//                 <div className="vo-float-icon" style={{ background: c.bg }}>
//                   {c.icon}
//                 </div>
//                 <div>
//                   <div className="vo-float-title">{c.title}</div>
//                   <div className="vo-float-desc">{c.desc}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Hospital Grid */}
//       <section className="vo-hospitals" id="hospitals">
//         <div className="vo-container">
//           <div style={{ textAlign: "center", marginBottom: 48 }}>
//             <div className="vo-section-tag">🏥 Browse Hospitals</div>
//             <h2 className="vo-section-title">
//               Find the Right
//               <br />
//               <em>Hospital for You</em>
//             </h2>
//             <p
//               style={{
//                 fontSize: 16,
//                 color: "#475569",
//                 maxWidth: 540,
//                 margin: "0 auto",
//                 lineHeight: 1.7,
//               }}
//             >
//               Browse verified hospitals by speciality or city.
//             </p>
//           </div>
//           <div className="vo-controls">
//             <input
//               className="vo-search"
//               placeholder="🔍 Search by hospital name or city..."
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               autoComplete="off"
//             />
//             <div className="vo-cats">
//               {CATEGORIES.map((c) => (
//                 <button
//                   key={c.id}
//                   className={`vo-cat${activeCat === c.id ? " active" : ""}`}
//                   onClick={() => setActiveCat(c.id)}
//                 >
//                   {c.icon} {c.label}
//                 </button>
//               ))}
//             </div>
//           </div>
//           <div style={{ fontSize: 13, color: "#94a3b8", marginBottom: 24 }}>
//             {loading
//               ? "Loading hospitals..."
//               : `${filtered.length} hospital${filtered.length !== 1 ? "s" : ""} found`}
//           </div>
//           <div className="vo-grid">
//             {loading ? (
//               [1, 2, 3, 4, 5, 6].map((i) => (
//                 <div
//                   key={i}
//                   style={{
//                     background: "#fff",
//                     borderRadius: 20,
//                     overflow: "hidden",
//                   }}
//                 >
//                   <div className="vo-skel" style={{ height: 140 }} />
//                   <div style={{ padding: "20px 22px" }}>
//                     <div
//                       className="vo-skel"
//                       style={{ height: 20, width: "70%", marginBottom: 8 }}
//                     />
//                     <div
//                       className="vo-skel"
//                       style={{ height: 13, width: "40%", marginBottom: 14 }}
//                     />
//                     <div
//                       className="vo-skel"
//                       style={{ height: 38, borderRadius: 10 }}
//                     />
//                   </div>
//                 </div>
//               ))
//             ) : filtered.length === 0 ? (
//               <div className="vo-empty">No hospitals match your search.</div>
//             ) : (
//               filtered.map((h) => {
//                 const type = (h.type || "general").toLowerCase();
//                 const grad = CAT_GRADIENTS[type] || CAT_GRADIENTS.general;
//                 const cat = CATEGORIES.find((c) => c.id === type);
//                 return (
//                   <div
//                     key={h._id}
//                     className="vo-card"
//                     onClick={() => navigate(`/hospital/${h.slug}`)}
//                   >
//                     <div className="vo-card-top" style={{ background: grad }}>
//                       <div className="vo-card-badge">
//                         {cat?.label || "Hospital"}
//                       </div>
//                       {h.logoUrl ? (
//                         <img
//                           src={h.logoUrl}
//                           alt={h.name}
//                           style={{
//                             width: 70,
//                             height: 70,
//                             borderRadius: "50%",
//                             objectFit: "cover",
//                             border: "3px solid rgba(255,255,255,0.3)",
//                           }}
//                         />
//                       ) : (
//                         <span>{CAT_ICONS[type] || "🏥"}</span>
//                       )}
//                     </div>
//                     <div className="vo-card-body">
//                       <div className="vo-card-name">{h.name}</div>
//                       <div className="vo-card-type">
//                         {cat?.icon} {cat?.label || "Hospital"}
//                       </div>
//                       <div className="vo-card-city">
//                         📍 {h.city || "Location not specified"}
//                       </div>
//                       <div className="vo-card-stats">
//                         {[
//                           ["Patients", h.statPatients],
//                           ["Doctors", h.statDoctors],
//                           ["Rating", h.statRating],
//                         ].map(([l, v]) => (
//                           <div key={l} className="vo-card-stat">
//                             <div className="vo-card-stat-num">{v || "—"}</div>
//                             <div className="vo-card-stat-lbl">{l}</div>
//                           </div>
//                         ))}
//                       </div>
//                       <button className="vo-card-btn">
//                         Book Appointment →
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>
//       </section>

//       {/* How It Works */}
//       <section className="vo-how" id="how">
//         <div className="vo-container">
//           <div style={{ textAlign: "center" }}>
//             <div className="vo-section-tag">Simple Process</div>
//             <h2 className="vo-section-title">
//               How <em>PranJeev</em> Works
//             </h2>
//             <p
//               style={{
//                 fontSize: 16,
//                 color: "#475569",
//                 maxWidth: 520,
//                 margin: "0 auto",
//                 lineHeight: 1.7,
//               }}
//             >
//               Get your hospital live in under 10 minutes. No technical knowledge
//               required.
//             </p>
//           </div>
//           <div className="vo-how-grid">
//             {[
//               {
//                 step: "1",
//                 icon: "🏥",
//                 title: "Register Hospital",
//                 desc: "Fill your hospital details, choose a plan and pay securely.",
//               },
//               {
//                 step: "2",
//                 icon: "⚙️",
//                 title: "Setup Your Panel",
//                 desc: "Add your doctors, services and pricing inside your admin dashboard.",
//               },
//               {
//                 step: "3",
//                 icon: "📅",
//                 title: "Patients Book",
//                 desc: "Patients find your hospital on PranJeev and book appointments online.",
//               },
//               {
//                 step: "4",
//                 icon: "📊",
//                 title: "Manage Everything",
//                 desc: "Track appointments, patients, billing and doctor availability in one panel.",
//               },
//             ].map((s) => (
//               <div key={s.step} className="vo-how-card">
//                 <div className="vo-how-step">{s.step}</div>
//                 <div className="vo-how-icon">{s.icon}</div>
//                 <div className="vo-how-title">{s.title}</div>
//                 <div className="vo-how-desc">{s.desc}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA / Pricing */}
//       <section className="vo-cta" id="pricing">
//         <div className="vo-container">
//           <div
//             className="vo-section-tag"
//             style={{
//               background: "rgba(201,168,76,0.15)",
//               borderColor: "rgba(201,168,76,0.3)",
//               color: "#c9a845",
//             }}
//           >
//             💰 Simple Pricing
//           </div>
//           <h2 className="vo-cta-title">
//             Register Your Hospital
//             <br />
//             <em>Start Today</em>
//           </h2>
//           <p className="vo-cta-desc">
//             Choose a plan that fits your hospital. All plans include full admin
//             panel, patient management & WhatsApp integration.
//           </p>
//           <div className="vo-plans">
//             {[
//               {
//                 name: "Starter",
//                 price: "₹999",
//                 period: "/month",
//                 features: "3 Doctors · Appointments · Patients",
//               },
//               {
//                 name: "Pro",
//                 price: "₹1,999",
//                 period: "/month",
//                 features: "10 Doctors · Billing · WhatsApp",
//                 featured: true,
//               },
//               {
//                 name: "Enterprise",
//                 price: "₹3,499",
//                 period: "/month",
//                 features: "Unlimited · Priority Support · Custom Domain",
//               },
//             ].map((p) => (
//               <div
//                 key={p.name}
//                 className={`vo-plan${p.featured ? " featured" : ""}`}
//               >
//                 <div className="vo-plan-name">{p.name}</div>
//                 <div className="vo-plan-price">{p.price}</div>
//                 <div className="vo-plan-period">{p.period}</div>
//                 <div className="vo-plan-features">{p.features}</div>
//               </div>
//             ))}
//           </div>
//           <button
//             className="vo-btn-primary"
//             style={{ fontSize: 16, padding: "15px 36px" }}
//             onClick={() => setRegOpen(true)}
//           >
//             Register Your Hospital Now →
//           </button>
//           <div
//             style={{
//               fontSize: 12,
//               color: "rgba(255,255,255,0.4)",
//               marginTop: 14,
//             }}
//           >
//             14-day free trial · No credit card required to start
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="vo-footer">
//         <div className="vo-footer-inner">
//           <div>
//             <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//               <div className="vo-footer-logo-icon">
//                 <img src={logo} alt="PranJeev Logo" />
//               </div>
//               <div>
//                 <div
//                   style={{
//                     fontFamily: "Cormorant Garamond,serif",
//                     fontSize: 20,
//                     fontWeight: 700,
//                     color: "#fff",
//                   }}
//                 >
//                   PranJeev
//                 </div>
//                 <div
//                   style={{
//                     fontSize: 9,
//                     color: "#c9a845",
//                     letterSpacing: 2,
//                     textTransform: "uppercase",
//                   }}
//                 >
//                   Life-Giving Healthcare
//                 </div>
//               </div>
//             </div>
//             <p className="vo-footer-desc">
//               Prana (life force) + Jeev (living being) — India's life-giving
//               hospital management platform.
//             </p>
//           </div>
//           <div className="vo-footer-col">
//             <h4>For Hospitals</h4>
//             <ul>
//               {[
//                 "Register Hospital",
//                 "Pricing Plans",
//                 "How It Works",
//                 "Admin Login",
//               ].map((s) => (
//                 <li key={s}>
//                   <a>{s}</a>
//                 </li>
//               ))}
//             </ul>
//           </div>
//           <div className="vo-footer-col">
//             <h4>Specialities</h4>
//             <ul>
//               {[
//                 "🦷 Dental",
//                 "🦴 Ortho",
//                 "🌿 Ayurved",
//                 "❤️ Cardiology",
//                 "👁️ Eye Care",
//                 "👶 Pediatric",
//               ].map((s) => (
//                 <li key={s}>
//                   <a>{s}</a>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>
//         <div className="vo-footer-bottom">
//           <p>
//             © 2026 PranJeev · Life-Giving Healthcare Platform. All rights
//             reserved.
//           </p>
//           <div style={{ display: "flex", gap: 24 }}>
//             <a>Privacy Policy</a>
//             <a>Terms of Service</a>
//           </div>
//         </div>
//       </footer>

//       {regOpen && (
//         <RegisterModal
//           onClose={() => {
//             setRegOpen(false);
//             fetchHospitals();
//           }}
//         />
//       )}
//     </div>
//   );
// }

/////////// pearl smile removing /////////

// // ============================================================
// // src/pages/PranJeev.js  (renamed from VidyaOne.js)
// // ✅ Full rebrand: VidyaOne → PranJeev
// // ✅ Super Admin button in navbar
// // ✅ Registration secret key gate
// // ✅ Logo: replaced emoji with logo.jpeg
// // ✅ FIXED: Mobile navbar larger, logo 2x on mobile/tablet
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import logo from "../assets/logo.jpeg";

// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// const PEARLSMILE_CARD = {
//   _id: "pearlsmile-static",
//   name: "PearlSmile Dental Hospital",
//   type: "dental",
//   city: "Pune, Maharashtra",
//   slug: "pearlsmile",
//   statPatients: "18K+",
//   statDoctors: "20+",
//   statRating: "4.9★",
//   logoUrl: "",
// };

// const CATEGORIES = [
//   { id: "all", label: "All", icon: "🏥" },
//   { id: "dental", label: "Dental", icon: "🦷" },
//   { id: "ortho", label: "Ortho", icon: "🦴" },
//   { id: "ayurved", label: "Ayurved", icon: "🌿" },
//   { id: "cardiology", label: "Cardiology", icon: "❤️" },
//   { id: "eye", label: "Eye", icon: "👁️" },
//   { id: "pediatric", label: "Pediatric", icon: "👶" },
//   { id: "general", label: "General", icon: "➕" },
// ];

// const CAT_GRADIENTS = {
//   dental: "linear-gradient(135deg,#0d7377,#14a0a5)",
//   ortho: "linear-gradient(135deg,#1a3a6b,#2563eb)",
//   ayurved: "linear-gradient(135deg,#166534,#16a34a)",
//   cardiology: "linear-gradient(135deg,#881337,#dc2626)",
//   eye: "linear-gradient(135deg,#4338ca,#7c3aed)",
//   pediatric: "linear-gradient(135deg,#c2410c,#f97316)",
//   general: "linear-gradient(135deg,#0f766e,#0d9488)",
// };

// const CAT_ICONS = {
//   dental: "🦷",
//   ortho: "🦴",
//   ayurved: "🌿",
//   cardiology: "❤️",
//   eye: "👁️",
//   pediatric: "👶",
//   general: "➕",
// };

// const TYPES = [
//   "Dental",
//   "Ortho",
//   "Ayurved",
//   "Cardiology",
//   "Eye",
//   "Pediatric",
//   "General",
// ];
// const PLANS = [
//   { id: "starter", label: "Starter — ₹999/mo" },
//   { id: "pro", label: "Pro — ₹1,999/mo" },
//   { id: "enterprise", label: "Enterprise — ₹3,499/mo" },
// ];

// // ── Register Modal ────────────────────────────────────────────
// function RegisterModal({ onClose }) {
//   const [step, setStep] = useState(1);
//   const [saving, setSaving] = useState(false);
//   const [msg, setMsg] = useState("");
//   const [form, setForm] = useState({
//     name: "",
//     type: "",
//     phone: "",
//     whatsapp: "",
//     email: "",
//     address: "",
//     city: "",
//     established: "",
//     plan: "pro",
//     adminId: "",
//     password: "",
//     registrationKey: "",
//   });
//   const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

//   const inp = {
//     width: "100%",
//     padding: "10px 14px",
//     borderRadius: 8,
//     border: "1.5px solid #e2e8f0",
//     fontSize: 14,
//     fontFamily: "DM Sans,sans-serif",
//     outline: "none",
//     background: "#f8fafc",
//     boxSizing: "border-box",
//     marginTop: 4,
//     marginBottom: 12,
//   };
//   const lbl = {
//     fontSize: 12,
//     fontWeight: 600,
//     color: "#475569",
//     display: "block",
//   };

//   const next = () => {
//     if (!form.name || !form.type || !form.phone || !form.city) {
//       setMsg("Please fill all required fields.");
//       return;
//     }
//     setMsg("");
//     setStep(2);
//   };

//   const submit = async () => {
//     if (!form.adminId || !form.password) {
//       setMsg("Admin ID and password are required.");
//       return;
//     }
//     if (!form.registrationKey.trim()) {
//       setMsg(
//         "Registration access key is required. Contact PranJeev on WhatsApp to get your key.",
//       );
//       return;
//     }
//     setSaving(true);
//     setMsg("");
//     try {
//       const slug = form.name
//         .toLowerCase()
//         .replace(/[^a-z0-9]+/g, "-")
//         .replace(/^-|-$/g, "");
//       const res = await fetch(`${API_URL}/hospitals/register`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ ...form, slug }),
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message || "Registration failed");
//       setStep(3);
//     } catch (err) {
//       setMsg(err.message);
//     }
//     setSaving(false);
//   };

//   return (
//     <div
//       style={{
//         position: "fixed",
//         inset: 0,
//         background: "rgba(0,0,0,0.6)",
//         backdropFilter: "blur(4px)",
//         zIndex: 2000,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: 20,
//       }}
//       onClick={(e) => {
//         if (e.target === e.currentTarget) onClose();
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 24,
//           width: "100%",
//           maxWidth: 520,
//           maxHeight: "90vh",
//           overflowY: "auto",
//           boxShadow: "0 24px 80px rgba(0,0,0,0.4)",
//         }}
//       >
//         {/* Header */}
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             padding: "22px 28px",
//             borderRadius: "24px 24px 0 0",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div>
//             <div style={{ fontSize: 17, fontWeight: 700, color: "#fff" }}>
//               {step === 3
//                 ? "🎉 Registration Successful!"
//                 : "🏥 Register Your Hospital"}
//             </div>
//             <div
//               style={{
//                 fontSize: 12,
//                 color: "rgba(255,255,255,0.55)",
//                 marginTop: 3,
//               }}
//             >
//               {step === 1 && "Step 1 of 2 — Hospital Details"}
//               {step === 2 && "Step 2 of 2 — Admin Credentials & Access Key"}
//               {step === 3 && "Your hospital is now live on PranJeev!"}
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.12)",
//               border: "none",
//               color: "#fff",
//               width: 32,
//               height: 32,
//               borderRadius: "50%",
//               fontSize: 16,
//               cursor: "pointer",
//             }}
//           >
//             ✕
//           </button>
//         </div>

//         <form
//           autoComplete="off"
//           onSubmit={(e) => e.preventDefault()}
//           style={{ padding: 28 }}
//         >
//           {msg && (
//             <div
//               style={{
//                 background: "#fef2f2",
//                 border: "1px solid #fecaca",
//                 borderRadius: 8,
//                 padding: "10px 14px",
//                 marginBottom: 16,
//                 fontSize: 13,
//                 color: "#dc2626",
//               }}
//             >
//               {msg}
//             </div>
//           )}

//           {/* STEP 1 */}
//           {step === 1 && (
//             <>
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "1fr 1fr",
//                   gap: "0 14px",
//                 }}
//               >
//                 <div>
//                   <label style={lbl}>Hospital Name *</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. Sai Dental Hospital"
//                     autoComplete="off"
//                     value={form.name}
//                     onChange={(e) => set("name", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Hospital Type *</label>
//                   <select
//                     style={inp}
//                     value={form.type}
//                     onChange={(e) => set("type", e.target.value)}
//                   >
//                     <option value="">Select type</option>
//                     {TYPES.map((t) => (
//                       <option key={t} value={t.toLowerCase()}>
//                         {t}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 <div>
//                   <label style={lbl}>Phone *</label>
//                   <input
//                     style={inp}
//                     placeholder="+91 98765 43210"
//                     autoComplete="off"
//                     value={form.phone}
//                     onChange={(e) => set("phone", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>WhatsApp (no +)</label>
//                   <input
//                     style={inp}
//                     placeholder="919876543210"
//                     autoComplete="off"
//                     value={form.whatsapp}
//                     onChange={(e) => set("whatsapp", e.target.value)}
//                   />
//                 </div>
//                 <div style={{ gridColumn: "1/-1" }}>
//                   <label style={lbl}>Email</label>
//                   <input
//                     style={inp}
//                     type="email"
//                     placeholder="info@hospital.com"
//                     autoComplete="off"
//                     value={form.email}
//                     onChange={(e) => set("email", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Address</label>
//                   <input
//                     style={inp}
//                     placeholder="Street, Area"
//                     autoComplete="off"
//                     value={form.address}
//                     onChange={(e) => set("address", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>City *</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. Mumbai, MH"
//                     autoComplete="off"
//                     value={form.city}
//                     onChange={(e) => set("city", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Established Year</label>
//                   <input
//                     style={inp}
//                     placeholder="e.g. 2010"
//                     autoComplete="off"
//                     value={form.established}
//                     onChange={(e) => set("established", e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <label style={lbl}>Plan</label>
//                   <select
//                     style={inp}
//                     value={form.plan}
//                     onChange={(e) => set("plan", e.target.value)}
//                   >
//                     {PLANS.map((p) => (
//                       <option key={p.id} value={p.id}>
//                         {p.label}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//               <button
//                 onClick={next}
//                 style={{
//                   width: "100%",
//                   padding: 13,
//                   background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 10,
//                   fontSize: 15,
//                   fontWeight: 700,
//                   cursor: "pointer",
//                 }}
//               >
//                 Next: Create Admin Account →
//               </button>
//             </>
//           )}

//           {/* STEP 2 */}
//           {step === 2 && (
//             <>
//               <div
//                 style={{
//                   background: "#f0fdf4",
//                   border: "1px solid #bbf7d0",
//                   borderRadius: 10,
//                   padding: "12px 16px",
//                   marginBottom: 20,
//                   fontSize: 13,
//                   color: "#166534",
//                 }}
//               >
//                 ✅ <strong>{form.name}</strong> · {form.city}
//               </div>
//               <label style={lbl}>Admin ID *</label>
//               <input
//                 style={inp}
//                 placeholder="e.g. saidental_admin"
//                 autoComplete="off"
//                 value={form.adminId}
//                 onChange={(e) => set("adminId", e.target.value)}
//               />
//               <label style={lbl}>Password *</label>
//               <input
//                 style={inp}
//                 type="password"
//                 placeholder="Create a strong password"
//                 autoComplete="new-password"
//                 value={form.password}
//                 onChange={(e) => set("password", e.target.value)}
//               />
//               <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 18 }}>
//                 💡 Save these credentials — you'll use them to login to your
//                 admin panel.
//               </div>
//               <div
//                 style={{
//                   background: "#fffbeb",
//                   border: "1px solid #fde68a",
//                   borderRadius: 10,
//                   padding: "14px 16px",
//                   marginBottom: 16,
//                 }}
//               >
//                 <div
//                   style={{
//                     fontSize: 13,
//                     fontWeight: 700,
//                     color: "#92400e",
//                     marginBottom: 8,
//                   }}
//                 >
//                   🔐 Registration Access Key Required
//                 </div>
//                 <div
//                   style={{
//                     fontSize: 12,
//                     color: "#92400e",
//                     marginBottom: 10,
//                     lineHeight: 1.5,
//                   }}
//                 >
//                   This is a private key provided by PranJeev. Without it,
//                   registration is not allowed. Contact us on WhatsApp to get
//                   your key before registering.
//                 </div>
//                 <a
//                   href="https://wa.me/918793608083?text=Hi%20PranJeev%2C%20I%20want%20to%20register%20my%20hospital.%20Please%20share%20the%20registration%20key."
//                   target="_blank"
//                   rel="noreferrer"
//                   style={{
//                     display: "inline-flex",
//                     alignItems: "center",
//                     gap: 8,
//                     margin: "6px 0 12px",
//                     background: "#25d366",
//                     color: "#fff",
//                     borderRadius: 8,
//                     padding: "9px 16px",
//                     fontSize: 13,
//                     fontWeight: 700,
//                     textDecoration: "none",
//                   }}
//                 >
//                   💬 Contact PranJeev Owner — +91 87936 08083
//                 </a>
//                 <label style={{ ...lbl, color: "#92400e" }}>Access Key *</label>
//                 <input
//                   style={{
//                     ...inp,
//                     marginBottom: 0,
//                     background: "#fff",
//                     border: "1.5px solid #fcd34d",
//                   }}
//                   type="password"
//                   placeholder="Enter your PranJeev registration key"
//                   autoComplete="new-password"
//                   value={form.registrationKey}
//                   onChange={(e) => set("registrationKey", e.target.value)}
//                 />
//               </div>
//               <div style={{ display: "flex", gap: 10 }}>
//                 <button
//                   onClick={() => setStep(1)}
//                   style={{
//                     flex: 1,
//                     padding: 13,
//                     background: "#f1f5f9",
//                     color: "#475569",
//                     border: "none",
//                     borderRadius: 10,
//                     fontSize: 14,
//                     fontWeight: 600,
//                     cursor: "pointer",
//                   }}
//                 >
//                   ← Back
//                 </button>
//                 <button
//                   onClick={submit}
//                   disabled={saving}
//                   style={{
//                     flex: 2,
//                     padding: 13,
//                     background: saving
//                       ? "#94a3b8"
//                       : "linear-gradient(135deg,#0d7377,#14a0a5)",
//                     color: "#fff",
//                     border: "none",
//                     borderRadius: 10,
//                     fontSize: 15,
//                     fontWeight: 700,
//                     cursor: saving ? "not-allowed" : "pointer",
//                   }}
//                 >
//                   {saving ? "Registering..." : "🚀 Complete Registration"}
//                 </button>
//               </div>
//             </>
//           )}

//           {/* STEP 3 */}
//           {step === 3 && (
//             <div style={{ textAlign: "center", padding: "20px 0" }}>
//               <div style={{ fontSize: 64, marginBottom: 16 }}>🎉</div>
//               <h3
//                 style={{
//                   fontSize: 22,
//                   fontWeight: 700,
//                   color: "#0a1628",
//                   marginBottom: 8,
//                 }}
//               >
//                 {form.name}
//               </h3>
//               <p
//                 style={{
//                   fontSize: 14,
//                   color: "#64748b",
//                   marginBottom: 24,
//                   lineHeight: 1.6,
//                 }}
//               >
//                 Your hospital is now live on PranJeev! Use your credentials to
//                 login.
//               </p>
//               <div
//                 style={{
//                   background: "#f0fdf4",
//                   border: "1px solid #bbf7d0",
//                   borderRadius: 12,
//                   padding: "16px 20px",
//                   marginBottom: 24,
//                   textAlign: "left",
//                 }}
//               >
//                 <div
//                   style={{
//                     fontSize: 12,
//                     fontWeight: 700,
//                     color: "#16a34a",
//                     marginBottom: 8,
//                   }}
//                 >
//                   YOUR LOGIN CREDENTIALS
//                 </div>
//                 <div style={{ fontSize: 14, color: "#166534" }}>
//                   Admin ID: <strong>{form.adminId}</strong>
//                 </div>
//                 <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>
//                   (Save your password securely)
//                 </div>
//               </div>
//               <button
//                 onClick={onClose}
//                 style={{
//                   width: "100%",
//                   padding: 13,
//                   background: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 10,
//                   fontSize: 15,
//                   fontWeight: 700,
//                   cursor: "pointer",
//                 }}
//               >
//                 Done ✓
//               </button>
//             </div>
//           )}
//         </form>
//       </div>
//     </div>
//   );
// }

// // ── Main PranJeev Page ────────────────────────────────────────
// export default function PranJeev() {
//   const navigate = useNavigate();
//   const [hospitals, setHospitals] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState("");
//   const [activeCat, setActiveCat] = useState("all");
//   const [regOpen, setRegOpen] = useState(false);
//   const [menuOpen, setMenuOpen] = useState(false);

//   const fetchHospitals = useCallback(async () => {
//     setLoading(true);
//     try {
//       const r = await fetch(`${API_URL}/hospitals`);
//       if (r.ok) {
//         const data = await r.json();
//         setHospitals(Array.isArray(data) ? data : []);
//       }
//     } catch (_) {}
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     fetchHospitals();
//   }, [fetchHospitals]);

//   // ✅ FIX: All hospitals from DB — PearlSmile now live like every other hospital
//   const allHospitals = hospitals;

//   const filtered = allHospitals.filter((h) => {
//     const matchCat =
//       activeCat === "all" || (h.type || "").toLowerCase() === activeCat;
//     const q = search.toLowerCase();
//     const matchSearch =
//       !q ||
//       (h.name || "").toLowerCase().includes(q) ||
//       (h.city || "").toLowerCase().includes(q) ||
//       (h.type || "").toLowerCase().includes(q);
//     return matchCat && matchSearch;
//   });

//   const css = `
//     * { box-sizing:border-box; margin:0; padding:0; }
//     body { font-family:"DM Sans",sans-serif; }
//     .vo-nav { position:fixed; top:0; left:0; right:0; z-index:1000; background:rgba(10,22,40,0.97); backdrop-filter:blur(12px); border-bottom:1px solid rgba(255,255,255,0.06); display:flex; align-items:center; justify-content:space-between; padding:0 40px; height:68px; gap:16px; }
//     .vo-logo { display:flex; align-items:center; gap:10px; cursor:pointer; flex-shrink:0; min-width:0; }
//     .vo-logo-icon { width:38px; height:38px; border-radius:10px; overflow:hidden; flex-shrink:0; display:flex; align-items:center; justify-content:center; background:linear-gradient(135deg,#0d7377,#14a0a5); }
//     .vo-logo-icon img { width:100%; height:100%; object-fit:cover; display:block; border-radius:10px; }
//     .vo-logo-textblock { display:flex; flex-direction:column; min-width:0; }
//     .vo-logo-text { font-family:"Cormorant Garamond",serif; font-size:22px; font-weight:700; color:#fff; white-space:nowrap; line-height:1.2; }
//     .vo-logo-sub  { font-size:9px; color:#c9a845; letter-spacing:2px; text-transform:uppercase; white-space:nowrap; }
//     .vo-nav-links { display:flex; align-items:center; gap:12px; flex-shrink:0; }
//     .vo-nav-btn { background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; padding:10px 22px; border-radius:8px; font-weight:700; font-size:13px; font-family:"DM Sans",sans-serif; cursor:pointer; white-space:nowrap; }
//     .vo-nav-sa  { background:rgba(255,255,255,0.06); color:rgba(255,255,255,0.55); border:1px solid rgba(255,255,255,0.12); padding:8px 14px; border-radius:8px; font-weight:600; font-size:12px; font-family:"DM Sans",sans-serif; cursor:pointer; white-space:nowrap; }
//     .vo-nav-sa:hover { background:rgba(255,255,255,0.12); color:#fff; }
//     .vo-hamburger { display:none; flex-direction:column; gap:5px; background:none; border:none; cursor:pointer; padding:6px; z-index:1100; flex-shrink:0; }
//     .vo-hamburger span { display:block; width:28px; height:2.5px; background:#fff; border-radius:2px; transition:all 0.3s; }
//     .vo-mobile-menu { display:none; position:fixed; top:68px; left:0; right:0; background:rgba(10,22,40,0.98); backdrop-filter:blur(16px); border-bottom:1px solid rgba(255,255,255,0.08); padding:16px 20px 20px; flex-direction:column; gap:12px; z-index:999; }
//     .vo-mobile-menu.open { display:flex; }
//     .vo-mobile-link { color:rgba(255,255,255,0.8); font-size:15px; font-weight:500; padding:10px 0; border-bottom:1px solid rgba(255,255,255,0.07); cursor:pointer; font-family:"DM Sans",sans-serif; background:none; border-left:none; border-right:none; border-top:none; text-align:left; }
//     .vo-mobile-btn { width:100%; padding:12px; background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; border-radius:10px; font-size:14px; font-weight:700; cursor:pointer; font-family:"DM Sans",sans-serif; margin-top:4px; }
//     .vo-mobile-sa  { width:100%; padding:10px; background:rgba(255,255,255,0.06); color:rgba(255,255,255,0.7); border:1px solid rgba(255,255,255,0.15); border-radius:10px; font-size:13px; font-weight:600; cursor:pointer; font-family:"DM Sans",sans-serif; }
//     .vo-hero { min-height:100vh; background:linear-gradient(135deg,#0a1628 0%,#0d2444 50%,#0a1f3a 100%); display:flex; align-items:center; padding-top:68px; position:relative; overflow:hidden; }
//     .vo-hero::before { content:""; position:absolute; top:-200px; right:-200px; width:600px; height:600px; background:radial-gradient(circle,rgba(13,115,119,0.15) 0%,transparent 70%); border-radius:50%; }
//     .vo-hero-inner { max-width:1200px; margin:0 auto; padding:80px 24px; display:grid; grid-template-columns:1fr 1fr; gap:60px; align-items:center; position:relative; z-index:1; }
//     .vo-badge { display:inline-flex; align-items:center; gap:8px; background:rgba(201,168,76,0.15); border:1px solid rgba(201,168,76,0.3); color:#c9a845; font-size:11px; font-weight:700; letter-spacing:1px; text-transform:uppercase; padding:7px 16px; border-radius:100px; margin-bottom:24px; }
//     .vo-hero h1 { font-family:"Cormorant Garamond",serif; font-size:clamp(40px,5vw,64px); font-weight:700; color:#fff; line-height:1.1; margin-bottom:20px; }
//     .vo-hero h1 em { font-style:italic; color:#14a0a5; }
//     .vo-hero-desc { font-size:16px; color:rgba(255,255,255,0.7); line-height:1.7; margin-bottom:36px; max-width:480px; }
//     .vo-actions { display:flex; gap:14px; flex-wrap:wrap; }
//     .vo-btn-primary { background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; padding:14px 28px; border-radius:10px; font-size:15px; font-weight:700; font-family:"DM Sans",sans-serif; cursor:pointer; transition:opacity 0.2s,transform 0.2s; }
//     .vo-btn-primary:hover { opacity:0.92; transform:translateY(-1px); }
//     .vo-btn-outline { background:transparent; color:#fff; border:1.5px solid rgba(255,255,255,0.3); padding:14px 28px; border-radius:10px; font-size:15px; font-weight:600; font-family:"DM Sans",sans-serif; cursor:pointer; }
//     .vo-stats { display:flex; gap:32px; margin-top:40px; }
//     .vo-stat-num { font-family:"Cormorant Garamond",serif; font-size:28px; font-weight:700; color:#14a0a5; }
//     .vo-stat-lbl { font-size:12px; color:rgba(255,255,255,0.5); margin-top:2px; }
//     .vo-float-cards { display:flex; flex-direction:column; gap:14px; }
//     .vo-float-card { background:rgba(255,255,255,0.06); border:1px solid rgba(255,255,255,0.1); backdrop-filter:blur(12px); border-radius:16px; padding:18px 22px; display:flex; align-items:center; gap:14px; transition:transform 0.3s; }
//     .vo-float-card:hover { transform:translateX(6px); }
//     .vo-float-icon { width:46px; height:46px; border-radius:12px; display:flex; align-items:center; justify-content:center; font-size:22px; flex-shrink:0; }
//     .vo-float-title { font-size:14px; font-weight:700; color:#fff; margin-bottom:3px; }
//     .vo-float-desc  { font-size:12px; color:rgba(255,255,255,0.55); }
//     .vo-hospitals { padding:100px 0; background:#f8fafc; }
//     .vo-container { max-width:1200px; margin:0 auto; padding:0 24px; }
//     .vo-section-tag { display:inline-flex; align-items:center; gap:6px; background:rgba(13,115,119,0.1); border:1px solid rgba(13,115,119,0.25); color:#0d7377; font-size:11px; font-weight:700; letter-spacing:1.2px; text-transform:uppercase; padding:6px 14px; border-radius:100px; margin-bottom:16px; }
//     .vo-section-title { font-family:"Cormorant Garamond",serif; font-size:clamp(32px,4vw,52px); font-weight:700; color:#0a1628; line-height:1.15; margin-bottom:16px; }
//     .vo-section-title em { font-style:italic; color:#0d7377; }
//     .vo-controls { display:flex; gap:16px; margin-bottom:32px; flex-wrap:wrap; align-items:center; }
//     .vo-search { flex:1; min-width:260px; padding:12px 18px; border-radius:10px; border:1.5px solid #e2e8f0; font-size:14px; font-family:"DM Sans",sans-serif; outline:none; background:#fff; transition:border-color 0.2s; }
//     .vo-search:focus { border-color:#0d7377; }
//     .vo-cats { display:flex; gap:8px; flex-wrap:wrap; }
//     .vo-cat { padding:8px 14px; border-radius:100px; border:1.5px solid #e2e8f0; background:#fff; font-size:13px; font-weight:600; color:#475569; cursor:pointer; transition:all 0.2s; white-space:nowrap; font-family:"DM Sans",sans-serif; }
//     .vo-cat:hover { border-color:#0d7377; color:#0d7377; }
//     .vo-cat.active { background:#0d7377; border-color:#0d7377; color:#fff; }
//     .vo-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(300px,1fr)); gap:28px; }
//     .vo-card { background:#fff; border-radius:20px; overflow:hidden; box-shadow:0 4px 32px rgba(0,0,0,0.08); transition:transform 0.28s,box-shadow 0.28s; cursor:pointer; border:1px solid #f1f5f9; }
//     .vo-card:hover { transform:translateY(-6px); box-shadow:0 12px 48px rgba(0,0,0,0.14); }
//     .vo-card-top { height:140px; display:flex; align-items:center; justify-content:center; position:relative; font-size:52px; }
//     .vo-card-badge { position:absolute; top:14px; right:14px; background:rgba(255,255,255,0.2); backdrop-filter:blur(8px); border:1px solid rgba(255,255,255,0.3); border-radius:20px; padding:4px 12px; font-size:11px; font-weight:700; color:#fff; }
//     .vo-card-body { padding:20px 22px 22px; }
//     .vo-card-name { font-family:"Cormorant Garamond",serif; font-size:20px; font-weight:700; color:#0a1628; margin-bottom:4px; }
//     .vo-card-type { font-size:12px; font-weight:700; color:#0d7377; text-transform:uppercase; letter-spacing:0.5px; margin-bottom:8px; }
//     .vo-card-city { font-size:13px; color:#94a3b8; margin-bottom:14px; }
//     .vo-card-stats { display:flex; gap:16px; padding:12px 0; border-top:1px solid #f1f5f9; border-bottom:1px solid #f1f5f9; margin-bottom:14px; }
//     .vo-card-stat { text-align:center; flex:1; }
//     .vo-card-stat-num { font-size:15px; font-weight:700; color:#0a1628; }
//     .vo-card-stat-lbl { font-size:10px; color:#94a3b8; margin-top:2px; }
//     .vo-card-btn { width:100%; padding:11px; background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; border-radius:10px; font-size:13px; font-weight:700; cursor:pointer; font-family:"DM Sans",sans-serif; }
//     .vo-empty { grid-column:1/-1; text-align:center; padding:60px 0; color:#94a3b8; font-size:15px; }
//     @keyframes vopulse { 0%,100%{opacity:1}50%{opacity:0.45} }
//     .vo-skel { background:#e2e8f0; border-radius:8px; animation:vopulse 1.5s ease-in-out infinite; }
//     .vo-cta { padding:100px 0; background:linear-gradient(135deg,#0a1628,#0d2444); text-align:center; }
//     .vo-cta-title { font-family:"Cormorant Garamond",serif; font-size:clamp(32px,4vw,52px); font-weight:700; color:#fff; margin-bottom:16px; }
//     .vo-cta-title em { font-style:italic; color:#14a0a5; }
//     .vo-cta-desc { font-size:16px; color:rgba(255,255,255,0.65); max-width:520px; margin:0 auto 40px; line-height:1.7; }
//     .vo-plans { display:flex; gap:20px; justify-content:center; flex-wrap:wrap; margin-bottom:36px; }
//     .vo-plan { background:rgba(255,255,255,0.08); border:1px solid rgba(255,255,255,0.15); border-radius:16px; padding:22px 26px; min-width:180px; }
//     .vo-plan.featured { background:linear-gradient(135deg,#0d7377,#14a0a5); border-color:transparent; }
//     .vo-plan-name { font-size:12px; font-weight:700; color:rgba(255,255,255,0.65); text-transform:uppercase; letter-spacing:1px; margin-bottom:8px; }
//     .vo-plan-price { font-family:"Cormorant Garamond",serif; font-size:30px; font-weight:700; color:#fff; line-height:1; margin-bottom:4px; }
//     .vo-plan-period { font-size:12px; color:rgba(255,255,255,0.5); margin-bottom:10px; }
//     .vo-plan-features { font-size:12px; color:rgba(255,255,255,0.6); line-height:1.6; }
//     .vo-how { padding:100px 0; background:#fff; }
//     .vo-how-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:28px; margin-top:56px; }
//     .vo-how-card { text-align:center; padding:28px 20px; border-radius:20px; background:#f8fafc; border:1px solid #f1f5f9; }
//     .vo-how-step { width:46px; height:46px; border-radius:50%; background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; font-size:18px; font-weight:800; display:flex; align-items:center; justify-content:center; margin:0 auto 14px; }
//     .vo-how-icon { font-size:30px; margin-bottom:12px; }
//     .vo-how-title { font-size:15px; font-weight:700; color:#0a1628; margin-bottom:8px; }
//     .vo-how-desc  { font-size:13px; color:#475569; line-height:1.6; }
//     .vo-footer { background:#0a1628; padding:56px 0 24px; border-top:1px solid rgba(255,255,255,0.06); }
//     .vo-footer-inner { max-width:1200px; margin:0 auto; padding:0 24px 40px; display:grid; grid-template-columns:2fr 1fr 1fr; gap:48px; }
//     .vo-footer-desc { font-size:14px; color:rgba(255,255,255,0.5); line-height:1.7; margin-top:10px; max-width:280px; }
//     .vo-footer-col h4 { font-size:12px; font-weight:700; color:rgba(255,255,255,0.85); text-transform:uppercase; letter-spacing:1px; margin-bottom:14px; }
//     .vo-footer-col ul { list-style:none; }
//     .vo-footer-col ul li { margin-bottom:8px; }
//     .vo-footer-col ul li a { font-size:13px; color:rgba(255,255,255,0.5); cursor:pointer; }
//     .vo-footer-bottom { max-width:1200px; margin:0 auto; padding:20px 24px 0; border-top:1px solid rgba(255,255,255,0.07); display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:12px; font-size:13px; color:rgba(255,255,255,0.35); }

//     /* ── Footer logo ── */
//     .vo-footer-logo-icon { width:36px; height:36px; border-radius:10px; overflow:hidden; flex-shrink:0; display:flex; align-items:center; justify-content:center; background:linear-gradient(135deg,#0d7377,#14a0a5); }
//     .vo-footer-logo-icon img { width:100%; height:100%; object-fit:cover; display:block; border-radius:10px; }

//     /* ── Responsive navbar — FIXED: bigger logo + navbar on mobile/tablet ── */
//     @media(max-width:860px) {
//       .vo-nav { padding:0 20px; height:76px; }
//       .vo-nav-links { display:none !important; }
//       .vo-hamburger { display:flex; }
//       .vo-mobile-menu { top:76px; }
//       /* ✅ Logo 2x bigger on tablet */
//       .vo-logo-icon { width:52px; height:52px; border-radius:12px; }
//       .vo-logo-text { font-size:26px; }
//       .vo-logo-sub  { font-size:9px; letter-spacing:1.5px; display:block; }
//       .vo-logo { gap:12px; }
//       /* ✅ Hamburger bigger */
//       .vo-hamburger span { width:30px; height:3px; }
//       .vo-footer-logo-icon { width:40px; height:40px; border-radius:10px; }
//       .vo-hero-inner { grid-template-columns:1fr; }
//       .vo-float-cards { display:none; }
//       .vo-how-grid { grid-template-columns:repeat(2,1fr); }
//       .vo-footer-inner { grid-template-columns:1fr; gap:28px; }
//     }
//     @media(max-width:480px) {
//       .vo-nav { padding:0 16px; height:72px; }
//       .vo-mobile-menu { top:72px; }
//       /* ✅ Logo 2x bigger on mobile */
//       .vo-logo-icon { width:48px; height:48px; border-radius:11px; }
//       .vo-logo-text { font-size:24px; }
//       .vo-logo-sub  { font-size:8px; letter-spacing:1.2px; display:block; }
//       .vo-logo { gap:11px; }
//       .vo-footer-logo-icon { width:36px; height:36px; border-radius:9px; }
//     }
//     @media(max-width:600px) {
//       .vo-grid { grid-template-columns:1fr; }
//       .vo-how-grid { grid-template-columns:1fr; }
//       .vo-stats { gap:20px; }
//       .vo-plans { flex-direction:column; align-items:center; }
//     }
//   `;

//   const scrollTo = (id) =>
//     document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

//   return (
//     <div style={{ fontFamily: "DM Sans,sans-serif" }}>
//       <style>{css}</style>

//       {/* Navbar */}
//       <div className="vo-nav">
//         <div className="vo-logo">
//           <div className="vo-logo-icon">
//             <img src={logo} alt="PranJeev Logo" />
//           </div>
//           <div className="vo-logo-textblock">
//             <div className="vo-logo-text">PranJeev</div>
//             <div className="vo-logo-sub">Life-Giving Healthcare</div>
//           </div>
//         </div>
//         <div className="vo-nav-links">
//           <a
//             onClick={() => scrollTo("hospitals")}
//             style={{
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 14,
//               fontWeight: 500,
//               cursor: "pointer",
//             }}
//           >
//             Hospitals
//           </a>
//           <a
//             onClick={() => scrollTo("how")}
//             style={{
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 14,
//               fontWeight: 500,
//               cursor: "pointer",
//             }}
//           >
//             How It Works
//           </a>
//           <button className="vo-nav-btn" onClick={() => setRegOpen(true)}>
//             Register Hospital
//           </button>
//           <button className="vo-nav-sa" onClick={() => navigate("/superadmin")}>
//             🛡️ Admin
//           </button>
//         </div>
//         <button
//           className="vo-hamburger"
//           onClick={() => setMenuOpen((m) => !m)}
//           aria-label="Menu"
//         >
//           <span
//             style={{
//               transform: menuOpen ? "rotate(45deg) translate(5px,5px)" : "none",
//             }}
//           />
//           <span style={{ opacity: menuOpen ? 0 : 1 }} />
//           <span
//             style={{
//               transform: menuOpen
//                 ? "rotate(-45deg) translate(5px,-5px)"
//                 : "none",
//             }}
//           />
//         </button>
//       </div>

//       {/* Mobile Menu */}
//       <div className={`vo-mobile-menu${menuOpen ? " open" : ""}`}>
//         <button
//           className="vo-mobile-link"
//           onClick={() => {
//             scrollTo("hospitals");
//             setMenuOpen(false);
//           }}
//         >
//           🏥 Hospitals
//         </button>
//         <button
//           className="vo-mobile-link"
//           onClick={() => {
//             scrollTo("how");
//             setMenuOpen(false);
//           }}
//         >
//           ⚙️ How It Works
//         </button>
//         <button
//           className="vo-mobile-link"
//           onClick={() => {
//             scrollTo("pricing");
//             setMenuOpen(false);
//           }}
//         >
//           💰 Pricing
//         </button>
//         <button
//           className="vo-mobile-btn"
//           onClick={() => {
//             setRegOpen(true);
//             setMenuOpen(false);
//           }}
//         >
//           Register Your Hospital →
//         </button>
//         <button
//           className="vo-mobile-sa"
//           onClick={() => {
//             navigate("/superadmin");
//             setMenuOpen(false);
//           }}
//         >
//           🛡️ Admin
//         </button>
//       </div>

//       {/* Hero */}
//       <section className="vo-hero" id="home">
//         <div className="vo-hero-inner">
//           <div>
//             <div className="vo-badge">
//               🌟 India's Life-Giving Healthcare Platform
//             </div>
//             <h1>
//               Find & Book
//               <br />
//               <em>Top Hospitals</em>
//               <br />
//               Near You
//             </h1>
//             <p className="vo-hero-desc">
//               From Dental to Ortho, Ayurved to Cardiology — discover verified
//               hospitals, book appointments instantly, and manage your health all
//               in one place.
//             </p>
//             <div className="vo-actions">
//               <button
//                 className="vo-btn-primary"
//                 onClick={() => scrollTo("hospitals")}
//               >
//                 Find Hospitals →
//               </button>
//               <button
//                 className="vo-btn-outline"
//                 onClick={() => setRegOpen(true)}
//               >
//                 Register Your Hospital
//               </button>
//             </div>
//             <div className="vo-stats">
//               {[
//                 ["200+", "Hospitals"],
//                 ["50K+", "Patients"],
//                 ["7", "Specialities"],
//               ].map(([n, l]) => (
//                 <div key={l}>
//                   <div className="vo-stat-num">{n}</div>
//                   <div className="vo-stat-lbl">{l}</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//           <div className="vo-float-cards">
//             {[
//               {
//                 icon: "🦷",
//                 bg: "linear-gradient(135deg,#0d7377,#14a0a5)",
//                 title: "Dental Care",
//                 desc: "Root canal, implants, whitening",
//               },
//               {
//                 icon: "🦴",
//                 bg: "linear-gradient(135deg,#1a3a6b,#2563eb)",
//                 title: "Ortho Care",
//                 desc: "Joint replacement, physiotherapy",
//               },
//               {
//                 icon: "🌿",
//                 bg: "linear-gradient(135deg,#166534,#16a34a)",
//                 title: "Ayurved",
//                 desc: "Panchakarma, herbal treatments",
//               },
//               {
//                 icon: "❤️",
//                 bg: "linear-gradient(135deg,#881337,#dc2626)",
//                 title: "Cardiology",
//                 desc: "Heart care, ECG, consultations",
//               },
//             ].map((c) => (
//               <div key={c.title} className="vo-float-card">
//                 <div className="vo-float-icon" style={{ background: c.bg }}>
//                   {c.icon}
//                 </div>
//                 <div>
//                   <div className="vo-float-title">{c.title}</div>
//                   <div className="vo-float-desc">{c.desc}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Hospital Grid */}
//       <section className="vo-hospitals" id="hospitals">
//         <div className="vo-container">
//           <div style={{ textAlign: "center", marginBottom: 48 }}>
//             <div className="vo-section-tag">🏥 Browse Hospitals</div>
//             <h2 className="vo-section-title">
//               Find the Right
//               <br />
//               <em>Hospital for You</em>
//             </h2>
//             <p
//               style={{
//                 fontSize: 16,
//                 color: "#475569",
//                 maxWidth: 540,
//                 margin: "0 auto",
//                 lineHeight: 1.7,
//               }}
//             >
//               Browse verified hospitals by speciality or city.
//             </p>
//           </div>
//           <div className="vo-controls">
//             <input
//               className="vo-search"
//               placeholder="🔍 Search by hospital name or city..."
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               autoComplete="off"
//             />
//             <div className="vo-cats">
//               {CATEGORIES.map((c) => (
//                 <button
//                   key={c.id}
//                   className={`vo-cat${activeCat === c.id ? " active" : ""}`}
//                   onClick={() => setActiveCat(c.id)}
//                 >
//                   {c.icon} {c.label}
//                 </button>
//               ))}
//             </div>
//           </div>
//           <div style={{ fontSize: 13, color: "#94a3b8", marginBottom: 24 }}>
//             {loading
//               ? "Loading hospitals..."
//               : `${filtered.length} hospital${filtered.length !== 1 ? "s" : ""} found`}
//           </div>
//           <div className="vo-grid">
//             {loading ? (
//               [1, 2, 3, 4, 5, 6].map((i) => (
//                 <div
//                   key={i}
//                   style={{
//                     background: "#fff",
//                     borderRadius: 20,
//                     overflow: "hidden",
//                   }}
//                 >
//                   <div className="vo-skel" style={{ height: 140 }} />
//                   <div style={{ padding: "20px 22px" }}>
//                     <div
//                       className="vo-skel"
//                       style={{ height: 20, width: "70%", marginBottom: 8 }}
//                     />
//                     <div
//                       className="vo-skel"
//                       style={{ height: 13, width: "40%", marginBottom: 14 }}
//                     />
//                     <div
//                       className="vo-skel"
//                       style={{ height: 38, borderRadius: 10 }}
//                     />
//                   </div>
//                 </div>
//               ))
//             ) : filtered.length === 0 ? (
//               <div className="vo-empty">No hospitals match your search.</div>
//             ) : (
//               filtered.map((h) => {
//                 const type = (h.type || "general").toLowerCase();
//                 const grad = CAT_GRADIENTS[type] || CAT_GRADIENTS.general;
//                 const cat = CATEGORIES.find((c) => c.id === type);
//                 return (
//                   <div
//                     key={h._id}
//                     className="vo-card"
//                     onClick={() => navigate(`/hospital/${h.slug}`)}
//                   >
//                     <div className="vo-card-top" style={{ background: grad }}>
//                       <div className="vo-card-badge">
//                         {cat?.label || "Hospital"}
//                       </div>
//                       {h.logoUrl ? (
//                         <img
//                           src={h.logoUrl}
//                           alt={h.name}
//                           style={{
//                             width: 70,
//                             height: 70,
//                             borderRadius: "50%",
//                             objectFit: "cover",
//                             border: "3px solid rgba(255,255,255,0.3)",
//                           }}
//                         />
//                       ) : (
//                         <span>{CAT_ICONS[type] || "🏥"}</span>
//                       )}
//                     </div>
//                     <div className="vo-card-body">
//                       <div className="vo-card-name">{h.name}</div>
//                       <div className="vo-card-type">
//                         {cat?.icon} {cat?.label || "Hospital"}
//                       </div>
//                       <div className="vo-card-city">
//                         📍 {h.city || "Location not specified"}
//                       </div>
//                       <div className="vo-card-stats">
//                         {[
//                           ["Patients", h.statPatients],
//                           ["Doctors", h.statDoctors],
//                           ["Rating", h.statRating],
//                         ].map(([l, v]) => (
//                           <div key={l} className="vo-card-stat">
//                             <div className="vo-card-stat-num">{v || "—"}</div>
//                             <div className="vo-card-stat-lbl">{l}</div>
//                           </div>
//                         ))}
//                       </div>
//                       <button className="vo-card-btn">
//                         Book Appointment →
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>
//       </section>

//       {/* How It Works */}
//       <section className="vo-how" id="how">
//         <div className="vo-container">
//           <div style={{ textAlign: "center" }}>
//             <div className="vo-section-tag">Simple Process</div>
//             <h2 className="vo-section-title">
//               How <em>PranJeev</em> Works
//             </h2>
//             <p
//               style={{
//                 fontSize: 16,
//                 color: "#475569",
//                 maxWidth: 520,
//                 margin: "0 auto",
//                 lineHeight: 1.7,
//               }}
//             >
//               Get your hospital live in under 10 minutes. No technical knowledge
//               required.
//             </p>
//           </div>
//           <div className="vo-how-grid">
//             {[
//               {
//                 step: "1",
//                 icon: "🏥",
//                 title: "Register Hospital",
//                 desc: "Fill your hospital details, choose a plan and pay securely.",
//               },
//               {
//                 step: "2",
//                 icon: "⚙️",
//                 title: "Setup Your Panel",
//                 desc: "Add your doctors, services and pricing inside your admin dashboard.",
//               },
//               {
//                 step: "3",
//                 icon: "📅",
//                 title: "Patients Book",
//                 desc: "Patients find your hospital on PranJeev and book appointments online.",
//               },
//               {
//                 step: "4",
//                 icon: "📊",
//                 title: "Manage Everything",
//                 desc: "Track appointments, patients, billing and doctor availability in one panel.",
//               },
//             ].map((s) => (
//               <div key={s.step} className="vo-how-card">
//                 <div className="vo-how-step">{s.step}</div>
//                 <div className="vo-how-icon">{s.icon}</div>
//                 <div className="vo-how-title">{s.title}</div>
//                 <div className="vo-how-desc">{s.desc}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA / Pricing */}
//       <section className="vo-cta" id="pricing">
//         <div className="vo-container">
//           <div
//             className="vo-section-tag"
//             style={{
//               background: "rgba(201,168,76,0.15)",
//               borderColor: "rgba(201,168,76,0.3)",
//               color: "#c9a845",
//             }}
//           >
//             💰 Simple Pricing
//           </div>
//           <h2 className="vo-cta-title">
//             Register Your Hospital
//             <br />
//             <em>Start Today</em>
//           </h2>
//           <p className="vo-cta-desc">
//             Choose a plan that fits your hospital. All plans include full admin
//             panel, patient management & WhatsApp integration.
//           </p>
//           <div className="vo-plans">
//             {[
//               {
//                 name: "Starter",
//                 price: "₹999",
//                 period: "/month",
//                 features: "3 Doctors · Appointments · Patients",
//               },
//               {
//                 name: "Pro",
//                 price: "₹1,999",
//                 period: "/month",
//                 features: "10 Doctors · Billing · WhatsApp",
//                 featured: true,
//               },
//               {
//                 name: "Enterprise",
//                 price: "₹3,499",
//                 period: "/month",
//                 features: "Unlimited · Priority Support · Custom Domain",
//               },
//             ].map((p) => (
//               <div
//                 key={p.name}
//                 className={`vo-plan${p.featured ? " featured" : ""}`}
//               >
//                 <div className="vo-plan-name">{p.name}</div>
//                 <div className="vo-plan-price">{p.price}</div>
//                 <div className="vo-plan-period">{p.period}</div>
//                 <div className="vo-plan-features">{p.features}</div>
//               </div>
//             ))}
//           </div>
//           <button
//             className="vo-btn-primary"
//             style={{ fontSize: 16, padding: "15px 36px" }}
//             onClick={() => setRegOpen(true)}
//           >
//             Register Your Hospital Now →
//           </button>
//           <div
//             style={{
//               fontSize: 12,
//               color: "rgba(255,255,255,0.4)",
//               marginTop: 14,
//             }}
//           >
//             14-day free trial · No credit card required to start
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="vo-footer">
//         <div className="vo-footer-inner">
//           <div>
//             <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//               <div className="vo-footer-logo-icon">
//                 <img src={logo} alt="PranJeev Logo" />
//               </div>
//               <div>
//                 <div
//                   style={{
//                     fontFamily: "Cormorant Garamond,serif",
//                     fontSize: 20,
//                     fontWeight: 700,
//                     color: "#fff",
//                   }}
//                 >
//                   PranJeev
//                 </div>
//                 <div
//                   style={{
//                     fontSize: 9,
//                     color: "#c9a845",
//                     letterSpacing: 2,
//                     textTransform: "uppercase",
//                   }}
//                 >
//                   Life-Giving Healthcare
//                 </div>
//               </div>
//             </div>
//             <p className="vo-footer-desc">
//               Prana (life force) + Jeev (living being) — India's life-giving
//               hospital management platform.
//             </p>
//           </div>
//           <div className="vo-footer-col">
//             <h4>For Hospitals</h4>
//             <ul>
//               {[
//                 "Register Hospital",
//                 "Pricing Plans",
//                 "How It Works",
//                 "Admin Login",
//               ].map((s) => (
//                 <li key={s}>
//                   <a>{s}</a>
//                 </li>
//               ))}
//             </ul>
//           </div>
//           <div className="vo-footer-col">
//             <h4>Specialities</h4>
//             <ul>
//               {[
//                 "🦷 Dental",
//                 "🦴 Ortho",
//                 "🌿 Ayurved",
//                 "❤️ Cardiology",
//                 "👁️ Eye Care",
//                 "👶 Pediatric",
//               ].map((s) => (
//                 <li key={s}>
//                   <a>{s}</a>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>
//         <div className="vo-footer-bottom">
//           <p>
//             © 2026 PranJeev · Life-Giving Healthcare Platform. All rights
//             reserved.
//           </p>
//           <div style={{ display: "flex", gap: 24 }}>
//             <a>Privacy Policy</a>
//             <a>Terms of Service</a>
//           </div>
//         </div>
//       </footer>

//       {regOpen && (
//         <RegisterModal
//           onClose={() => {
//             setRegOpen(false);
//             fetchHospitals();
//           }}
//         />
//       )}
//     </div>
//   );
// }

/////// image square testing above code is perfectly main code

// ============================================================
// src/pages/PranJeev.js  (renamed from VidyaOne.js)
// ✅ Full rebrand: VidyaOne → PranJeev
// ✅ Super Admin button in navbar
// ✅ Registration secret key gate
// ✅ Logo: replaced emoji with logo.jpeg
// ✅ FIXED: Mobile navbar larger, logo 2x on mobile/tablet
// ============================================================
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.jpeg";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const PEARLSMILE_CARD = {
  _id: "pearlsmile-static",
  name: "PearlSmile Dental Hospital",
  type: "dental",
  city: "Pune, Maharashtra",
  slug: "pearlsmile",
  statPatients: "18K+",
  statDoctors: "20+",
  statRating: "4.9★",
  logoUrl: "",
};

const CATEGORIES = [
  { id: "all", label: "All", icon: "🏥" },
  { id: "dental", label: "Dental", icon: "🦷" },
  { id: "ortho", label: "Ortho", icon: "🦴" },
  { id: "ayurved", label: "Ayurved", icon: "🌿" },
  { id: "cardiology", label: "Cardiology", icon: "❤️" },
  { id: "eye", label: "Eye", icon: "👁️" },
  { id: "pediatric", label: "Pediatric", icon: "👶" },
  { id: "general", label: "General", icon: "➕" },
];

const CAT_GRADIENTS = {
  dental: "linear-gradient(135deg,#0d7377,#14a0a5)",
  ortho: "linear-gradient(135deg,#1a3a6b,#2563eb)",
  ayurved: "linear-gradient(135deg,#166534,#16a34a)",
  cardiology: "linear-gradient(135deg,#881337,#dc2626)",
  eye: "linear-gradient(135deg,#4338ca,#7c3aed)",
  pediatric: "linear-gradient(135deg,#c2410c,#f97316)",
  general: "linear-gradient(135deg,#0f766e,#0d9488)",
};

const CAT_ICONS = {
  dental: "🦷",
  ortho: "🦴",
  ayurved: "🌿",
  cardiology: "❤️",
  eye: "👁️",
  pediatric: "👶",
  general: "➕",
};

const TYPES = [
  "Dental",
  "Ortho",
  "Ayurved",
  "Cardiology",
  "Eye",
  "Pediatric",
  "General",
];
const PLANS = [
  { id: "starter", label: "Starter — ₹999/mo" },
  { id: "pro", label: "Pro — ₹1,999/mo" },
  { id: "enterprise", label: "Enterprise — ₹3,499/mo" },
];

// ── Register Modal ────────────────────────────────────────────
function RegisterModal({ onClose }) {
  const [step, setStep] = useState(1);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");
  const [form, setForm] = useState({
    name: "",
    type: "",
    phone: "",
    whatsapp: "",
    email: "",
    address: "",
    city: "",
    established: "",
    plan: "pro",
    adminId: "",
    password: "",
    registrationKey: "",
  });
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const inp = {
    width: "100%",
    padding: "10px 14px",
    borderRadius: 8,
    border: "1.5px solid #e2e8f0",
    fontSize: 14,
    fontFamily: "DM Sans,sans-serif",
    outline: "none",
    background: "#f8fafc",
    boxSizing: "border-box",
    marginTop: 4,
    marginBottom: 12,
  };
  const lbl = {
    fontSize: 12,
    fontWeight: 600,
    color: "#475569",
    display: "block",
  };

  const next = () => {
    if (!form.name || !form.type || !form.phone || !form.city) {
      setMsg("Please fill all required fields.");
      return;
    }
    setMsg("");
    setStep(2);
  };

  const submit = async () => {
    if (!form.adminId || !form.password) {
      setMsg("Admin ID and password are required.");
      return;
    }
    if (!form.registrationKey.trim()) {
      setMsg(
        "Registration access key is required. Contact PranJeev on WhatsApp to get your key.",
      );
      return;
    }
    setSaving(true);
    setMsg("");
    try {
      const slug = form.name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-|-$/g, "");
      const res = await fetch(`${API_URL}/hospitals/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...form, slug }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Registration failed");
      setStep(3);
    } catch (err) {
      setMsg(err.message);
    }
    setSaving(false);
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.6)",
        backdropFilter: "blur(4px)",
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 24,
          width: "100%",
          maxWidth: 520,
          maxHeight: "90vh",
          overflowY: "auto",
          boxShadow: "0 24px 80px rgba(0,0,0,0.4)",
        }}
      >
        {/* Header */}
        <div
          style={{
            background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
            padding: "22px 28px",
            borderRadius: "24px 24px 0 0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div>
            <div style={{ fontSize: 17, fontWeight: 700, color: "#fff" }}>
              {step === 3
                ? "🎉 Registration Successful!"
                : "🏥 Register Your Hospital"}
            </div>
            <div
              style={{
                fontSize: 12,
                color: "rgba(255,255,255,0.55)",
                marginTop: 3,
              }}
            >
              {step === 1 && "Step 1 of 2 — Hospital Details"}
              {step === 2 && "Step 2 of 2 — Admin Credentials & Access Key"}
              {step === 3 && "Your hospital is now live on PranJeev!"}
            </div>
          </div>
          <button
            onClick={onClose}
            style={{
              background: "rgba(255,255,255,0.12)",
              border: "none",
              color: "#fff",
              width: 32,
              height: 32,
              borderRadius: "50%",
              fontSize: 16,
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        </div>

        <form
          autoComplete="off"
          onSubmit={(e) => e.preventDefault()}
          style={{ padding: 28 }}
        >
          {msg && (
            <div
              style={{
                background: "#fef2f2",
                border: "1px solid #fecaca",
                borderRadius: 8,
                padding: "10px 14px",
                marginBottom: 16,
                fontSize: 13,
                color: "#dc2626",
              }}
            >
              {msg}
            </div>
          )}

          {/* STEP 1 */}
          {step === 1 && (
            <>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "0 14px",
                }}
              >
                <div>
                  <label style={lbl}>Hospital Name *</label>
                  <input
                    style={inp}
                    placeholder="e.g. Sai Dental Hospital"
                    autoComplete="off"
                    value={form.name}
                    onChange={(e) => set("name", e.target.value)}
                  />
                </div>
                <div>
                  <label style={lbl}>Hospital Type *</label>
                  <select
                    style={inp}
                    value={form.type}
                    onChange={(e) => set("type", e.target.value)}
                  >
                    <option value="">Select type</option>
                    {TYPES.map((t) => (
                      <option key={t} value={t.toLowerCase()}>
                        {t}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label style={lbl}>Phone *</label>
                  <input
                    style={inp}
                    placeholder="+91 98765 43210"
                    autoComplete="off"
                    value={form.phone}
                    onChange={(e) => set("phone", e.target.value)}
                  />
                </div>
                <div>
                  <label style={lbl}>WhatsApp (no +)</label>
                  <input
                    style={inp}
                    placeholder="919876543210"
                    autoComplete="off"
                    value={form.whatsapp}
                    onChange={(e) => set("whatsapp", e.target.value)}
                  />
                </div>
                <div style={{ gridColumn: "1/-1" }}>
                  <label style={lbl}>Email</label>
                  <input
                    style={inp}
                    type="email"
                    placeholder="info@hospital.com"
                    autoComplete="off"
                    value={form.email}
                    onChange={(e) => set("email", e.target.value)}
                  />
                </div>
                <div>
                  <label style={lbl}>Address</label>
                  <input
                    style={inp}
                    placeholder="Street, Area"
                    autoComplete="off"
                    value={form.address}
                    onChange={(e) => set("address", e.target.value)}
                  />
                </div>
                <div>
                  <label style={lbl}>City *</label>
                  <input
                    style={inp}
                    placeholder="e.g. Mumbai, MH"
                    autoComplete="off"
                    value={form.city}
                    onChange={(e) => set("city", e.target.value)}
                  />
                </div>
                <div>
                  <label style={lbl}>Established Year</label>
                  <input
                    style={inp}
                    placeholder="e.g. 2010"
                    autoComplete="off"
                    value={form.established}
                    onChange={(e) => set("established", e.target.value)}
                  />
                </div>
                <div>
                  <label style={lbl}>Plan</label>
                  <select
                    style={inp}
                    value={form.plan}
                    onChange={(e) => set("plan", e.target.value)}
                  >
                    {PLANS.map((p) => (
                      <option key={p.id} value={p.id}>
                        {p.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <button
                onClick={next}
                style={{
                  width: "100%",
                  padding: 13,
                  background: "linear-gradient(135deg,#0d7377,#14a0a5)",
                  color: "#fff",
                  border: "none",
                  borderRadius: 10,
                  fontSize: 15,
                  fontWeight: 700,
                  cursor: "pointer",
                }}
              >
                Next: Create Admin Account →
              </button>
            </>
          )}

          {/* STEP 2 */}
          {step === 2 && (
            <>
              <div
                style={{
                  background: "#f0fdf4",
                  border: "1px solid #bbf7d0",
                  borderRadius: 10,
                  padding: "12px 16px",
                  marginBottom: 20,
                  fontSize: 13,
                  color: "#166534",
                }}
              >
                ✅ <strong>{form.name}</strong> · {form.city}
              </div>
              <label style={lbl}>Admin ID *</label>
              <input
                style={inp}
                placeholder="e.g. saidental_admin"
                autoComplete="off"
                value={form.adminId}
                onChange={(e) => set("adminId", e.target.value)}
              />
              <label style={lbl}>Password *</label>
              <input
                style={inp}
                type="password"
                placeholder="Create a strong password"
                autoComplete="new-password"
                value={form.password}
                onChange={(e) => set("password", e.target.value)}
              />
              <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 18 }}>
                💡 Save these credentials — you'll use them to login to your
                admin panel.
              </div>
              <div
                style={{
                  background: "#fffbeb",
                  border: "1px solid #fde68a",
                  borderRadius: 10,
                  padding: "14px 16px",
                  marginBottom: 16,
                }}
              >
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 700,
                    color: "#92400e",
                    marginBottom: 8,
                  }}
                >
                  🔐 Registration Access Key Required
                </div>
                <div
                  style={{
                    fontSize: 12,
                    color: "#92400e",
                    marginBottom: 10,
                    lineHeight: 1.5,
                  }}
                >
                  This is a private key provided by PranJeev. Without it,
                  registration is not allowed. Contact us on WhatsApp to get
                  your key before registering.
                </div>
                <a
                  href="https://wa.me/918793608083?text=Hi%20PranJeev%2C%20I%20want%20to%20register%20my%20hospital.%20Please%20share%20the%20registration%20key."
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 8,
                    margin: "6px 0 12px",
                    background: "#25d366",
                    color: "#fff",
                    borderRadius: 8,
                    padding: "9px 16px",
                    fontSize: 13,
                    fontWeight: 700,
                    textDecoration: "none",
                  }}
                >
                  💬 Contact PranJeev Owner — +91 87936 08083
                </a>
                <label style={{ ...lbl, color: "#92400e" }}>Access Key *</label>
                <input
                  style={{
                    ...inp,
                    marginBottom: 0,
                    background: "#fff",
                    border: "1.5px solid #fcd34d",
                  }}
                  type="password"
                  placeholder="Enter your PranJeev registration key"
                  autoComplete="new-password"
                  value={form.registrationKey}
                  onChange={(e) => set("registrationKey", e.target.value)}
                />
              </div>
              <div style={{ display: "flex", gap: 10 }}>
                <button
                  onClick={() => setStep(1)}
                  style={{
                    flex: 1,
                    padding: 13,
                    background: "#f1f5f9",
                    color: "#475569",
                    border: "none",
                    borderRadius: 10,
                    fontSize: 14,
                    fontWeight: 600,
                    cursor: "pointer",
                  }}
                >
                  ← Back
                </button>
                <button
                  onClick={submit}
                  disabled={saving}
                  style={{
                    flex: 2,
                    padding: 13,
                    background: saving
                      ? "#94a3b8"
                      : "linear-gradient(135deg,#0d7377,#14a0a5)",
                    color: "#fff",
                    border: "none",
                    borderRadius: 10,
                    fontSize: 15,
                    fontWeight: 700,
                    cursor: saving ? "not-allowed" : "pointer",
                  }}
                >
                  {saving ? "Registering..." : "🚀 Complete Registration"}
                </button>
              </div>
            </>
          )}

          {/* STEP 3 */}
          {step === 3 && (
            <div style={{ textAlign: "center", padding: "20px 0" }}>
              <div style={{ fontSize: 64, marginBottom: 16 }}>🎉</div>
              <h3
                style={{
                  fontSize: 22,
                  fontWeight: 700,
                  color: "#0a1628",
                  marginBottom: 8,
                }}
              >
                {form.name}
              </h3>
              <p
                style={{
                  fontSize: 14,
                  color: "#64748b",
                  marginBottom: 24,
                  lineHeight: 1.6,
                }}
              >
                Your hospital is now live on PranJeev! Use your credentials to
                login.
              </p>
              <div
                style={{
                  background: "#f0fdf4",
                  border: "1px solid #bbf7d0",
                  borderRadius: 12,
                  padding: "16px 20px",
                  marginBottom: 24,
                  textAlign: "left",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    fontWeight: 700,
                    color: "#16a34a",
                    marginBottom: 8,
                  }}
                >
                  YOUR LOGIN CREDENTIALS
                </div>
                <div style={{ fontSize: 14, color: "#166534" }}>
                  Admin ID: <strong>{form.adminId}</strong>
                </div>
                <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>
                  (Save your password securely)
                </div>
              </div>
              <button
                onClick={onClose}
                style={{
                  width: "100%",
                  padding: 13,
                  background: "linear-gradient(135deg,#0d7377,#14a0a5)",
                  color: "#fff",
                  border: "none",
                  borderRadius: 10,
                  fontSize: 15,
                  fontWeight: 700,
                  cursor: "pointer",
                }}
              >
                Done ✓
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

// ── Main PranJeev Page ────────────────────────────────────────
export default function PranJeev() {
  const navigate = useNavigate();
  const [hospitals, setHospitals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [activeCat, setActiveCat] = useState("all");
  const [regOpen, setRegOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const fetchHospitals = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/hospitals`);
      if (r.ok) {
        const data = await r.json();
        setHospitals(Array.isArray(data) ? data : []);
      }
    } catch (_) {}
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchHospitals();
  }, [fetchHospitals]);

  // ✅ FIX: All hospitals from DB — PearlSmile now live like every other hospital
  const allHospitals = hospitals;

  const filtered = allHospitals.filter((h) => {
    const matchCat =
      activeCat === "all" || (h.type || "").toLowerCase() === activeCat;
    const q = search.toLowerCase();
    const matchSearch =
      !q ||
      (h.name || "").toLowerCase().includes(q) ||
      (h.city || "").toLowerCase().includes(q) ||
      (h.type || "").toLowerCase().includes(q);
    return matchCat && matchSearch;
  });

  const css = `
    * { box-sizing:border-box; margin:0; padding:0; }
    body { font-family:"DM Sans",sans-serif; }
    .vo-nav { position:fixed; top:0; left:0; right:0; z-index:1000; background:rgba(10,22,40,0.97); backdrop-filter:blur(12px); border-bottom:1px solid rgba(255,255,255,0.06); display:flex; align-items:center; justify-content:space-between; padding:0 40px; height:68px; gap:16px; }
    .vo-logo { display:flex; align-items:center; gap:10px; cursor:pointer; flex-shrink:0; min-width:0; }
    .vo-logo-icon { width:38px; height:38px; border-radius:10px; overflow:hidden; flex-shrink:0; display:flex; align-items:center; justify-content:center; background:linear-gradient(135deg,#0d7377,#14a0a5); }
    .vo-logo-icon img { width:100%; height:100%; object-fit:cover; display:block; border-radius:10px; }
    .vo-logo-textblock { display:flex; flex-direction:column; min-width:0; }
    .vo-logo-text { font-family:"Cormorant Garamond",serif; font-size:22px; font-weight:700; color:#fff; white-space:nowrap; line-height:1.2; }
    .vo-logo-sub  { font-size:9px; color:#c9a845; letter-spacing:2px; text-transform:uppercase; white-space:nowrap; }
    .vo-nav-links { display:flex; align-items:center; gap:12px; flex-shrink:0; }
    .vo-nav-btn { background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; padding:10px 22px; border-radius:8px; font-weight:700; font-size:13px; font-family:"DM Sans",sans-serif; cursor:pointer; white-space:nowrap; }
    .vo-nav-sa  { background:rgba(255,255,255,0.06); color:rgba(255,255,255,0.55); border:1px solid rgba(255,255,255,0.12); padding:8px 14px; border-radius:8px; font-weight:600; font-size:12px; font-family:"DM Sans",sans-serif; cursor:pointer; white-space:nowrap; }
    .vo-nav-sa:hover { background:rgba(255,255,255,0.12); color:#fff; }
    .vo-hamburger { display:none; flex-direction:column; gap:5px; background:none; border:none; cursor:pointer; padding:6px; z-index:1100; flex-shrink:0; }
    .vo-hamburger span { display:block; width:28px; height:2.5px; background:#fff; border-radius:2px; transition:all 0.3s; }
    .vo-mobile-menu { display:none; position:fixed; top:68px; left:0; right:0; background:rgba(10,22,40,0.98); backdrop-filter:blur(16px); border-bottom:1px solid rgba(255,255,255,0.08); padding:16px 20px 20px; flex-direction:column; gap:12px; z-index:999; }
    .vo-mobile-menu.open { display:flex; }
    .vo-mobile-link { color:rgba(255,255,255,0.8); font-size:15px; font-weight:500; padding:10px 0; border-bottom:1px solid rgba(255,255,255,0.07); cursor:pointer; font-family:"DM Sans",sans-serif; background:none; border-left:none; border-right:none; border-top:none; text-align:left; }
    .vo-mobile-btn { width:100%; padding:12px; background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; border-radius:10px; font-size:14px; font-weight:700; cursor:pointer; font-family:"DM Sans",sans-serif; margin-top:4px; }
    .vo-mobile-sa  { width:100%; padding:10px; background:rgba(255,255,255,0.06); color:rgba(255,255,255,0.7); border:1px solid rgba(255,255,255,0.15); border-radius:10px; font-size:13px; font-weight:600; cursor:pointer; font-family:"DM Sans",sans-serif; }
    .vo-hero { min-height:100vh; background:linear-gradient(135deg,#0a1628 0%,#0d2444 50%,#0a1f3a 100%); display:flex; align-items:center; padding-top:68px; position:relative; overflow:hidden; }
    .vo-hero::before { content:""; position:absolute; top:-200px; right:-200px; width:600px; height:600px; background:radial-gradient(circle,rgba(13,115,119,0.15) 0%,transparent 70%); border-radius:50%; }
    .vo-hero-inner { max-width:1200px; margin:0 auto; padding:80px 24px; display:grid; grid-template-columns:1fr 1fr; gap:60px; align-items:center; position:relative; z-index:1; }
    .vo-badge { display:inline-flex; align-items:center; gap:8px; background:rgba(201,168,76,0.15); border:1px solid rgba(201,168,76,0.3); color:#c9a845; font-size:11px; font-weight:700; letter-spacing:1px; text-transform:uppercase; padding:7px 16px; border-radius:100px; margin-bottom:24px; }
    .vo-hero h1 { font-family:"Cormorant Garamond",serif; font-size:clamp(40px,5vw,64px); font-weight:700; color:#fff; line-height:1.1; margin-bottom:20px; }
    .vo-hero h1 em { font-style:italic; color:#14a0a5; }
    .vo-hero-desc { font-size:16px; color:rgba(255,255,255,0.7); line-height:1.7; margin-bottom:36px; max-width:480px; }
    .vo-actions { display:flex; gap:14px; flex-wrap:wrap; }
    .vo-btn-primary { background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; padding:14px 28px; border-radius:10px; font-size:15px; font-weight:700; font-family:"DM Sans",sans-serif; cursor:pointer; transition:opacity 0.2s,transform 0.2s; }
    .vo-btn-primary:hover { opacity:0.92; transform:translateY(-1px); }
    .vo-btn-outline { background:transparent; color:#fff; border:1.5px solid rgba(255,255,255,0.3); padding:14px 28px; border-radius:10px; font-size:15px; font-weight:600; font-family:"DM Sans",sans-serif; cursor:pointer; }
    .vo-stats { display:flex; gap:32px; margin-top:40px; }
    .vo-stat-num { font-family:"Cormorant Garamond",serif; font-size:28px; font-weight:700; color:#14a0a5; }
    .vo-stat-lbl { font-size:12px; color:rgba(255,255,255,0.5); margin-top:2px; }
    .vo-float-cards { display:flex; flex-direction:column; gap:14px; }
    .vo-float-card { background:rgba(255,255,255,0.06); border:1px solid rgba(255,255,255,0.1); backdrop-filter:blur(12px); border-radius:16px; padding:18px 22px; display:flex; align-items:center; gap:14px; transition:transform 0.3s; }
    .vo-float-card:hover { transform:translateX(6px); }
    .vo-float-icon { width:46px; height:46px; border-radius:12px; display:flex; align-items:center; justify-content:center; font-size:22px; flex-shrink:0; }
    .vo-float-title { font-size:14px; font-weight:700; color:#fff; margin-bottom:3px; }
    .vo-float-desc  { font-size:12px; color:rgba(255,255,255,0.55); }
    .vo-hospitals { padding:100px 0; background:#f8fafc; }
    .vo-container { max-width:1200px; margin:0 auto; padding:0 24px; }
    .vo-section-tag { display:inline-flex; align-items:center; gap:6px; background:rgba(13,115,119,0.1); border:1px solid rgba(13,115,119,0.25); color:#0d7377; font-size:11px; font-weight:700; letter-spacing:1.2px; text-transform:uppercase; padding:6px 14px; border-radius:100px; margin-bottom:16px; }
    .vo-section-title { font-family:"Cormorant Garamond",serif; font-size:clamp(32px,4vw,52px); font-weight:700; color:#0a1628; line-height:1.15; margin-bottom:16px; }
    .vo-section-title em { font-style:italic; color:#0d7377; }
    .vo-controls { display:flex; gap:16px; margin-bottom:32px; flex-wrap:wrap; align-items:center; }
    .vo-search { flex:1; min-width:260px; padding:12px 18px; border-radius:10px; border:1.5px solid #e2e8f0; font-size:14px; font-family:"DM Sans",sans-serif; outline:none; background:#fff; transition:border-color 0.2s; }
    .vo-search:focus { border-color:#0d7377; }
    .vo-cats { display:flex; gap:8px; flex-wrap:wrap; }
    .vo-cat { padding:8px 14px; border-radius:100px; border:1.5px solid #e2e8f0; background:#fff; font-size:13px; font-weight:600; color:#475569; cursor:pointer; transition:all 0.2s; white-space:nowrap; font-family:"DM Sans",sans-serif; }
    .vo-cat:hover { border-color:#0d7377; color:#0d7377; }
    .vo-cat.active { background:#0d7377; border-color:#0d7377; color:#fff; }
    .vo-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(300px,1fr)); gap:28px; }
    .vo-card { background:#fff; border-radius:20px; overflow:hidden; box-shadow:0 4px 32px rgba(0,0,0,0.08); transition:transform 0.28s,box-shadow 0.28s; cursor:pointer; border:1px solid #f1f5f9; }
    .vo-card:hover { transform:translateY(-6px); box-shadow:0 12px 48px rgba(0,0,0,0.14); }
    .vo-card-top { height:140px; display:flex; align-items:center; justify-content:center; position:relative; font-size:52px; }
    .vo-card-badge { position:absolute; top:14px; right:14px; background:rgba(255,255,255,0.2); backdrop-filter:blur(8px); border:1px solid rgba(255,255,255,0.3); border-radius:20px; padding:4px 12px; font-size:11px; font-weight:700; color:#fff; }
    .vo-card-body { padding:20px 22px 22px; }
    .vo-card-name { font-family:"Cormorant Garamond",serif; font-size:20px; font-weight:700; color:#0a1628; margin-bottom:4px; }
    .vo-card-type { font-size:12px; font-weight:700; color:#0d7377; text-transform:uppercase; letter-spacing:0.5px; margin-bottom:8px; }
    .vo-card-city { font-size:13px; color:#94a3b8; margin-bottom:14px; }
    .vo-card-stats { display:flex; gap:16px; padding:12px 0; border-top:1px solid #f1f5f9; border-bottom:1px solid #f1f5f9; margin-bottom:14px; }
    .vo-card-stat { text-align:center; flex:1; }
    .vo-card-stat-num { font-size:15px; font-weight:700; color:#0a1628; }
    .vo-card-stat-lbl { font-size:10px; color:#94a3b8; margin-top:2px; }
    .vo-card-btn { width:100%; padding:11px; background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; border:none; border-radius:10px; font-size:13px; font-weight:700; cursor:pointer; font-family:"DM Sans",sans-serif; }
    .vo-empty { grid-column:1/-1; text-align:center; padding:60px 0; color:#94a3b8; font-size:15px; }
    @keyframes vopulse { 0%,100%{opacity:1}50%{opacity:0.45} }
    .vo-skel { background:#e2e8f0; border-radius:8px; animation:vopulse 1.5s ease-in-out infinite; }
    .vo-cta { padding:100px 0; background:linear-gradient(135deg,#0a1628,#0d2444); text-align:center; }
    .vo-cta-title { font-family:"Cormorant Garamond",serif; font-size:clamp(32px,4vw,52px); font-weight:700; color:#fff; margin-bottom:16px; }
    .vo-cta-title em { font-style:italic; color:#14a0a5; }
    .vo-cta-desc { font-size:16px; color:rgba(255,255,255,0.65); max-width:520px; margin:0 auto 40px; line-height:1.7; }
    .vo-plans { display:flex; gap:20px; justify-content:center; flex-wrap:wrap; margin-bottom:36px; }
    .vo-plan { background:rgba(255,255,255,0.08); border:1px solid rgba(255,255,255,0.15); border-radius:16px; padding:22px 26px; min-width:180px; }
    .vo-plan.featured { background:linear-gradient(135deg,#0d7377,#14a0a5); border-color:transparent; }
    .vo-plan-name { font-size:12px; font-weight:700; color:rgba(255,255,255,0.65); text-transform:uppercase; letter-spacing:1px; margin-bottom:8px; }
    .vo-plan-price { font-family:"Cormorant Garamond",serif; font-size:30px; font-weight:700; color:#fff; line-height:1; margin-bottom:4px; }
    .vo-plan-period { font-size:12px; color:rgba(255,255,255,0.5); margin-bottom:10px; }
    .vo-plan-features { font-size:12px; color:rgba(255,255,255,0.6); line-height:1.6; }
    .vo-how { padding:100px 0; background:#fff; }
    .vo-how-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:28px; margin-top:56px; }
    .vo-how-card { text-align:center; padding:28px 20px; border-radius:20px; background:#f8fafc; border:1px solid #f1f5f9; }
    .vo-how-step { width:46px; height:46px; border-radius:50%; background:linear-gradient(135deg,#0d7377,#14a0a5); color:#fff; font-size:18px; font-weight:800; display:flex; align-items:center; justify-content:center; margin:0 auto 14px; }
    .vo-how-icon { font-size:30px; margin-bottom:12px; }
    .vo-how-title { font-size:15px; font-weight:700; color:#0a1628; margin-bottom:8px; }
    .vo-how-desc  { font-size:13px; color:#475569; line-height:1.6; }
    .vo-footer { background:#0a1628; padding:56px 0 24px; border-top:1px solid rgba(255,255,255,0.06); }
    .vo-footer-inner { max-width:1200px; margin:0 auto; padding:0 24px 40px; display:grid; grid-template-columns:2fr 1fr 1fr; gap:48px; }
    .vo-footer-desc { font-size:14px; color:rgba(255,255,255,0.5); line-height:1.7; margin-top:10px; max-width:280px; }
    .vo-footer-col h4 { font-size:12px; font-weight:700; color:rgba(255,255,255,0.85); text-transform:uppercase; letter-spacing:1px; margin-bottom:14px; }
    .vo-footer-col ul { list-style:none; }
    .vo-footer-col ul li { margin-bottom:8px; }
    .vo-footer-col ul li a { font-size:13px; color:rgba(255,255,255,0.5); cursor:pointer; }
    .vo-footer-bottom { max-width:1200px; margin:0 auto; padding:20px 24px 0; border-top:1px solid rgba(255,255,255,0.07); display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:12px; font-size:13px; color:rgba(255,255,255,0.35); }

    /* ── Footer logo ── */
    .vo-footer-logo-icon { width:36px; height:36px; border-radius:10px; overflow:hidden; flex-shrink:0; display:flex; align-items:center; justify-content:center; background:linear-gradient(135deg,#0d7377,#14a0a5); }
    .vo-footer-logo-icon img { width:100%; height:100%; object-fit:cover; display:block; border-radius:10px; }

    /* ── Responsive navbar — FIXED: bigger logo + navbar on mobile/tablet ── */
    @media(max-width:860px) {
      .vo-nav { padding:0 20px; height:76px; }
      .vo-nav-links { display:none !important; }
      .vo-hamburger { display:flex; }
      .vo-mobile-menu { top:76px; }
      /* ✅ Logo 2x bigger on tablet */
      .vo-logo-icon { width:52px; height:52px; border-radius:12px; }
      .vo-logo-text { font-size:26px; }
      .vo-logo-sub  { font-size:9px; letter-spacing:1.5px; display:block; }
      .vo-logo { gap:12px; }
      /* ✅ Hamburger bigger */
      .vo-hamburger span { width:30px; height:3px; }
      .vo-footer-logo-icon { width:40px; height:40px; border-radius:10px; }
      .vo-hero-inner { grid-template-columns:1fr; }
      .vo-float-cards { display:none; }
      .vo-how-grid { grid-template-columns:repeat(2,1fr); }
      .vo-footer-inner { grid-template-columns:1fr; gap:28px; }
    }
    @media(max-width:480px) {
      .vo-nav { padding:0 16px; height:72px; }
      .vo-mobile-menu { top:72px; }
      /* ✅ Logo 2x bigger on mobile */
      .vo-logo-icon { width:48px; height:48px; border-radius:11px; }
      .vo-logo-text { font-size:24px; }
      .vo-logo-sub  { font-size:8px; letter-spacing:1.2px; display:block; }
      .vo-logo { gap:11px; }
      .vo-footer-logo-icon { width:36px; height:36px; border-radius:9px; }
    }
    @media(max-width:600px) {
      .vo-grid { grid-template-columns:1fr; }
      .vo-how-grid { grid-template-columns:1fr; }
      .vo-stats { gap:20px; }
      .vo-plans { flex-direction:column; align-items:center; }
    }
  `;

  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <div style={{ fontFamily: "DM Sans,sans-serif" }}>
      <style>{css}</style>

      {/* Navbar */}
      <div className="vo-nav">
        <div className="vo-logo">
          <div className="vo-logo-icon">
            <img src={logo} alt="PranJeev Logo" />
          </div>
          <div className="vo-logo-textblock">
            <div className="vo-logo-text">PranJeev</div>
            <div className="vo-logo-sub">Life-Giving Healthcare</div>
          </div>
        </div>
        <div className="vo-nav-links">
          <a
            onClick={() => scrollTo("hospitals")}
            style={{
              color: "rgba(255,255,255,0.7)",
              fontSize: 14,
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            Hospitals
          </a>
          <a
            onClick={() => scrollTo("how")}
            style={{
              color: "rgba(255,255,255,0.7)",
              fontSize: 14,
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            How It Works
          </a>
          <button className="vo-nav-btn" onClick={() => setRegOpen(true)}>
            Register Hospital
          </button>
          <button className="vo-nav-sa" onClick={() => navigate("/superadmin")}>
            🛡️ Admin
          </button>
        </div>
        <button
          className="vo-hamburger"
          onClick={() => setMenuOpen((m) => !m)}
          aria-label="Menu"
        >
          <span
            style={{
              transform: menuOpen ? "rotate(45deg) translate(5px,5px)" : "none",
            }}
          />
          <span style={{ opacity: menuOpen ? 0 : 1 }} />
          <span
            style={{
              transform: menuOpen
                ? "rotate(-45deg) translate(5px,-5px)"
                : "none",
            }}
          />
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`vo-mobile-menu${menuOpen ? " open" : ""}`}>
        <button
          className="vo-mobile-link"
          onClick={() => {
            scrollTo("hospitals");
            setMenuOpen(false);
          }}
        >
          🏥 Hospitals
        </button>
        <button
          className="vo-mobile-link"
          onClick={() => {
            scrollTo("how");
            setMenuOpen(false);
          }}
        >
          ⚙️ How It Works
        </button>
        <button
          className="vo-mobile-link"
          onClick={() => {
            scrollTo("pricing");
            setMenuOpen(false);
          }}
        >
          💰 Pricing
        </button>
        <button
          className="vo-mobile-btn"
          onClick={() => {
            setRegOpen(true);
            setMenuOpen(false);
          }}
        >
          Register Your Hospital →
        </button>
        <button
          className="vo-mobile-sa"
          onClick={() => {
            navigate("/superadmin");
            setMenuOpen(false);
          }}
        >
          🛡️ Admin
        </button>
      </div>

      {/* Hero */}
      <section className="vo-hero" id="home">
        <div className="vo-hero-inner">
          <div>
            <div className="vo-badge">
              🌟 India's Life-Giving Healthcare Platform
            </div>
            <h1>
              Find & Book
              <br />
              <em>Top Hospitals</em>
              <br />
              Near You
            </h1>
            <p className="vo-hero-desc">
              From Dental to Ortho, Ayurved to Cardiology — discover verified
              hospitals, book appointments instantly, and manage your health all
              in one place.
            </p>
            <div className="vo-actions">
              <button
                className="vo-btn-primary"
                onClick={() => scrollTo("hospitals")}
              >
                Find Hospitals →
              </button>
              <button
                className="vo-btn-outline"
                onClick={() => setRegOpen(true)}
              >
                Register Your Hospital
              </button>
            </div>
            <div className="vo-stats">
              {[
                ["200+", "Hospitals"],
                ["50K+", "Patients"],
                ["7", "Specialities"],
              ].map(([n, l]) => (
                <div key={l}>
                  <div className="vo-stat-num">{n}</div>
                  <div className="vo-stat-lbl">{l}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="vo-float-cards">
            {[
              {
                icon: "🦷",
                bg: "linear-gradient(135deg,#0d7377,#14a0a5)",
                title: "Dental Care",
                desc: "Root canal, implants, whitening",
              },
              {
                icon: "🦴",
                bg: "linear-gradient(135deg,#1a3a6b,#2563eb)",
                title: "Ortho Care",
                desc: "Joint replacement, physiotherapy",
              },
              {
                icon: "🌿",
                bg: "linear-gradient(135deg,#166534,#16a34a)",
                title: "Ayurved",
                desc: "Panchakarma, herbal treatments",
              },
              {
                icon: "❤️",
                bg: "linear-gradient(135deg,#881337,#dc2626)",
                title: "Cardiology",
                desc: "Heart care, ECG, consultations",
              },
            ].map((c) => (
              <div key={c.title} className="vo-float-card">
                <div className="vo-float-icon" style={{ background: c.bg }}>
                  {c.icon}
                </div>
                <div>
                  <div className="vo-float-title">{c.title}</div>
                  <div className="vo-float-desc">{c.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Hospital Grid */}
      <section className="vo-hospitals" id="hospitals">
        <div className="vo-container">
          <div style={{ textAlign: "center", marginBottom: 48 }}>
            <div className="vo-section-tag">🏥 Browse Hospitals</div>
            <h2 className="vo-section-title">
              Find the Right
              <br />
              <em>Hospital for You</em>
            </h2>
            <p
              style={{
                fontSize: 16,
                color: "#475569",
                maxWidth: 540,
                margin: "0 auto",
                lineHeight: 1.7,
              }}
            >
              Browse verified hospitals by speciality or city.
            </p>
          </div>
          <div className="vo-controls">
            <input
              className="vo-search"
              placeholder="🔍 Search by hospital name or city..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              autoComplete="off"
            />
            <div className="vo-cats">
              {CATEGORIES.map((c) => (
                <button
                  key={c.id}
                  className={`vo-cat${activeCat === c.id ? " active" : ""}`}
                  onClick={() => setActiveCat(c.id)}
                >
                  {c.icon} {c.label}
                </button>
              ))}
            </div>
          </div>
          <div style={{ fontSize: 13, color: "#94a3b8", marginBottom: 24 }}>
            {loading
              ? "Loading hospitals..."
              : `${filtered.length} hospital${filtered.length !== 1 ? "s" : ""} found`}
          </div>
          <div className="vo-grid">
            {loading ? (
              [1, 2, 3, 4, 5, 6].map((i) => (
                <div
                  key={i}
                  style={{
                    background: "#fff",
                    borderRadius: 20,
                    overflow: "hidden",
                  }}
                >
                  <div className="vo-skel" style={{ height: 140 }} />
                  <div style={{ padding: "20px 22px" }}>
                    <div
                      className="vo-skel"
                      style={{ height: 20, width: "70%", marginBottom: 8 }}
                    />
                    <div
                      className="vo-skel"
                      style={{ height: 13, width: "40%", marginBottom: 14 }}
                    />
                    <div
                      className="vo-skel"
                      style={{ height: 38, borderRadius: 10 }}
                    />
                  </div>
                </div>
              ))
            ) : filtered.length === 0 ? (
              <div className="vo-empty">No hospitals match your search.</div>
            ) : (
              filtered.map((h) => {
                const type = (h.type || "general").toLowerCase();
                const grad = CAT_GRADIENTS[type] || CAT_GRADIENTS.general;
                const cat = CATEGORIES.find((c) => c.id === type);
                return (
                  <div
                    key={h._id}
                    className="vo-card"
                    onClick={() => navigate(`/hospital/${h.slug}`)}
                  >
                    <div className="vo-card-top" style={{ background: grad }}>
                      <div className="vo-card-badge">
                        {cat?.label || "Hospital"}
                      </div>
                      {h.logoUrl ? (
                        // ✅ Option 2: Square white box — logo visible on any gradient
                        <div
                          style={{
                            width: 76,
                            height: 76,
                            background: "#fff",
                            borderRadius: 14,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0 4px 16px rgba(0,0,0,0.18)",
                          }}
                        >
                          <img
                            src={h.logoUrl}
                            alt={h.name}
                            style={{
                              width: 58,
                              height: 58,
                              borderRadius: 10,
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      ) : (
                        <div
                          style={{
                            width: 76,
                            height: 76,
                            background: "rgba(255,255,255,0.15)",
                            borderRadius: 14,
                            border: "2px solid rgba(255,255,255,0.3)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 34,
                          }}
                        >
                          <span>{CAT_ICONS[type] || "🏥"}</span>
                        </div>
                      )}
                    </div>
                    <div className="vo-card-body">
                      <div className="vo-card-name">{h.name}</div>
                      <div className="vo-card-type">
                        {cat?.icon} {cat?.label || "Hospital"}
                      </div>
                      <div className="vo-card-city">
                        📍 {h.city || "Location not specified"}
                      </div>
                      <div className="vo-card-stats">
                        {[
                          ["Patients", h.statPatients],
                          ["Doctors", h.statDoctors],
                          ["Rating", h.statRating],
                        ].map(([l, v]) => (
                          <div key={l} className="vo-card-stat">
                            <div className="vo-card-stat-num">{v || "—"}</div>
                            <div className="vo-card-stat-lbl">{l}</div>
                          </div>
                        ))}
                      </div>
                      <button className="vo-card-btn">
                        Book Appointment →
                      </button>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="vo-how" id="how">
        <div className="vo-container">
          <div style={{ textAlign: "center" }}>
            <div className="vo-section-tag">Simple Process</div>
            <h2 className="vo-section-title">
              How <em>PranJeev</em> Works
            </h2>
            <p
              style={{
                fontSize: 16,
                color: "#475569",
                maxWidth: 520,
                margin: "0 auto",
                lineHeight: 1.7,
              }}
            >
              Get your hospital live in under 10 minutes. No technical knowledge
              required.
            </p>
          </div>
          <div className="vo-how-grid">
            {[
              {
                step: "1",
                icon: "🏥",
                title: "Register Hospital",
                desc: "Fill your hospital details, choose a plan and pay securely.",
              },
              {
                step: "2",
                icon: "⚙️",
                title: "Setup Your Panel",
                desc: "Add your doctors, services and pricing inside your admin dashboard.",
              },
              {
                step: "3",
                icon: "📅",
                title: "Patients Book",
                desc: "Patients find your hospital on PranJeev and book appointments online.",
              },
              {
                step: "4",
                icon: "📊",
                title: "Manage Everything",
                desc: "Track appointments, patients, billing and doctor availability in one panel.",
              },
            ].map((s) => (
              <div key={s.step} className="vo-how-card">
                <div className="vo-how-step">{s.step}</div>
                <div className="vo-how-icon">{s.icon}</div>
                <div className="vo-how-title">{s.title}</div>
                <div className="vo-how-desc">{s.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA / Pricing */}
      <section className="vo-cta" id="pricing">
        <div className="vo-container">
          <div
            className="vo-section-tag"
            style={{
              background: "rgba(201,168,76,0.15)",
              borderColor: "rgba(201,168,76,0.3)",
              color: "#c9a845",
            }}
          >
            💰 Simple Pricing
          </div>
          <h2 className="vo-cta-title">
            Register Your Hospital
            <br />
            <em>Start Today</em>
          </h2>
          <p className="vo-cta-desc">
            Choose a plan that fits your hospital. All plans include full admin
            panel, patient management & WhatsApp integration.
          </p>
          <div className="vo-plans">
            {[
              {
                name: "Starter",
                price: "₹999",
                period: "/month",
                features: "3 Doctors · Appointments · Patients",
              },
              {
                name: "Pro",
                price: "₹1,999",
                period: "/month",
                features: "10 Doctors · Billing · WhatsApp",
                featured: true,
              },
              {
                name: "Enterprise",
                price: "₹3,499",
                period: "/month",
                features: "Unlimited · Priority Support · Custom Domain",
              },
            ].map((p) => (
              <div
                key={p.name}
                className={`vo-plan${p.featured ? " featured" : ""}`}
              >
                <div className="vo-plan-name">{p.name}</div>
                <div className="vo-plan-price">{p.price}</div>
                <div className="vo-plan-period">{p.period}</div>
                <div className="vo-plan-features">{p.features}</div>
              </div>
            ))}
          </div>
          <button
            className="vo-btn-primary"
            style={{ fontSize: 16, padding: "15px 36px" }}
            onClick={() => setRegOpen(true)}
          >
            Register Your Hospital Now →
          </button>
          <div
            style={{
              fontSize: 12,
              color: "rgba(255,255,255,0.4)",
              marginTop: 14,
            }}
          >
            14-day free trial · No credit card required to start
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="vo-footer">
        <div className="vo-footer-inner">
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div className="vo-footer-logo-icon">
                <img src={logo} alt="PranJeev Logo" />
              </div>
              <div>
                <div
                  style={{
                    fontFamily: "Cormorant Garamond,serif",
                    fontSize: 20,
                    fontWeight: 700,
                    color: "#fff",
                  }}
                >
                  PranJeev
                </div>
                <div
                  style={{
                    fontSize: 9,
                    color: "#c9a845",
                    letterSpacing: 2,
                    textTransform: "uppercase",
                  }}
                >
                  Life-Giving Healthcare
                </div>
              </div>
            </div>
            <p className="vo-footer-desc">
              Prana (life force) + Jeev (living being) — India's life-giving
              hospital management platform.
            </p>
          </div>
          <div className="vo-footer-col">
            <h4>For Hospitals</h4>
            <ul>
              {[
                "Register Hospital",
                "Pricing Plans",
                "How It Works",
                "Admin Login",
              ].map((s) => (
                <li key={s}>
                  <a>{s}</a>
                </li>
              ))}
            </ul>
          </div>
          <div className="vo-footer-col">
            <h4>Specialities</h4>
            <ul>
              {[
                "🦷 Dental",
                "🦴 Ortho",
                "🌿 Ayurved",
                "❤️ Cardiology",
                "👁️ Eye Care",
                "👶 Pediatric",
              ].map((s) => (
                <li key={s}>
                  <a>{s}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="vo-footer-bottom">
          <p>
            © 2026 PranJeev · Life-Giving Healthcare Platform. All rights
            reserved.
          </p>
          <div style={{ display: "flex", gap: 24 }}>
            <a>Privacy Policy</a>
            <a>Terms of Service</a>
          </div>
        </div>
      </footer>

      {regOpen && (
        <RegisterModal
          onClose={() => {
            setRegOpen(false);
            fetchHospitals();
          }}
        />
      )}
    </div>
  );
}
